
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5e08"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5e08"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("771aI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hsQoX"));

});
parcelRegister("hsQoX", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $cb6db30d633f1e4d$export$ffb0004e005737fa; }, function (v) { return $cb6db30d633f1e4d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $cb6db30d633f1e4d$export$34b9dba7ce09269b; }, function (v) { return $cb6db30d633f1e4d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $cb6db30d633f1e4d$export$25062201e9e25d76; }, function (v) { return $cb6db30d633f1e4d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cb6db30d633f1e4d$export$ffb0004e005737fa;
var $cb6db30d633f1e4d$export$34b9dba7ce09269b;
var $cb6db30d633f1e4d$export$25062201e9e25d76;
"use strict";
var $cb6db30d633f1e4d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $cb6db30d633f1e4d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $cb6db30d633f1e4d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $cb6db30d633f1e4d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$cb6db30d633f1e4d$export$ffb0004e005737fa = $cb6db30d633f1e4d$var$REACT_FRAGMENT_TYPE;
$cb6db30d633f1e4d$export$34b9dba7ce09269b = $cb6db30d633f1e4d$var$jsxProd;
$cb6db30d633f1e4d$export$25062201e9e25d76 = $cb6db30d633f1e4d$var$jsxProd;

});


parcelRegister("d1Z4Y", function(module, exports) {
'use strict';

module.exports = (parcelRequire("24QKf"));

});
parcelRegister("24QKf", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $1834de864d88f964$export$9c16c1426311996d; }, function (v) { return $1834de864d88f964$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $1834de864d88f964$export$dca3b0875bd9a954; }, function (v) { return $1834de864d88f964$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $1834de864d88f964$export$16fa2f45be04daa8; }, function (v) { return $1834de864d88f964$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1834de864d88f964$export$ffb0004e005737fa; }, function (v) { return $1834de864d88f964$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $1834de864d88f964$export$e2c29f18771995cb; }, function (v) { return $1834de864d88f964$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $1834de864d88f964$export$221d75b3f55bb0bd; }, function (v) { return $1834de864d88f964$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1834de864d88f964$export$5f8d39834fd61797; }, function (v) { return $1834de864d88f964$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1834de864d88f964$export$74bf444e3cd11ea5; }, function (v) { return $1834de864d88f964$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $1834de864d88f964$export$1ced07cd6b1985ce; }, function (v) { return $1834de864d88f964$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $1834de864d88f964$export$abd8e32b826d7ea7; }, function (v) { return $1834de864d88f964$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $1834de864d88f964$export$69a3209f1a06c04d; }, function (v) { return $1834de864d88f964$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $1834de864d88f964$export$8c538325882c7eec; }, function (v) { return $1834de864d88f964$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $1834de864d88f964$export$e530037191fcd5d7; }, function (v) { return $1834de864d88f964$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $1834de864d88f964$export$fd42f52fd3ae1109; }, function (v) { return $1834de864d88f964$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $1834de864d88f964$export$c8a8987d4410bf2d; }, function (v) { return $1834de864d88f964$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $1834de864d88f964$export$7d1e3a5e95ceca43; }, function (v) { return $1834de864d88f964$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $1834de864d88f964$export$257a8862b851cb5b; }, function (v) { return $1834de864d88f964$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $1834de864d88f964$export$a8257692ac88316c; }, function (v) { return $1834de864d88f964$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $1834de864d88f964$export$488013bae63b21da; }, function (v) { return $1834de864d88f964$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $1834de864d88f964$export$7c73462e0d25e514; }, function (v) { return $1834de864d88f964$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $1834de864d88f964$export$7568632d0d33d16d; }, function (v) { return $1834de864d88f964$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $1834de864d88f964$export$f93f40ac0ca7e3a8; }, function (v) { return $1834de864d88f964$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $1834de864d88f964$export$1f96ae73734a86cc; }, function (v) { return $1834de864d88f964$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $1834de864d88f964$export$9a47ced3238df325; }, function (v) { return $1834de864d88f964$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $1834de864d88f964$export$35808ee640e87ca7; }, function (v) { return $1834de864d88f964$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $1834de864d88f964$export$fae74005e78b1a27; }, function (v) { return $1834de864d88f964$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $1834de864d88f964$export$dc8fbce3eb94dc1e; }, function (v) { return $1834de864d88f964$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $1834de864d88f964$export$6a7bc4e911dc01cf; }, function (v) { return $1834de864d88f964$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $1834de864d88f964$export$6d9c69b0de29b591; }, function (v) { return $1834de864d88f964$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $1834de864d88f964$export$7f54fc3180508a52; }, function (v) { return $1834de864d88f964$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $1834de864d88f964$export$f680877a34711e37; }, function (v) { return $1834de864d88f964$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $1834de864d88f964$export$d5a552a76deda3c2; }, function (v) { return $1834de864d88f964$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $1834de864d88f964$export$aaabe4eda9ed9969; }, function (v) { return $1834de864d88f964$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $1834de864d88f964$export$e5c5a5f917a5871c; }, function (v) { return $1834de864d88f964$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $1834de864d88f964$export$1538c33de8887b59; }, function (v) { return $1834de864d88f964$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $1834de864d88f964$export$fca7f784ae7a249a; }, function (v) { return $1834de864d88f964$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $1834de864d88f964$export$13e3392192263954; }, function (v) { return $1834de864d88f964$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $1834de864d88f964$export$b8f5890fc79d6aca; }, function (v) { return $1834de864d88f964$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $1834de864d88f964$export$60241385465d0a34; }, function (v) { return $1834de864d88f964$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $1834de864d88f964$export$306c0aa65ff9ec16; }, function (v) { return $1834de864d88f964$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $1834de864d88f964$export$7b286972b8d8ccbf; }, function (v) { return $1834de864d88f964$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $1834de864d88f964$export$83d89fbfd8236492; }, function (v) { return $1834de864d88f964$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1834de864d88f964$export$9c16c1426311996d;
var $1834de864d88f964$export$dca3b0875bd9a954;
var $1834de864d88f964$export$16fa2f45be04daa8;
var $1834de864d88f964$export$ffb0004e005737fa;
var $1834de864d88f964$export$e2c29f18771995cb;
var $1834de864d88f964$export$221d75b3f55bb0bd;
var $1834de864d88f964$export$5f8d39834fd61797;
var $1834de864d88f964$export$74bf444e3cd11ea5;
var $1834de864d88f964$export$1ced07cd6b1985ce;
var $1834de864d88f964$export$abd8e32b826d7ea7;
var $1834de864d88f964$export$69a3209f1a06c04d;
var $1834de864d88f964$export$8c538325882c7eec;
var $1834de864d88f964$export$e530037191fcd5d7;
var $1834de864d88f964$export$fd42f52fd3ae1109;
var $1834de864d88f964$export$c8a8987d4410bf2d;
var $1834de864d88f964$export$7d1e3a5e95ceca43;
var $1834de864d88f964$export$257a8862b851cb5b;
var $1834de864d88f964$export$a8257692ac88316c;
var $1834de864d88f964$export$488013bae63b21da;
var $1834de864d88f964$export$7c73462e0d25e514;
var $1834de864d88f964$export$7568632d0d33d16d;
var $1834de864d88f964$export$f93f40ac0ca7e3a8;
var $1834de864d88f964$export$1f96ae73734a86cc;
var $1834de864d88f964$export$9a47ced3238df325;
var $1834de864d88f964$export$35808ee640e87ca7;
var $1834de864d88f964$export$fae74005e78b1a27;
var $1834de864d88f964$export$dc8fbce3eb94dc1e;
var $1834de864d88f964$export$6a7bc4e911dc01cf;
var $1834de864d88f964$export$6d9c69b0de29b591;
var $1834de864d88f964$export$7f54fc3180508a52;
var $1834de864d88f964$export$f680877a34711e37;
var $1834de864d88f964$export$d5a552a76deda3c2;
var $1834de864d88f964$export$aaabe4eda9ed9969;
var $1834de864d88f964$export$e5c5a5f917a5871c;
var $1834de864d88f964$export$1538c33de8887b59;
var $1834de864d88f964$export$fca7f784ae7a249a;
var $1834de864d88f964$export$13e3392192263954;
var $1834de864d88f964$export$b8f5890fc79d6aca;
var $1834de864d88f964$export$60241385465d0a34;
var $1834de864d88f964$export$306c0aa65ff9ec16;
var $1834de864d88f964$export$7b286972b8d8ccbf;
var $1834de864d88f964$export$83d89fbfd8236492;
"use strict";
var $1834de864d88f964$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1834de864d88f964$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $1834de864d88f964$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $1834de864d88f964$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $1834de864d88f964$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $1834de864d88f964$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $1834de864d88f964$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $1834de864d88f964$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $1834de864d88f964$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $1834de864d88f964$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $1834de864d88f964$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $1834de864d88f964$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $1834de864d88f964$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $1834de864d88f964$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $1834de864d88f964$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$1834de864d88f964$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $1834de864d88f964$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1834de864d88f964$var$assign = Object.assign, $1834de864d88f964$var$emptyObject = {};
function $1834de864d88f964$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $1834de864d88f964$var$emptyObject;
    this.updater = updater || $1834de864d88f964$var$ReactNoopUpdateQueue;
}
$1834de864d88f964$var$Component.prototype.isReactComponent = {};
$1834de864d88f964$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$1834de864d88f964$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $1834de864d88f964$var$ComponentDummy() {}
$1834de864d88f964$var$ComponentDummy.prototype = $1834de864d88f964$var$Component.prototype;
function $1834de864d88f964$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $1834de864d88f964$var$emptyObject;
    this.updater = updater || $1834de864d88f964$var$ReactNoopUpdateQueue;
}
var $1834de864d88f964$var$pureComponentPrototype = $1834de864d88f964$var$PureComponent.prototype = new $1834de864d88f964$var$ComponentDummy();
$1834de864d88f964$var$pureComponentPrototype.constructor = $1834de864d88f964$var$PureComponent;
$1834de864d88f964$var$assign($1834de864d88f964$var$pureComponentPrototype, $1834de864d88f964$var$Component.prototype);
$1834de864d88f964$var$pureComponentPrototype.isPureReactComponent = !0;
var $1834de864d88f964$var$isArrayImpl = Array.isArray;
function $1834de864d88f964$var$noop() {}
var $1834de864d88f964$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $1834de864d88f964$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $1834de864d88f964$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $1834de864d88f964$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $1834de864d88f964$var$cloneAndReplaceKey(oldElement, newKey) {
    return $1834de864d88f964$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $1834de864d88f964$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $1834de864d88f964$var$REACT_ELEMENT_TYPE;
}
function $1834de864d88f964$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $1834de864d88f964$var$userProvidedKeyEscapeRegex = /\/+/g;
function $1834de864d88f964$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $1834de864d88f964$var$escape("" + element.key) : index.toString(36);
}
function $1834de864d88f964$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($1834de864d88f964$var$noop, $1834de864d88f964$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $1834de864d88f964$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $1834de864d88f964$var$REACT_ELEMENT_TYPE:
                case $1834de864d88f964$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $1834de864d88f964$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $1834de864d88f964$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $1834de864d88f964$var$getElementKey(children, 0) : nameSoFar, $1834de864d88f964$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($1834de864d88f964$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $1834de864d88f964$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($1834de864d88f964$var$isValidElement(callback) && (callback = $1834de864d88f964$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($1834de864d88f964$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($1834de864d88f964$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $1834de864d88f964$var$getElementKey(nameSoFar, i), invokeCallback += $1834de864d88f964$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $1834de864d88f964$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $1834de864d88f964$var$getElementKey(nameSoFar, i++), invokeCallback += $1834de864d88f964$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $1834de864d88f964$var$mapIntoArray($1834de864d88f964$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $1834de864d88f964$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $1834de864d88f964$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $1834de864d88f964$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $1834de864d88f964$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $1834de864d88f964$var$Children = {
    map: $1834de864d88f964$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $1834de864d88f964$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $1834de864d88f964$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $1834de864d88f964$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$1834de864d88f964$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$1834de864d88f964$export$9c16c1426311996d = $1834de864d88f964$var$REACT_ACTIVITY_TYPE;
$1834de864d88f964$export$dca3b0875bd9a954 = $1834de864d88f964$var$Children;
$1834de864d88f964$export$16fa2f45be04daa8 = $1834de864d88f964$var$Component;
$1834de864d88f964$export$ffb0004e005737fa = $1834de864d88f964$var$REACT_FRAGMENT_TYPE;
$1834de864d88f964$export$e2c29f18771995cb = $1834de864d88f964$var$REACT_PROFILER_TYPE;
$1834de864d88f964$export$221d75b3f55bb0bd = $1834de864d88f964$var$PureComponent;
$1834de864d88f964$export$5f8d39834fd61797 = $1834de864d88f964$var$REACT_STRICT_MODE_TYPE;
$1834de864d88f964$export$74bf444e3cd11ea5 = $1834de864d88f964$var$REACT_SUSPENSE_TYPE;
$1834de864d88f964$export$1ced07cd6b1985ce = $1834de864d88f964$var$ReactSharedInternals;
$1834de864d88f964$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $1834de864d88f964$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$1834de864d88f964$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$1834de864d88f964$export$8c538325882c7eec = function() {
    return null;
};
$1834de864d88f964$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $1834de864d88f964$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$1834de864d88f964$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $1834de864d88f964$var$ReactElement(element.type, key, props);
};
$1834de864d88f964$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $1834de864d88f964$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $1834de864d88f964$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$1834de864d88f964$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$1834de864d88f964$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $1834de864d88f964$var$ReactElement(type, key, props);
};
$1834de864d88f964$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1834de864d88f964$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $1834de864d88f964$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$1834de864d88f964$export$a8257692ac88316c = $1834de864d88f964$var$isValidElement;
$1834de864d88f964$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $1834de864d88f964$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $1834de864d88f964$var$lazyInitializer
    };
};
$1834de864d88f964$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $1834de864d88f964$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$1834de864d88f964$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $1834de864d88f964$var$ReactSharedInternals.T, currentTransition = {};
    $1834de864d88f964$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $1834de864d88f964$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($1834de864d88f964$var$noop, $1834de864d88f964$var$reportGlobalError);
    } catch (error) {
        $1834de864d88f964$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $1834de864d88f964$var$ReactSharedInternals.T = prevTransition;
    }
};
$1834de864d88f964$export$f93f40ac0ca7e3a8 = function() {
    return $1834de864d88f964$var$ReactSharedInternals.H.useCacheRefresh();
};
$1834de864d88f964$export$1f96ae73734a86cc = function(usable) {
    return $1834de864d88f964$var$ReactSharedInternals.H.use(usable);
};
$1834de864d88f964$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$1834de864d88f964$export$35808ee640e87ca7 = function(callback, deps) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$1834de864d88f964$export$fae74005e78b1a27 = function(Context) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useContext(Context);
};
$1834de864d88f964$export$dc8fbce3eb94dc1e = function() {};
$1834de864d88f964$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$1834de864d88f964$export$6d9c69b0de29b591 = function(create, deps) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useEffect(create, deps);
};
$1834de864d88f964$export$7f54fc3180508a52 = function(callback) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$1834de864d88f964$export$f680877a34711e37 = function() {
    return $1834de864d88f964$var$ReactSharedInternals.H.useId();
};
$1834de864d88f964$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$1834de864d88f964$export$aaabe4eda9ed9969 = function(create, deps) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$1834de864d88f964$export$e5c5a5f917a5871c = function(create, deps) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$1834de864d88f964$export$1538c33de8887b59 = function(create, deps) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useMemo(create, deps);
};
$1834de864d88f964$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$1834de864d88f964$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$1834de864d88f964$export$b8f5890fc79d6aca = function(initialValue) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useRef(initialValue);
};
$1834de864d88f964$export$60241385465d0a34 = function(initialState) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useState(initialState);
};
$1834de864d88f964$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $1834de864d88f964$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$1834de864d88f964$export$7b286972b8d8ccbf = function() {
    return $1834de864d88f964$var$ReactSharedInternals.H.useTransition();
};
$1834de864d88f964$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("03qsr", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $00a4cde6c819110e$export$882461b6382ed46c; }, function (v) { return $00a4cde6c819110e$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $00a4cde6c819110e$export$757ceba2d55c277e; }, function (v) { return $00a4cde6c819110e$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $00a4cde6c819110e$export$83d89fbfd8236492; }, function (v) { return $00a4cde6c819110e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $00a4cde6c819110e$export$882461b6382ed46c;
var $00a4cde6c819110e$export$757ceba2d55c277e;
var $00a4cde6c819110e$export$83d89fbfd8236492;
"use strict";

var $aczbN = parcelRequire("aczbN");

var $d1Z4Y = parcelRequire("d1Z4Y");

var $d5tj1 = parcelRequire("d5tj1");
function $00a4cde6c819110e$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $00a4cde6c819110e$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $00a4cde6c819110e$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $00a4cde6c819110e$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $00a4cde6c819110e$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $00a4cde6c819110e$var$assertIsMounted(fiber) {
    if ($00a4cde6c819110e$var$getNearestMountedFiber(fiber) !== fiber) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(188));
}
function $00a4cde6c819110e$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $00a4cde6c819110e$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $00a4cde6c819110e$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $00a4cde6c819110e$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($00a4cde6c819110e$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $00a4cde6c819110e$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $00a4cde6c819110e$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $00a4cde6c819110e$var$assign = Object.assign, $00a4cde6c819110e$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $00a4cde6c819110e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $00a4cde6c819110e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $00a4cde6c819110e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $00a4cde6c819110e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $00a4cde6c819110e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $00a4cde6c819110e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $00a4cde6c819110e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $00a4cde6c819110e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $00a4cde6c819110e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $00a4cde6c819110e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $00a4cde6c819110e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $00a4cde6c819110e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $00a4cde6c819110e$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $00a4cde6c819110e$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $00a4cde6c819110e$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $00a4cde6c819110e$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $00a4cde6c819110e$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$00a4cde6c819110e$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $00a4cde6c819110e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $00a4cde6c819110e$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $00a4cde6c819110e$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $00a4cde6c819110e$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $00a4cde6c819110e$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $00a4cde6c819110e$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $00a4cde6c819110e$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $00a4cde6c819110e$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $00a4cde6c819110e$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $00a4cde6c819110e$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $00a4cde6c819110e$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $00a4cde6c819110e$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $00a4cde6c819110e$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $00a4cde6c819110e$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $00a4cde6c819110e$var$getComponentNameFromType(type.type) || "Memo";
        case $00a4cde6c819110e$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $00a4cde6c819110e$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $00a4cde6c819110e$var$isArrayImpl = Array.isArray, $00a4cde6c819110e$var$ReactSharedInternals = $d1Z4Y.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $00a4cde6c819110e$var$ReactDOMSharedInternals = $d5tj1.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $00a4cde6c819110e$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $00a4cde6c819110e$var$valueStack = [], $00a4cde6c819110e$var$index = -1;
function $00a4cde6c819110e$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $00a4cde6c819110e$var$pop(cursor) {
    0 > $00a4cde6c819110e$var$index || (cursor.current = $00a4cde6c819110e$var$valueStack[$00a4cde6c819110e$var$index], $00a4cde6c819110e$var$valueStack[$00a4cde6c819110e$var$index] = null, $00a4cde6c819110e$var$index--);
}
function $00a4cde6c819110e$var$push(cursor, value) {
    $00a4cde6c819110e$var$index++;
    $00a4cde6c819110e$var$valueStack[$00a4cde6c819110e$var$index] = cursor.current;
    cursor.current = value;
}
var $00a4cde6c819110e$var$contextStackCursor = $00a4cde6c819110e$var$createCursor(null), $00a4cde6c819110e$var$contextFiberStackCursor = $00a4cde6c819110e$var$createCursor(null), $00a4cde6c819110e$var$rootInstanceStackCursor = $00a4cde6c819110e$var$createCursor(null), $00a4cde6c819110e$var$hostTransitionProviderCursor = $00a4cde6c819110e$var$createCursor(null);
function $00a4cde6c819110e$var$pushHostContainer(fiber, nextRootInstance) {
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$rootInstanceStackCursor, nextRootInstance);
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$contextFiberStackCursor, fiber);
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $00a4cde6c819110e$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $00a4cde6c819110e$var$getOwnHostContext(nextRootInstance), fiber = $00a4cde6c819110e$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$contextStackCursor);
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$contextStackCursor, fiber);
}
function $00a4cde6c819110e$var$popHostContainer() {
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$contextStackCursor);
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$contextFiberStackCursor);
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$rootInstanceStackCursor);
}
function $00a4cde6c819110e$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $00a4cde6c819110e$var$push($00a4cde6c819110e$var$hostTransitionProviderCursor, fiber);
    var context = $00a4cde6c819110e$var$contextStackCursor.current;
    var JSCompiler_inline_result = $00a4cde6c819110e$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($00a4cde6c819110e$var$push($00a4cde6c819110e$var$contextFiberStackCursor, fiber), $00a4cde6c819110e$var$push($00a4cde6c819110e$var$contextStackCursor, JSCompiler_inline_result));
}
function $00a4cde6c819110e$var$popHostContext(fiber) {
    $00a4cde6c819110e$var$contextFiberStackCursor.current === fiber && ($00a4cde6c819110e$var$pop($00a4cde6c819110e$var$contextStackCursor), $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$contextFiberStackCursor));
    $00a4cde6c819110e$var$hostTransitionProviderCursor.current === fiber && ($00a4cde6c819110e$var$pop($00a4cde6c819110e$var$hostTransitionProviderCursor), $00a4cde6c819110e$var$HostTransitionContext._currentValue = $00a4cde6c819110e$var$sharedNotPendingObject);
}
var $00a4cde6c819110e$var$prefix, $00a4cde6c819110e$var$suffix;
function $00a4cde6c819110e$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $00a4cde6c819110e$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $00a4cde6c819110e$var$prefix = match && match[1] || "";
        $00a4cde6c819110e$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $00a4cde6c819110e$var$prefix + name + $00a4cde6c819110e$var$suffix;
}
var $00a4cde6c819110e$var$reentry = !1;
function $00a4cde6c819110e$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $00a4cde6c819110e$var$reentry) return "";
    $00a4cde6c819110e$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $00a4cde6c819110e$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $00a4cde6c819110e$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $00a4cde6c819110e$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $00a4cde6c819110e$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $00a4cde6c819110e$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $00a4cde6c819110e$var$describeBuiltInComponentFrame("Suspense Fallback") : $00a4cde6c819110e$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $00a4cde6c819110e$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $00a4cde6c819110e$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $00a4cde6c819110e$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $00a4cde6c819110e$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $00a4cde6c819110e$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $00a4cde6c819110e$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $00a4cde6c819110e$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $00a4cde6c819110e$var$hasOwnProperty = Object.prototype.hasOwnProperty, $00a4cde6c819110e$var$scheduleCallback$3 = $aczbN.unstable_scheduleCallback, $00a4cde6c819110e$var$cancelCallback$1 = $aczbN.unstable_cancelCallback, $00a4cde6c819110e$var$shouldYield = $aczbN.unstable_shouldYield, $00a4cde6c819110e$var$requestPaint = $aczbN.unstable_requestPaint, $00a4cde6c819110e$var$now = $aczbN.unstable_now, $00a4cde6c819110e$var$getCurrentPriorityLevel = $aczbN.unstable_getCurrentPriorityLevel, $00a4cde6c819110e$var$ImmediatePriority = $aczbN.unstable_ImmediatePriority, $00a4cde6c819110e$var$UserBlockingPriority = $aczbN.unstable_UserBlockingPriority, $00a4cde6c819110e$var$NormalPriority$1 = $aczbN.unstable_NormalPriority, $00a4cde6c819110e$var$LowPriority = $aczbN.unstable_LowPriority, $00a4cde6c819110e$var$IdlePriority = $aczbN.unstable_IdlePriority, $00a4cde6c819110e$var$log$1 = $aczbN.log, $00a4cde6c819110e$var$unstable_setDisableYieldValue = $aczbN.unstable_setDisableYieldValue, $00a4cde6c819110e$var$rendererID = null, $00a4cde6c819110e$var$injectedHook = null;
function $00a4cde6c819110e$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $00a4cde6c819110e$var$log$1 && $00a4cde6c819110e$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($00a4cde6c819110e$var$injectedHook && "function" === typeof $00a4cde6c819110e$var$injectedHook.setStrictMode) try {
        $00a4cde6c819110e$var$injectedHook.setStrictMode($00a4cde6c819110e$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $00a4cde6c819110e$var$clz32 = Math.clz32 ? Math.clz32 : $00a4cde6c819110e$var$clz32Fallback, $00a4cde6c819110e$var$log = Math.log, $00a4cde6c819110e$var$LN2 = Math.LN2;
function $00a4cde6c819110e$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($00a4cde6c819110e$var$log(x) / $00a4cde6c819110e$var$LN2 | 0) | 0;
}
var $00a4cde6c819110e$var$nextTransitionUpdateLane = 256, $00a4cde6c819110e$var$nextTransitionDeferredLane = 262144, $00a4cde6c819110e$var$nextRetryLane = 4194304;
function $00a4cde6c819110e$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $00a4cde6c819110e$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $00a4cde6c819110e$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $00a4cde6c819110e$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $00a4cde6c819110e$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $00a4cde6c819110e$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $00a4cde6c819110e$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $00a4cde6c819110e$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $00a4cde6c819110e$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $00a4cde6c819110e$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $00a4cde6c819110e$var$claimNextRetryLane() {
    var lane = $00a4cde6c819110e$var$nextRetryLane;
    $00a4cde6c819110e$var$nextRetryLane <<= 1;
    0 === ($00a4cde6c819110e$var$nextRetryLane & 62914560) && ($00a4cde6c819110e$var$nextRetryLane = 4194304);
    return lane;
}
function $00a4cde6c819110e$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $00a4cde6c819110e$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $00a4cde6c819110e$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $00a4cde6c819110e$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $00a4cde6c819110e$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $00a4cde6c819110e$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $00a4cde6c819110e$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $00a4cde6c819110e$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $00a4cde6c819110e$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $00a4cde6c819110e$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $00a4cde6c819110e$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $00a4cde6c819110e$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $00a4cde6c819110e$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $00a4cde6c819110e$var$resolveUpdatePriority() {
    var updatePriority = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $00a4cde6c819110e$var$getEventPriority(updatePriority.type);
}
function $00a4cde6c819110e$var$runWithPriority(priority, fn) {
    var previousPriority = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
    try {
        return $00a4cde6c819110e$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $00a4cde6c819110e$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $00a4cde6c819110e$var$randomKey = Math.random().toString(36).slice(2), $00a4cde6c819110e$var$internalInstanceKey = "__reactFiber$" + $00a4cde6c819110e$var$randomKey, $00a4cde6c819110e$var$internalPropsKey = "__reactProps$" + $00a4cde6c819110e$var$randomKey, $00a4cde6c819110e$var$internalContainerInstanceKey = "__reactContainer$" + $00a4cde6c819110e$var$randomKey, $00a4cde6c819110e$var$internalEventHandlersKey = "__reactEvents$" + $00a4cde6c819110e$var$randomKey, $00a4cde6c819110e$var$internalEventHandlerListenersKey = "__reactListeners$" + $00a4cde6c819110e$var$randomKey, $00a4cde6c819110e$var$internalEventHandlesSetKey = "__reactHandles$" + $00a4cde6c819110e$var$randomKey, $00a4cde6c819110e$var$internalRootNodeResourcesKey = "__reactResources$" + $00a4cde6c819110e$var$randomKey, $00a4cde6c819110e$var$internalHoistableMarker = "__reactMarker$" + $00a4cde6c819110e$var$randomKey;
function $00a4cde6c819110e$var$detachDeletedInstance(node) {
    delete node[$00a4cde6c819110e$var$internalInstanceKey];
    delete node[$00a4cde6c819110e$var$internalPropsKey];
    delete node[$00a4cde6c819110e$var$internalEventHandlersKey];
    delete node[$00a4cde6c819110e$var$internalEventHandlerListenersKey];
    delete node[$00a4cde6c819110e$var$internalEventHandlesSetKey];
}
function $00a4cde6c819110e$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$00a4cde6c819110e$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$00a4cde6c819110e$var$internalContainerInstanceKey] || parentNode[$00a4cde6c819110e$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $00a4cde6c819110e$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$00a4cde6c819110e$var$internalInstanceKey]) return parentNode;
                targetNode = $00a4cde6c819110e$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $00a4cde6c819110e$var$getInstanceFromNode(node) {
    if (node = node[$00a4cde6c819110e$var$internalInstanceKey] || node[$00a4cde6c819110e$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $00a4cde6c819110e$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(33));
}
function $00a4cde6c819110e$var$getResourcesFromRoot(root) {
    var resources = root[$00a4cde6c819110e$var$internalRootNodeResourcesKey];
    resources || (resources = root[$00a4cde6c819110e$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $00a4cde6c819110e$var$markNodeAsHoistable(node) {
    node[$00a4cde6c819110e$var$internalHoistableMarker] = !0;
}
var $00a4cde6c819110e$var$allNativeEvents = new Set(), $00a4cde6c819110e$var$registrationNameDependencies = {};
function $00a4cde6c819110e$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $00a4cde6c819110e$var$registerDirectEvent(registrationName, dependencies);
    $00a4cde6c819110e$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $00a4cde6c819110e$var$registerDirectEvent(registrationName, dependencies) {
    $00a4cde6c819110e$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$00a4cde6c819110e$var$allNativeEvents.add(dependencies[registrationName]);
}
var $00a4cde6c819110e$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $00a4cde6c819110e$var$illegalAttributeNameCache = {}, $00a4cde6c819110e$var$validatedAttributeNameCache = {};
function $00a4cde6c819110e$var$isAttributeNameSafe(attributeName) {
    if ($00a4cde6c819110e$var$hasOwnProperty.call($00a4cde6c819110e$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($00a4cde6c819110e$var$hasOwnProperty.call($00a4cde6c819110e$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($00a4cde6c819110e$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $00a4cde6c819110e$var$validatedAttributeNameCache[attributeName] = !0;
    $00a4cde6c819110e$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $00a4cde6c819110e$var$setValueForAttribute(node, name, value) {
    if ($00a4cde6c819110e$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $00a4cde6c819110e$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $00a4cde6c819110e$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $00a4cde6c819110e$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $00a4cde6c819110e$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $00a4cde6c819110e$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $00a4cde6c819110e$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $00a4cde6c819110e$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $00a4cde6c819110e$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $00a4cde6c819110e$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $00a4cde6c819110e$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $00a4cde6c819110e$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $00a4cde6c819110e$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $00a4cde6c819110e$var$getToStringValue(value);
        } else element.value !== "" + $00a4cde6c819110e$var$getToStringValue(value) && (element.value = "" + $00a4cde6c819110e$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $00a4cde6c819110e$var$setDefaultValue(element, type, $00a4cde6c819110e$var$getToStringValue(value)) : null != defaultValue ? $00a4cde6c819110e$var$setDefaultValue(element, type, $00a4cde6c819110e$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $00a4cde6c819110e$var$getToStringValue(name) : element.removeAttribute("name");
}
function $00a4cde6c819110e$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $00a4cde6c819110e$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $00a4cde6c819110e$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $00a4cde6c819110e$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $00a4cde6c819110e$var$track(element);
}
function $00a4cde6c819110e$var$setDefaultValue(node, type, value) {
    "number" === type && $00a4cde6c819110e$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $00a4cde6c819110e$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $00a4cde6c819110e$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $00a4cde6c819110e$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $00a4cde6c819110e$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $00a4cde6c819110e$var$getToStringValue(defaultValue) : "";
}
function $00a4cde6c819110e$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(92));
            if ($00a4cde6c819110e$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $00a4cde6c819110e$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $00a4cde6c819110e$var$track(element);
}
function $00a4cde6c819110e$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $00a4cde6c819110e$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $00a4cde6c819110e$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $00a4cde6c819110e$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $00a4cde6c819110e$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $00a4cde6c819110e$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $00a4cde6c819110e$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $00a4cde6c819110e$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $00a4cde6c819110e$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $00a4cde6c819110e$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $00a4cde6c819110e$var$sanitizeURL(url) {
    return $00a4cde6c819110e$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $00a4cde6c819110e$var$noop$1() {}
var $00a4cde6c819110e$var$currentReplayingEvent = null;
function $00a4cde6c819110e$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $00a4cde6c819110e$var$restoreTarget = null, $00a4cde6c819110e$var$restoreQueue = null;
function $00a4cde6c819110e$var$restoreStateOfTarget(target) {
    var internalInstance = $00a4cde6c819110e$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$00a4cde6c819110e$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $00a4cde6c819110e$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$00a4cde6c819110e$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(90));
                            $00a4cde6c819110e$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $00a4cde6c819110e$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $00a4cde6c819110e$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $00a4cde6c819110e$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $00a4cde6c819110e$var$isInsideEventHandler = !1;
function $00a4cde6c819110e$var$batchedUpdates$1(fn, a, b) {
    if ($00a4cde6c819110e$var$isInsideEventHandler) return fn(a, b);
    $00a4cde6c819110e$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($00a4cde6c819110e$var$isInsideEventHandler = !1, null !== $00a4cde6c819110e$var$restoreTarget || null !== $00a4cde6c819110e$var$restoreQueue) {
            if ($00a4cde6c819110e$var$flushSyncWork$1(), $00a4cde6c819110e$var$restoreTarget && (a = $00a4cde6c819110e$var$restoreTarget, fn = $00a4cde6c819110e$var$restoreQueue, $00a4cde6c819110e$var$restoreQueue = $00a4cde6c819110e$var$restoreTarget = null, $00a4cde6c819110e$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$00a4cde6c819110e$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $00a4cde6c819110e$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$00a4cde6c819110e$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $00a4cde6c819110e$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $00a4cde6c819110e$var$passiveBrowserEventsSupported = !1;
if ($00a4cde6c819110e$var$canUseDOM) try {
    var $00a4cde6c819110e$var$options = {};
    Object.defineProperty($00a4cde6c819110e$var$options, "passive", {
        get: function() {
            $00a4cde6c819110e$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $00a4cde6c819110e$var$options, $00a4cde6c819110e$var$options);
    window.removeEventListener("test", $00a4cde6c819110e$var$options, $00a4cde6c819110e$var$options);
} catch (e) {
    $00a4cde6c819110e$var$passiveBrowserEventsSupported = !1;
}
var $00a4cde6c819110e$var$root = null, $00a4cde6c819110e$var$startText = null, $00a4cde6c819110e$var$fallbackText = null;
function $00a4cde6c819110e$var$getData() {
    if ($00a4cde6c819110e$var$fallbackText) return $00a4cde6c819110e$var$fallbackText;
    var start, startValue = $00a4cde6c819110e$var$startText, startLength = startValue.length, end, endValue = "value" in $00a4cde6c819110e$var$root ? $00a4cde6c819110e$var$root.value : $00a4cde6c819110e$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $00a4cde6c819110e$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $00a4cde6c819110e$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $00a4cde6c819110e$var$functionThatReturnsTrue() {
    return !0;
}
function $00a4cde6c819110e$var$functionThatReturnsFalse() {
    return !1;
}
function $00a4cde6c819110e$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $00a4cde6c819110e$var$functionThatReturnsTrue : $00a4cde6c819110e$var$functionThatReturnsFalse;
        this.isPropagationStopped = $00a4cde6c819110e$var$functionThatReturnsFalse;
        return this;
    }
    $00a4cde6c819110e$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $00a4cde6c819110e$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $00a4cde6c819110e$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $00a4cde6c819110e$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $00a4cde6c819110e$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $00a4cde6c819110e$var$SyntheticEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$EventInterface), $00a4cde6c819110e$var$UIEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$EventInterface, {
    view: 0,
    detail: 0
}), $00a4cde6c819110e$var$SyntheticUIEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$UIEventInterface), $00a4cde6c819110e$var$lastMovementX, $00a4cde6c819110e$var$lastMovementY, $00a4cde6c819110e$var$lastMouseEvent, $00a4cde6c819110e$var$MouseEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $00a4cde6c819110e$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $00a4cde6c819110e$var$lastMouseEvent && ($00a4cde6c819110e$var$lastMouseEvent && "mousemove" === event.type ? ($00a4cde6c819110e$var$lastMovementX = event.screenX - $00a4cde6c819110e$var$lastMouseEvent.screenX, $00a4cde6c819110e$var$lastMovementY = event.screenY - $00a4cde6c819110e$var$lastMouseEvent.screenY) : $00a4cde6c819110e$var$lastMovementY = $00a4cde6c819110e$var$lastMovementX = 0, $00a4cde6c819110e$var$lastMouseEvent = event);
        return $00a4cde6c819110e$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $00a4cde6c819110e$var$lastMovementY;
    }
}), $00a4cde6c819110e$var$SyntheticMouseEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$MouseEventInterface), $00a4cde6c819110e$var$DragEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$MouseEventInterface, {
    dataTransfer: 0
}), $00a4cde6c819110e$var$SyntheticDragEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$DragEventInterface), $00a4cde6c819110e$var$FocusEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$UIEventInterface, {
    relatedTarget: 0
}), $00a4cde6c819110e$var$SyntheticFocusEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$FocusEventInterface), $00a4cde6c819110e$var$AnimationEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $00a4cde6c819110e$var$SyntheticAnimationEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$AnimationEventInterface), $00a4cde6c819110e$var$ClipboardEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $00a4cde6c819110e$var$SyntheticClipboardEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$ClipboardEventInterface), $00a4cde6c819110e$var$CompositionEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$EventInterface, {
    data: 0
}), $00a4cde6c819110e$var$SyntheticCompositionEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$CompositionEventInterface), $00a4cde6c819110e$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $00a4cde6c819110e$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $00a4cde6c819110e$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $00a4cde6c819110e$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $00a4cde6c819110e$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $00a4cde6c819110e$var$getEventModifierState() {
    return $00a4cde6c819110e$var$modifierStateGetter;
}
var $00a4cde6c819110e$var$KeyboardEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $00a4cde6c819110e$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $00a4cde6c819110e$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $00a4cde6c819110e$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $00a4cde6c819110e$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $00a4cde6c819110e$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $00a4cde6c819110e$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $00a4cde6c819110e$var$SyntheticKeyboardEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$KeyboardEventInterface), $00a4cde6c819110e$var$PointerEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $00a4cde6c819110e$var$SyntheticPointerEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$PointerEventInterface), $00a4cde6c819110e$var$TouchEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $00a4cde6c819110e$var$getEventModifierState
}), $00a4cde6c819110e$var$SyntheticTouchEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$TouchEventInterface), $00a4cde6c819110e$var$TransitionEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $00a4cde6c819110e$var$SyntheticTransitionEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$TransitionEventInterface), $00a4cde6c819110e$var$WheelEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $00a4cde6c819110e$var$SyntheticWheelEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$WheelEventInterface), $00a4cde6c819110e$var$ToggleEventInterface = $00a4cde6c819110e$var$assign({}, $00a4cde6c819110e$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $00a4cde6c819110e$var$SyntheticToggleEvent = $00a4cde6c819110e$var$createSyntheticEvent($00a4cde6c819110e$var$ToggleEventInterface), $00a4cde6c819110e$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $00a4cde6c819110e$var$canUseCompositionEvent = $00a4cde6c819110e$var$canUseDOM && "CompositionEvent" in window, $00a4cde6c819110e$var$documentMode = null;
$00a4cde6c819110e$var$canUseDOM && "documentMode" in document && ($00a4cde6c819110e$var$documentMode = document.documentMode);
var $00a4cde6c819110e$var$canUseTextInputEvent = $00a4cde6c819110e$var$canUseDOM && "TextEvent" in window && !$00a4cde6c819110e$var$documentMode, $00a4cde6c819110e$var$useFallbackCompositionData = $00a4cde6c819110e$var$canUseDOM && (!$00a4cde6c819110e$var$canUseCompositionEvent || $00a4cde6c819110e$var$documentMode && 8 < $00a4cde6c819110e$var$documentMode && 11 >= $00a4cde6c819110e$var$documentMode), $00a4cde6c819110e$var$SPACEBAR_CHAR = String.fromCharCode(32), $00a4cde6c819110e$var$hasSpaceKeypress = !1;
function $00a4cde6c819110e$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $00a4cde6c819110e$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $00a4cde6c819110e$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $00a4cde6c819110e$var$isComposing = !1;
function $00a4cde6c819110e$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $00a4cde6c819110e$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $00a4cde6c819110e$var$hasSpaceKeypress = !0;
            return $00a4cde6c819110e$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $00a4cde6c819110e$var$SPACEBAR_CHAR && $00a4cde6c819110e$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $00a4cde6c819110e$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($00a4cde6c819110e$var$isComposing) return "compositionend" === domEventName || !$00a4cde6c819110e$var$canUseCompositionEvent && $00a4cde6c819110e$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $00a4cde6c819110e$var$getData(), $00a4cde6c819110e$var$fallbackText = $00a4cde6c819110e$var$startText = $00a4cde6c819110e$var$root = null, $00a4cde6c819110e$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $00a4cde6c819110e$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $00a4cde6c819110e$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $00a4cde6c819110e$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$00a4cde6c819110e$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $00a4cde6c819110e$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $00a4cde6c819110e$var$restoreTarget ? $00a4cde6c819110e$var$restoreQueue ? $00a4cde6c819110e$var$restoreQueue.push(target) : $00a4cde6c819110e$var$restoreQueue = [
        target
    ] : $00a4cde6c819110e$var$restoreTarget = target;
    inst = $00a4cde6c819110e$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $00a4cde6c819110e$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $00a4cde6c819110e$var$activeElement$1 = null, $00a4cde6c819110e$var$activeElementInst$1 = null;
function $00a4cde6c819110e$var$runEventInBatch(dispatchQueue) {
    $00a4cde6c819110e$var$processDispatchQueue(dispatchQueue, 0);
}
function $00a4cde6c819110e$var$getInstIfValueChanged(targetInst) {
    var targetNode = $00a4cde6c819110e$var$getNodeFromInstance(targetInst);
    if ($00a4cde6c819110e$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $00a4cde6c819110e$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $00a4cde6c819110e$var$isInputEventSupported = !1;
if ($00a4cde6c819110e$var$canUseDOM) {
    var $00a4cde6c819110e$var$JSCompiler_inline_result$jscomp$286;
    if ($00a4cde6c819110e$var$canUseDOM) {
        var $00a4cde6c819110e$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$00a4cde6c819110e$var$isSupported$jscomp$inline_427) {
            var $00a4cde6c819110e$var$element$jscomp$inline_428 = document.createElement("div");
            $00a4cde6c819110e$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $00a4cde6c819110e$var$isSupported$jscomp$inline_427 = "function" === typeof $00a4cde6c819110e$var$element$jscomp$inline_428.oninput;
        }
        $00a4cde6c819110e$var$JSCompiler_inline_result$jscomp$286 = $00a4cde6c819110e$var$isSupported$jscomp$inline_427;
    } else $00a4cde6c819110e$var$JSCompiler_inline_result$jscomp$286 = !1;
    $00a4cde6c819110e$var$isInputEventSupported = $00a4cde6c819110e$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $00a4cde6c819110e$var$stopWatchingForValueChange() {
    $00a4cde6c819110e$var$activeElement$1 && ($00a4cde6c819110e$var$activeElement$1.detachEvent("onpropertychange", $00a4cde6c819110e$var$handlePropertyChange), $00a4cde6c819110e$var$activeElementInst$1 = $00a4cde6c819110e$var$activeElement$1 = null);
}
function $00a4cde6c819110e$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $00a4cde6c819110e$var$getInstIfValueChanged($00a4cde6c819110e$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $00a4cde6c819110e$var$createAndAccumulateChangeEvent(dispatchQueue, $00a4cde6c819110e$var$activeElementInst$1, nativeEvent, $00a4cde6c819110e$var$getEventTarget(nativeEvent));
        $00a4cde6c819110e$var$batchedUpdates$1($00a4cde6c819110e$var$runEventInBatch, dispatchQueue);
    }
}
function $00a4cde6c819110e$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($00a4cde6c819110e$var$stopWatchingForValueChange(), $00a4cde6c819110e$var$activeElement$1 = target, $00a4cde6c819110e$var$activeElementInst$1 = targetInst, $00a4cde6c819110e$var$activeElement$1.attachEvent("onpropertychange", $00a4cde6c819110e$var$handlePropertyChange)) : "focusout" === domEventName && $00a4cde6c819110e$var$stopWatchingForValueChange();
}
function $00a4cde6c819110e$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $00a4cde6c819110e$var$getInstIfValueChanged($00a4cde6c819110e$var$activeElementInst$1);
}
function $00a4cde6c819110e$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $00a4cde6c819110e$var$getInstIfValueChanged(targetInst);
}
function $00a4cde6c819110e$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $00a4cde6c819110e$var$getInstIfValueChanged(targetInst);
}
function $00a4cde6c819110e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $00a4cde6c819110e$var$objectIs = "function" === typeof Object.is ? Object.is : $00a4cde6c819110e$var$is;
function $00a4cde6c819110e$var$shallowEqual(objA, objB) {
    if ($00a4cde6c819110e$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$00a4cde6c819110e$var$hasOwnProperty.call(objB, currentKey) || !$00a4cde6c819110e$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $00a4cde6c819110e$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $00a4cde6c819110e$var$getNodeForCharacterOffset(root, offset) {
    var node = $00a4cde6c819110e$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $00a4cde6c819110e$var$getLeafNode(node);
    }
}
function $00a4cde6c819110e$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $00a4cde6c819110e$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $00a4cde6c819110e$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $00a4cde6c819110e$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $00a4cde6c819110e$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $00a4cde6c819110e$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $00a4cde6c819110e$var$skipSelectionChangeEvent = $00a4cde6c819110e$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $00a4cde6c819110e$var$activeElement = null, $00a4cde6c819110e$var$activeElementInst = null, $00a4cde6c819110e$var$lastSelection = null, $00a4cde6c819110e$var$mouseDown = !1;
function $00a4cde6c819110e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $00a4cde6c819110e$var$mouseDown || null == $00a4cde6c819110e$var$activeElement || $00a4cde6c819110e$var$activeElement !== $00a4cde6c819110e$var$getActiveElement(doc) || (doc = $00a4cde6c819110e$var$activeElement, "selectionStart" in doc && $00a4cde6c819110e$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $00a4cde6c819110e$var$lastSelection && $00a4cde6c819110e$var$shallowEqual($00a4cde6c819110e$var$lastSelection, doc) || ($00a4cde6c819110e$var$lastSelection = doc, doc = $00a4cde6c819110e$var$accumulateTwoPhaseListeners($00a4cde6c819110e$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $00a4cde6c819110e$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $00a4cde6c819110e$var$activeElement)));
}
function $00a4cde6c819110e$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $00a4cde6c819110e$var$vendorPrefixes = {
    animationend: $00a4cde6c819110e$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $00a4cde6c819110e$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $00a4cde6c819110e$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $00a4cde6c819110e$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $00a4cde6c819110e$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $00a4cde6c819110e$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $00a4cde6c819110e$var$makePrefixMap("Transition", "TransitionEnd")
}, $00a4cde6c819110e$var$prefixedEventNames = {}, $00a4cde6c819110e$var$style = {};
$00a4cde6c819110e$var$canUseDOM && ($00a4cde6c819110e$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $00a4cde6c819110e$var$vendorPrefixes.animationend.animation, delete $00a4cde6c819110e$var$vendorPrefixes.animationiteration.animation, delete $00a4cde6c819110e$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $00a4cde6c819110e$var$vendorPrefixes.transitionend.transition);
function $00a4cde6c819110e$var$getVendorPrefixedEventName(eventName) {
    if ($00a4cde6c819110e$var$prefixedEventNames[eventName]) return $00a4cde6c819110e$var$prefixedEventNames[eventName];
    if (!$00a4cde6c819110e$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $00a4cde6c819110e$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $00a4cde6c819110e$var$style) return $00a4cde6c819110e$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $00a4cde6c819110e$var$ANIMATION_END = $00a4cde6c819110e$var$getVendorPrefixedEventName("animationend"), $00a4cde6c819110e$var$ANIMATION_ITERATION = $00a4cde6c819110e$var$getVendorPrefixedEventName("animationiteration"), $00a4cde6c819110e$var$ANIMATION_START = $00a4cde6c819110e$var$getVendorPrefixedEventName("animationstart"), $00a4cde6c819110e$var$TRANSITION_RUN = $00a4cde6c819110e$var$getVendorPrefixedEventName("transitionrun"), $00a4cde6c819110e$var$TRANSITION_START = $00a4cde6c819110e$var$getVendorPrefixedEventName("transitionstart"), $00a4cde6c819110e$var$TRANSITION_CANCEL = $00a4cde6c819110e$var$getVendorPrefixedEventName("transitioncancel"), $00a4cde6c819110e$var$TRANSITION_END = $00a4cde6c819110e$var$getVendorPrefixedEventName("transitionend"), $00a4cde6c819110e$var$topLevelEventsToReactNames = new Map(), $00a4cde6c819110e$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$00a4cde6c819110e$var$simpleEventPluginEvents.push("scrollEnd");
function $00a4cde6c819110e$var$registerSimpleEvent(domEventName, reactName) {
    $00a4cde6c819110e$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $00a4cde6c819110e$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $00a4cde6c819110e$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $00a4cde6c819110e$var$concurrentQueues = [], $00a4cde6c819110e$var$concurrentQueuesIndex = 0, $00a4cde6c819110e$var$concurrentlyUpdatedLanes = 0;
function $00a4cde6c819110e$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $00a4cde6c819110e$var$concurrentQueuesIndex, i = $00a4cde6c819110e$var$concurrentlyUpdatedLanes = $00a4cde6c819110e$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $00a4cde6c819110e$var$concurrentQueues[i];
        $00a4cde6c819110e$var$concurrentQueues[i++] = null;
        var queue = $00a4cde6c819110e$var$concurrentQueues[i];
        $00a4cde6c819110e$var$concurrentQueues[i++] = null;
        var update = $00a4cde6c819110e$var$concurrentQueues[i];
        $00a4cde6c819110e$var$concurrentQueues[i++] = null;
        var lane = $00a4cde6c819110e$var$concurrentQueues[i];
        $00a4cde6c819110e$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $00a4cde6c819110e$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $00a4cde6c819110e$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $00a4cde6c819110e$var$concurrentQueues[$00a4cde6c819110e$var$concurrentQueuesIndex++] = fiber;
    $00a4cde6c819110e$var$concurrentQueues[$00a4cde6c819110e$var$concurrentQueuesIndex++] = queue;
    $00a4cde6c819110e$var$concurrentQueues[$00a4cde6c819110e$var$concurrentQueuesIndex++] = update;
    $00a4cde6c819110e$var$concurrentQueues[$00a4cde6c819110e$var$concurrentQueuesIndex++] = lane;
    $00a4cde6c819110e$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $00a4cde6c819110e$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $00a4cde6c819110e$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $00a4cde6c819110e$var$getRootForUpdatedFiber(fiber);
}
function $00a4cde6c819110e$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $00a4cde6c819110e$var$enqueueUpdate$1(fiber, null, null, lane);
    return $00a4cde6c819110e$var$getRootForUpdatedFiber(fiber);
}
function $00a4cde6c819110e$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $00a4cde6c819110e$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $00a4cde6c819110e$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $00a4cde6c819110e$var$nestedUpdateCount) throw $00a4cde6c819110e$var$nestedUpdateCount = 0, $00a4cde6c819110e$var$rootWithNestedUpdates = null, Error($00a4cde6c819110e$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $00a4cde6c819110e$var$emptyContextObject = {};
function $00a4cde6c819110e$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $00a4cde6c819110e$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $00a4cde6c819110e$var$FiberNode(tag, pendingProps, key, mode);
}
function $00a4cde6c819110e$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $00a4cde6c819110e$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $00a4cde6c819110e$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $00a4cde6c819110e$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $00a4cde6c819110e$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $00a4cde6c819110e$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $00a4cde6c819110e$var$isHostHoistableType(type, pendingProps, $00a4cde6c819110e$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $00a4cde6c819110e$var$REACT_ACTIVITY_TYPE:
            return type = $00a4cde6c819110e$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $00a4cde6c819110e$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $00a4cde6c819110e$var$REACT_FRAGMENT_TYPE:
            return $00a4cde6c819110e$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $00a4cde6c819110e$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $00a4cde6c819110e$var$REACT_PROFILER_TYPE:
            return type = $00a4cde6c819110e$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $00a4cde6c819110e$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $00a4cde6c819110e$var$REACT_SUSPENSE_TYPE:
            return type = $00a4cde6c819110e$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $00a4cde6c819110e$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $00a4cde6c819110e$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $00a4cde6c819110e$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $00a4cde6c819110e$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $00a4cde6c819110e$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $00a4cde6c819110e$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $00a4cde6c819110e$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $00a4cde6c819110e$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $00a4cde6c819110e$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($00a4cde6c819110e$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $00a4cde6c819110e$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $00a4cde6c819110e$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $00a4cde6c819110e$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $00a4cde6c819110e$var$createFiberFromText(content, mode, lanes) {
    content = $00a4cde6c819110e$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $00a4cde6c819110e$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $00a4cde6c819110e$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $00a4cde6c819110e$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $00a4cde6c819110e$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $00a4cde6c819110e$var$CapturedStacks = new WeakMap();
function $00a4cde6c819110e$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $00a4cde6c819110e$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $00a4cde6c819110e$var$getStackByFiberInDevAndProd(source)
        };
        $00a4cde6c819110e$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $00a4cde6c819110e$var$getStackByFiberInDevAndProd(source)
    };
}
var $00a4cde6c819110e$var$forkStack = [], $00a4cde6c819110e$var$forkStackIndex = 0, $00a4cde6c819110e$var$treeForkProvider = null, $00a4cde6c819110e$var$treeForkCount = 0, $00a4cde6c819110e$var$idStack = [], $00a4cde6c819110e$var$idStackIndex = 0, $00a4cde6c819110e$var$treeContextProvider = null, $00a4cde6c819110e$var$treeContextId = 1, $00a4cde6c819110e$var$treeContextOverflow = "";
function $00a4cde6c819110e$var$pushTreeFork(workInProgress, totalChildren) {
    $00a4cde6c819110e$var$forkStack[$00a4cde6c819110e$var$forkStackIndex++] = $00a4cde6c819110e$var$treeForkCount;
    $00a4cde6c819110e$var$forkStack[$00a4cde6c819110e$var$forkStackIndex++] = $00a4cde6c819110e$var$treeForkProvider;
    $00a4cde6c819110e$var$treeForkProvider = workInProgress;
    $00a4cde6c819110e$var$treeForkCount = totalChildren;
}
function $00a4cde6c819110e$var$pushTreeId(workInProgress, totalChildren, index) {
    $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex++] = $00a4cde6c819110e$var$treeContextId;
    $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex++] = $00a4cde6c819110e$var$treeContextOverflow;
    $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex++] = $00a4cde6c819110e$var$treeContextProvider;
    $00a4cde6c819110e$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $00a4cde6c819110e$var$treeContextId;
    workInProgress = $00a4cde6c819110e$var$treeContextOverflow;
    var baseLength = 32 - $00a4cde6c819110e$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $00a4cde6c819110e$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $00a4cde6c819110e$var$treeContextId = 1 << 32 - $00a4cde6c819110e$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $00a4cde6c819110e$var$treeContextOverflow = length + workInProgress;
    } else $00a4cde6c819110e$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $00a4cde6c819110e$var$treeContextOverflow = workInProgress;
}
function $00a4cde6c819110e$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($00a4cde6c819110e$var$pushTreeFork(workInProgress, 1), $00a4cde6c819110e$var$pushTreeId(workInProgress, 1, 0));
}
function $00a4cde6c819110e$var$popTreeContext(workInProgress) {
    for(; workInProgress === $00a4cde6c819110e$var$treeForkProvider;)$00a4cde6c819110e$var$treeForkProvider = $00a4cde6c819110e$var$forkStack[--$00a4cde6c819110e$var$forkStackIndex], $00a4cde6c819110e$var$forkStack[$00a4cde6c819110e$var$forkStackIndex] = null, $00a4cde6c819110e$var$treeForkCount = $00a4cde6c819110e$var$forkStack[--$00a4cde6c819110e$var$forkStackIndex], $00a4cde6c819110e$var$forkStack[$00a4cde6c819110e$var$forkStackIndex] = null;
    for(; workInProgress === $00a4cde6c819110e$var$treeContextProvider;)$00a4cde6c819110e$var$treeContextProvider = $00a4cde6c819110e$var$idStack[--$00a4cde6c819110e$var$idStackIndex], $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex] = null, $00a4cde6c819110e$var$treeContextOverflow = $00a4cde6c819110e$var$idStack[--$00a4cde6c819110e$var$idStackIndex], $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex] = null, $00a4cde6c819110e$var$treeContextId = $00a4cde6c819110e$var$idStack[--$00a4cde6c819110e$var$idStackIndex], $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex] = null;
}
function $00a4cde6c819110e$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex++] = $00a4cde6c819110e$var$treeContextId;
    $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex++] = $00a4cde6c819110e$var$treeContextOverflow;
    $00a4cde6c819110e$var$idStack[$00a4cde6c819110e$var$idStackIndex++] = $00a4cde6c819110e$var$treeContextProvider;
    $00a4cde6c819110e$var$treeContextId = suspendedContext.id;
    $00a4cde6c819110e$var$treeContextOverflow = suspendedContext.overflow;
    $00a4cde6c819110e$var$treeContextProvider = workInProgress;
}
var $00a4cde6c819110e$var$hydrationParentFiber = null, $00a4cde6c819110e$var$nextHydratableInstance = null, $00a4cde6c819110e$var$isHydrating = !1, $00a4cde6c819110e$var$hydrationErrors = null, $00a4cde6c819110e$var$rootOrSingletonContext = !1, $00a4cde6c819110e$var$HydrationMismatchException = Error($00a4cde6c819110e$var$formatProdErrorMessage(519));
function $00a4cde6c819110e$var$throwOnHydrationMismatch(fiber) {
    var error = Error($00a4cde6c819110e$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $00a4cde6c819110e$var$queueHydrationError($00a4cde6c819110e$var$createCapturedValueAtFiber(error, fiber));
    throw $00a4cde6c819110e$var$HydrationMismatchException;
}
function $00a4cde6c819110e$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$00a4cde6c819110e$var$internalInstanceKey] = fiber;
    instance[$00a4cde6c819110e$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("cancel", instance);
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $00a4cde6c819110e$var$mediaEventTypes.length; type++)$00a4cde6c819110e$var$listenToNonDelegatedEvent($00a4cde6c819110e$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("error", instance);
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("invalid", instance);
            $00a4cde6c819110e$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("invalid", instance), $00a4cde6c819110e$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $00a4cde6c819110e$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($00a4cde6c819110e$var$listenToNonDelegatedEvent("beforetoggle", instance), $00a4cde6c819110e$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $00a4cde6c819110e$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $00a4cde6c819110e$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $00a4cde6c819110e$var$noop$1), instance = !0) : instance = !1;
    instance || $00a4cde6c819110e$var$throwOnHydrationMismatch(fiber, !0);
}
function $00a4cde6c819110e$var$popToNextHostParent(fiber) {
    for($00a4cde6c819110e$var$hydrationParentFiber = fiber.return; $00a4cde6c819110e$var$hydrationParentFiber;)switch($00a4cde6c819110e$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $00a4cde6c819110e$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $00a4cde6c819110e$var$rootOrSingletonContext = !0;
            return;
        default:
            $00a4cde6c819110e$var$hydrationParentFiber = $00a4cde6c819110e$var$hydrationParentFiber.return;
    }
}
function $00a4cde6c819110e$var$popHydrationState(fiber) {
    if (fiber !== $00a4cde6c819110e$var$hydrationParentFiber) return !1;
    if (!$00a4cde6c819110e$var$isHydrating) return $00a4cde6c819110e$var$popToNextHostParent(fiber), $00a4cde6c819110e$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $00a4cde6c819110e$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $00a4cde6c819110e$var$nextHydratableInstance && $00a4cde6c819110e$var$throwOnHydrationMismatch(fiber);
    $00a4cde6c819110e$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(317));
        $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(317));
        $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $00a4cde6c819110e$var$nextHydratableInstance, $00a4cde6c819110e$var$isSingletonScope(fiber.type) ? (fiber = $00a4cde6c819110e$var$previousHydratableOnEnteringScopedSingleton, $00a4cde6c819110e$var$previousHydratableOnEnteringScopedSingleton = null, $00a4cde6c819110e$var$nextHydratableInstance = fiber) : $00a4cde6c819110e$var$nextHydratableInstance = tag) : $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$hydrationParentFiber ? $00a4cde6c819110e$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $00a4cde6c819110e$var$resetHydrationState() {
    $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$hydrationParentFiber = null;
    $00a4cde6c819110e$var$isHydrating = !1;
}
function $00a4cde6c819110e$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $00a4cde6c819110e$var$hydrationErrors;
    null !== queuedErrors && (null === $00a4cde6c819110e$var$workInProgressRootRecoverableErrors ? $00a4cde6c819110e$var$workInProgressRootRecoverableErrors = queuedErrors : $00a4cde6c819110e$var$workInProgressRootRecoverableErrors.push.apply($00a4cde6c819110e$var$workInProgressRootRecoverableErrors, queuedErrors), $00a4cde6c819110e$var$hydrationErrors = null);
    return queuedErrors;
}
function $00a4cde6c819110e$var$queueHydrationError(error) {
    null === $00a4cde6c819110e$var$hydrationErrors ? $00a4cde6c819110e$var$hydrationErrors = [
        error
    ] : $00a4cde6c819110e$var$hydrationErrors.push(error);
}
var $00a4cde6c819110e$var$valueCursor = $00a4cde6c819110e$var$createCursor(null), $00a4cde6c819110e$var$currentlyRenderingFiber$1 = null, $00a4cde6c819110e$var$lastContextDependency = null;
function $00a4cde6c819110e$var$pushProvider(providerFiber, context, nextValue) {
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $00a4cde6c819110e$var$popProvider(context) {
    context._currentValue = $00a4cde6c819110e$var$valueCursor.current;
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$valueCursor);
}
function $00a4cde6c819110e$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $00a4cde6c819110e$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $00a4cde6c819110e$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $00a4cde6c819110e$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $00a4cde6c819110e$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $00a4cde6c819110e$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $00a4cde6c819110e$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($00a4cde6c819110e$var$HostTransitionContext) : current = [
                $00a4cde6c819110e$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $00a4cde6c819110e$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $00a4cde6c819110e$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$00a4cde6c819110e$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $00a4cde6c819110e$var$prepareToReadContext(workInProgress) {
    $00a4cde6c819110e$var$currentlyRenderingFiber$1 = workInProgress;
    $00a4cde6c819110e$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $00a4cde6c819110e$var$readContext(context) {
    return $00a4cde6c819110e$var$readContextForConsumer($00a4cde6c819110e$var$currentlyRenderingFiber$1, context);
}
function $00a4cde6c819110e$var$readContextDuringReconciliation(consumer, context) {
    null === $00a4cde6c819110e$var$currentlyRenderingFiber$1 && $00a4cde6c819110e$var$prepareToReadContext(consumer);
    return $00a4cde6c819110e$var$readContextForConsumer(consumer, context);
}
function $00a4cde6c819110e$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $00a4cde6c819110e$var$lastContextDependency) {
        if (null === consumer) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(308));
        $00a4cde6c819110e$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $00a4cde6c819110e$var$lastContextDependency = $00a4cde6c819110e$var$lastContextDependency.next = context;
    return value;
}
var $00a4cde6c819110e$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $00a4cde6c819110e$var$scheduleCallback$2 = $aczbN.unstable_scheduleCallback, $00a4cde6c819110e$var$NormalPriority = $aczbN.unstable_NormalPriority, $00a4cde6c819110e$var$CacheContext = {
    $$typeof: $00a4cde6c819110e$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $00a4cde6c819110e$var$createCache() {
    return {
        controller: new $00a4cde6c819110e$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $00a4cde6c819110e$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $00a4cde6c819110e$var$scheduleCallback$2($00a4cde6c819110e$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $00a4cde6c819110e$var$currentEntangledListeners = null, $00a4cde6c819110e$var$currentEntangledPendingCount = 0, $00a4cde6c819110e$var$currentEntangledLane = 0, $00a4cde6c819110e$var$currentEntangledActionThenable = null;
function $00a4cde6c819110e$var$entangleAsyncAction(transition, thenable) {
    if (null === $00a4cde6c819110e$var$currentEntangledListeners) {
        var entangledListeners = $00a4cde6c819110e$var$currentEntangledListeners = [];
        $00a4cde6c819110e$var$currentEntangledPendingCount = 0;
        $00a4cde6c819110e$var$currentEntangledLane = $00a4cde6c819110e$var$requestTransitionLane();
        $00a4cde6c819110e$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $00a4cde6c819110e$var$currentEntangledPendingCount++;
    thenable.then($00a4cde6c819110e$var$pingEngtangledActionScope, $00a4cde6c819110e$var$pingEngtangledActionScope);
    return thenable;
}
function $00a4cde6c819110e$var$pingEngtangledActionScope() {
    if (0 === --$00a4cde6c819110e$var$currentEntangledPendingCount && null !== $00a4cde6c819110e$var$currentEntangledListeners) {
        null !== $00a4cde6c819110e$var$currentEntangledActionThenable && ($00a4cde6c819110e$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $00a4cde6c819110e$var$currentEntangledListeners;
        $00a4cde6c819110e$var$currentEntangledListeners = null;
        $00a4cde6c819110e$var$currentEntangledLane = 0;
        $00a4cde6c819110e$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $00a4cde6c819110e$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $00a4cde6c819110e$var$prevOnStartTransitionFinish = $00a4cde6c819110e$var$ReactSharedInternals.S;
$00a4cde6c819110e$var$ReactSharedInternals.S = function(transition, returnValue) {
    $00a4cde6c819110e$var$globalMostRecentTransitionTime = $00a4cde6c819110e$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $00a4cde6c819110e$var$entangleAsyncAction(transition, returnValue);
    null !== $00a4cde6c819110e$var$prevOnStartTransitionFinish && $00a4cde6c819110e$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $00a4cde6c819110e$var$resumedCache = $00a4cde6c819110e$var$createCursor(null);
function $00a4cde6c819110e$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $00a4cde6c819110e$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $00a4cde6c819110e$var$workInProgressRoot.pooledCache;
}
function $00a4cde6c819110e$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $00a4cde6c819110e$var$push($00a4cde6c819110e$var$resumedCache, $00a4cde6c819110e$var$resumedCache.current) : $00a4cde6c819110e$var$push($00a4cde6c819110e$var$resumedCache, prevCachePool.pool);
}
function $00a4cde6c819110e$var$getSuspendedCache() {
    var cacheFromPool = $00a4cde6c819110e$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $00a4cde6c819110e$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $00a4cde6c819110e$var$SuspenseException = Error($00a4cde6c819110e$var$formatProdErrorMessage(460)), $00a4cde6c819110e$var$SuspenseyCommitException = Error($00a4cde6c819110e$var$formatProdErrorMessage(474)), $00a4cde6c819110e$var$SuspenseActionException = Error($00a4cde6c819110e$var$formatProdErrorMessage(542)), $00a4cde6c819110e$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $00a4cde6c819110e$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $00a4cde6c819110e$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($00a4cde6c819110e$var$noop$1, $00a4cde6c819110e$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $00a4cde6c819110e$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($00a4cde6c819110e$var$noop$1, $00a4cde6c819110e$var$noop$1);
            else {
                thenableState = $00a4cde6c819110e$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $00a4cde6c819110e$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $00a4cde6c819110e$var$suspendedThenable = thenable;
            throw $00a4cde6c819110e$var$SuspenseException;
    }
}
function $00a4cde6c819110e$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $00a4cde6c819110e$var$suspendedThenable = x, $00a4cde6c819110e$var$SuspenseException;
        throw x;
    }
}
var $00a4cde6c819110e$var$suspendedThenable = null;
function $00a4cde6c819110e$var$getSuspendedThenable() {
    if (null === $00a4cde6c819110e$var$suspendedThenable) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(459));
    var thenable = $00a4cde6c819110e$var$suspendedThenable;
    $00a4cde6c819110e$var$suspendedThenable = null;
    return thenable;
}
function $00a4cde6c819110e$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $00a4cde6c819110e$var$SuspenseException || rejectedReason === $00a4cde6c819110e$var$SuspenseActionException) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(483));
}
var $00a4cde6c819110e$var$thenableState$1 = null, $00a4cde6c819110e$var$thenableIndexCounter$1 = 0;
function $00a4cde6c819110e$var$unwrapThenable(thenable) {
    var index = $00a4cde6c819110e$var$thenableIndexCounter$1;
    $00a4cde6c819110e$var$thenableIndexCounter$1 += 1;
    null === $00a4cde6c819110e$var$thenableState$1 && ($00a4cde6c819110e$var$thenableState$1 = []);
    return $00a4cde6c819110e$var$trackUsedThenable($00a4cde6c819110e$var$thenableState$1, thenable, index);
}
function $00a4cde6c819110e$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $00a4cde6c819110e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $00a4cde6c819110e$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $00a4cde6c819110e$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $00a4cde6c819110e$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $00a4cde6c819110e$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $00a4cde6c819110e$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $00a4cde6c819110e$var$REACT_LAZY_TYPE && $00a4cde6c819110e$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $00a4cde6c819110e$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $00a4cde6c819110e$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $00a4cde6c819110e$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $00a4cde6c819110e$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $00a4cde6c819110e$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $00a4cde6c819110e$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00a4cde6c819110e$var$REACT_ELEMENT_TYPE:
                    return lanes = $00a4cde6c819110e$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $00a4cde6c819110e$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $00a4cde6c819110e$var$REACT_PORTAL_TYPE:
                    return newChild = $00a4cde6c819110e$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $00a4cde6c819110e$var$REACT_LAZY_TYPE:
                    return newChild = $00a4cde6c819110e$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($00a4cde6c819110e$var$isArrayImpl(newChild) || $00a4cde6c819110e$var$getIteratorFn(newChild)) return newChild = $00a4cde6c819110e$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $00a4cde6c819110e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00a4cde6c819110e$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $00a4cde6c819110e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00a4cde6c819110e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00a4cde6c819110e$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $00a4cde6c819110e$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $00a4cde6c819110e$var$REACT_LAZY_TYPE:
                    return newChild = $00a4cde6c819110e$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($00a4cde6c819110e$var$isArrayImpl(newChild) || $00a4cde6c819110e$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $00a4cde6c819110e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00a4cde6c819110e$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $00a4cde6c819110e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00a4cde6c819110e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00a4cde6c819110e$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $00a4cde6c819110e$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $00a4cde6c819110e$var$REACT_LAZY_TYPE:
                    return newChild = $00a4cde6c819110e$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($00a4cde6c819110e$var$isArrayImpl(newChild) || $00a4cde6c819110e$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $00a4cde6c819110e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00a4cde6c819110e$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $00a4cde6c819110e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00a4cde6c819110e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $00a4cde6c819110e$var$isHydrating && $00a4cde6c819110e$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $00a4cde6c819110e$var$isHydrating && $00a4cde6c819110e$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $00a4cde6c819110e$var$isHydrating && $00a4cde6c819110e$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $00a4cde6c819110e$var$isHydrating && $00a4cde6c819110e$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $00a4cde6c819110e$var$isHydrating && $00a4cde6c819110e$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $00a4cde6c819110e$var$isHydrating && $00a4cde6c819110e$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $00a4cde6c819110e$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00a4cde6c819110e$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $00a4cde6c819110e$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $00a4cde6c819110e$var$REACT_LAZY_TYPE && $00a4cde6c819110e$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $00a4cde6c819110e$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $00a4cde6c819110e$var$REACT_FRAGMENT_TYPE ? (lanes = $00a4cde6c819110e$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $00a4cde6c819110e$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $00a4cde6c819110e$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $00a4cde6c819110e$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $00a4cde6c819110e$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $00a4cde6c819110e$var$REACT_LAZY_TYPE:
                    return newChild = $00a4cde6c819110e$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($00a4cde6c819110e$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($00a4cde6c819110e$var$getIteratorFn(newChild)) {
                key = $00a4cde6c819110e$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $00a4cde6c819110e$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00a4cde6c819110e$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $00a4cde6c819110e$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00a4cde6c819110e$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $00a4cde6c819110e$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $00a4cde6c819110e$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $00a4cde6c819110e$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $00a4cde6c819110e$var$SuspenseException || x === $00a4cde6c819110e$var$SuspenseActionException) throw x;
            var fiber = $00a4cde6c819110e$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $00a4cde6c819110e$var$reconcileChildFibers = $00a4cde6c819110e$var$createChildReconciler(!0), $00a4cde6c819110e$var$mountChildFibers = $00a4cde6c819110e$var$createChildReconciler(!1), $00a4cde6c819110e$var$hasForceUpdate = !1;
function $00a4cde6c819110e$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $00a4cde6c819110e$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $00a4cde6c819110e$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $00a4cde6c819110e$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($00a4cde6c819110e$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $00a4cde6c819110e$var$getRootForUpdatedFiber(fiber);
        $00a4cde6c819110e$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $00a4cde6c819110e$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $00a4cde6c819110e$var$getRootForUpdatedFiber(fiber);
}
function $00a4cde6c819110e$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $00a4cde6c819110e$var$markRootEntangled(root, lane);
    }
}
function $00a4cde6c819110e$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $00a4cde6c819110e$var$didReadFromEntangledAsyncAction = !1;
function $00a4cde6c819110e$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($00a4cde6c819110e$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $00a4cde6c819110e$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $00a4cde6c819110e$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $00a4cde6c819110e$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $00a4cde6c819110e$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($00a4cde6c819110e$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $00a4cde6c819110e$var$currentEntangledLane && ($00a4cde6c819110e$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $00a4cde6c819110e$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $00a4cde6c819110e$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $00a4cde6c819110e$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $00a4cde6c819110e$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $00a4cde6c819110e$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$00a4cde6c819110e$var$callCallback(callbacks[updateQueue], context);
}
var $00a4cde6c819110e$var$currentTreeHiddenStackCursor = $00a4cde6c819110e$var$createCursor(null), $00a4cde6c819110e$var$prevEntangledRenderLanesCursor = $00a4cde6c819110e$var$createCursor(0);
function $00a4cde6c819110e$var$pushHiddenContext(fiber, context) {
    fiber = $00a4cde6c819110e$var$entangledRenderLanes;
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$prevEntangledRenderLanesCursor, fiber);
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$currentTreeHiddenStackCursor, context);
    $00a4cde6c819110e$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $00a4cde6c819110e$var$reuseHiddenContextOnStack() {
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$prevEntangledRenderLanesCursor, $00a4cde6c819110e$var$entangledRenderLanes);
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$currentTreeHiddenStackCursor, $00a4cde6c819110e$var$currentTreeHiddenStackCursor.current);
}
function $00a4cde6c819110e$var$popHiddenContext() {
    $00a4cde6c819110e$var$entangledRenderLanes = $00a4cde6c819110e$var$prevEntangledRenderLanesCursor.current;
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$currentTreeHiddenStackCursor);
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$prevEntangledRenderLanesCursor);
}
var $00a4cde6c819110e$var$suspenseHandlerStackCursor = $00a4cde6c819110e$var$createCursor(null), $00a4cde6c819110e$var$shellBoundary = null;
function $00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseStackCursor, $00a4cde6c819110e$var$suspenseStackCursor.current & 1);
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseHandlerStackCursor, handler);
    null === $00a4cde6c819110e$var$shellBoundary && (null === current || null !== $00a4cde6c819110e$var$currentTreeHiddenStackCursor.current ? $00a4cde6c819110e$var$shellBoundary = handler : null !== current.memoizedState && ($00a4cde6c819110e$var$shellBoundary = handler));
}
function $00a4cde6c819110e$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseStackCursor, $00a4cde6c819110e$var$suspenseStackCursor.current);
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseHandlerStackCursor, fiber);
    null === $00a4cde6c819110e$var$shellBoundary && ($00a4cde6c819110e$var$shellBoundary = fiber);
}
function $00a4cde6c819110e$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseStackCursor, $00a4cde6c819110e$var$suspenseStackCursor.current), $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseHandlerStackCursor, fiber), null === $00a4cde6c819110e$var$shellBoundary && ($00a4cde6c819110e$var$shellBoundary = fiber)) : $00a4cde6c819110e$var$reuseSuspenseHandlerOnStack(fiber);
}
function $00a4cde6c819110e$var$reuseSuspenseHandlerOnStack() {
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseStackCursor, $00a4cde6c819110e$var$suspenseStackCursor.current);
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseHandlerStackCursor, $00a4cde6c819110e$var$suspenseHandlerStackCursor.current);
}
function $00a4cde6c819110e$var$popSuspenseHandler(fiber) {
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$suspenseHandlerStackCursor);
    $00a4cde6c819110e$var$shellBoundary === fiber && ($00a4cde6c819110e$var$shellBoundary = null);
    $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$suspenseStackCursor);
}
var $00a4cde6c819110e$var$suspenseStackCursor = $00a4cde6c819110e$var$createCursor(0);
function $00a4cde6c819110e$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $00a4cde6c819110e$var$isSuspenseInstancePending(state) || $00a4cde6c819110e$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $00a4cde6c819110e$var$renderLanes = 0, $00a4cde6c819110e$var$currentlyRenderingFiber = null, $00a4cde6c819110e$var$currentHook = null, $00a4cde6c819110e$var$workInProgressHook = null, $00a4cde6c819110e$var$didScheduleRenderPhaseUpdate = !1, $00a4cde6c819110e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $00a4cde6c819110e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $00a4cde6c819110e$var$localIdCounter = 0, $00a4cde6c819110e$var$thenableIndexCounter = 0, $00a4cde6c819110e$var$thenableState = null, $00a4cde6c819110e$var$globalClientIdCounter = 0;
function $00a4cde6c819110e$var$throwInvalidHookError() {
    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(321));
}
function $00a4cde6c819110e$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$00a4cde6c819110e$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $00a4cde6c819110e$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $00a4cde6c819110e$var$renderLanes = nextRenderLanes;
    $00a4cde6c819110e$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $00a4cde6c819110e$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $00a4cde6c819110e$var$HooksDispatcherOnMount : $00a4cde6c819110e$var$HooksDispatcherOnUpdate;
    $00a4cde6c819110e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $00a4cde6c819110e$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $00a4cde6c819110e$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $00a4cde6c819110e$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $00a4cde6c819110e$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $00a4cde6c819110e$var$finishRenderingHooks(current) {
    $00a4cde6c819110e$var$ReactSharedInternals.H = $00a4cde6c819110e$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $00a4cde6c819110e$var$currentHook && null !== $00a4cde6c819110e$var$currentHook.next;
    $00a4cde6c819110e$var$renderLanes = 0;
    $00a4cde6c819110e$var$workInProgressHook = $00a4cde6c819110e$var$currentHook = $00a4cde6c819110e$var$currentlyRenderingFiber = null;
    $00a4cde6c819110e$var$didScheduleRenderPhaseUpdate = !1;
    $00a4cde6c819110e$var$thenableIndexCounter = 0;
    $00a4cde6c819110e$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(300));
    null === current || $00a4cde6c819110e$var$didReceiveUpdate || (current = current.dependencies, null !== current && $00a4cde6c819110e$var$checkIfContextChanged(current) && ($00a4cde6c819110e$var$didReceiveUpdate = !0));
}
function $00a4cde6c819110e$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $00a4cde6c819110e$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $00a4cde6c819110e$var$didScheduleRenderPhaseUpdateDuringThisPass && ($00a4cde6c819110e$var$thenableState = null);
        $00a4cde6c819110e$var$thenableIndexCounter = 0;
        $00a4cde6c819110e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $00a4cde6c819110e$var$workInProgressHook = $00a4cde6c819110e$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $00a4cde6c819110e$var$ReactSharedInternals.H = $00a4cde6c819110e$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($00a4cde6c819110e$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $00a4cde6c819110e$var$TransitionAwareHostComponent() {
    var dispatcher = $00a4cde6c819110e$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $00a4cde6c819110e$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $00a4cde6c819110e$var$currentHook ? $00a4cde6c819110e$var$currentHook.memoizedState : null) !== dispatcher && ($00a4cde6c819110e$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $00a4cde6c819110e$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $00a4cde6c819110e$var$localIdCounter;
    $00a4cde6c819110e$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $00a4cde6c819110e$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $00a4cde6c819110e$var$resetHooksOnUnwind(workInProgress) {
    if ($00a4cde6c819110e$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $00a4cde6c819110e$var$didScheduleRenderPhaseUpdate = !1;
    }
    $00a4cde6c819110e$var$renderLanes = 0;
    $00a4cde6c819110e$var$workInProgressHook = $00a4cde6c819110e$var$currentHook = $00a4cde6c819110e$var$currentlyRenderingFiber = null;
    $00a4cde6c819110e$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $00a4cde6c819110e$var$thenableIndexCounter = $00a4cde6c819110e$var$localIdCounter = 0;
    $00a4cde6c819110e$var$thenableState = null;
}
function $00a4cde6c819110e$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $00a4cde6c819110e$var$workInProgressHook ? $00a4cde6c819110e$var$currentlyRenderingFiber.memoizedState = $00a4cde6c819110e$var$workInProgressHook = hook : $00a4cde6c819110e$var$workInProgressHook = $00a4cde6c819110e$var$workInProgressHook.next = hook;
    return $00a4cde6c819110e$var$workInProgressHook;
}
function $00a4cde6c819110e$var$updateWorkInProgressHook() {
    if (null === $00a4cde6c819110e$var$currentHook) {
        var nextCurrentHook = $00a4cde6c819110e$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $00a4cde6c819110e$var$currentHook.next;
    var nextWorkInProgressHook = null === $00a4cde6c819110e$var$workInProgressHook ? $00a4cde6c819110e$var$currentlyRenderingFiber.memoizedState : $00a4cde6c819110e$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $00a4cde6c819110e$var$workInProgressHook = nextWorkInProgressHook, $00a4cde6c819110e$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $00a4cde6c819110e$var$currentlyRenderingFiber.alternate) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(467));
            throw Error($00a4cde6c819110e$var$formatProdErrorMessage(310));
        }
        $00a4cde6c819110e$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $00a4cde6c819110e$var$currentHook.memoizedState,
            baseState: $00a4cde6c819110e$var$currentHook.baseState,
            baseQueue: $00a4cde6c819110e$var$currentHook.baseQueue,
            queue: $00a4cde6c819110e$var$currentHook.queue,
            next: null
        };
        null === $00a4cde6c819110e$var$workInProgressHook ? $00a4cde6c819110e$var$currentlyRenderingFiber.memoizedState = $00a4cde6c819110e$var$workInProgressHook = nextCurrentHook : $00a4cde6c819110e$var$workInProgressHook = $00a4cde6c819110e$var$workInProgressHook.next = nextCurrentHook;
    }
    return $00a4cde6c819110e$var$workInProgressHook;
}
function $00a4cde6c819110e$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $00a4cde6c819110e$var$useThenable(thenable) {
    var index = $00a4cde6c819110e$var$thenableIndexCounter;
    $00a4cde6c819110e$var$thenableIndexCounter += 1;
    null === $00a4cde6c819110e$var$thenableState && ($00a4cde6c819110e$var$thenableState = []);
    thenable = $00a4cde6c819110e$var$trackUsedThenable($00a4cde6c819110e$var$thenableState, thenable, index);
    index = $00a4cde6c819110e$var$currentlyRenderingFiber;
    null === (null === $00a4cde6c819110e$var$workInProgressHook ? index.memoizedState : $00a4cde6c819110e$var$workInProgressHook.next) && (index = index.alternate, $00a4cde6c819110e$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $00a4cde6c819110e$var$HooksDispatcherOnMount : $00a4cde6c819110e$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $00a4cde6c819110e$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $00a4cde6c819110e$var$useThenable(usable);
        if (usable.$$typeof === $00a4cde6c819110e$var$REACT_CONTEXT_TYPE) return $00a4cde6c819110e$var$readContext(usable);
    }
    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(438, String(usable)));
}
function $00a4cde6c819110e$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $00a4cde6c819110e$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $00a4cde6c819110e$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $00a4cde6c819110e$var$createFunctionComponentUpdateQueue(), $00a4cde6c819110e$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $00a4cde6c819110e$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $00a4cde6c819110e$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $00a4cde6c819110e$var$updateReducer(reducer) {
    var hook = $00a4cde6c819110e$var$updateWorkInProgressHook();
    return $00a4cde6c819110e$var$updateReducerImpl(hook, $00a4cde6c819110e$var$currentHook, reducer);
}
function $00a4cde6c819110e$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($00a4cde6c819110e$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($00a4cde6c819110e$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $00a4cde6c819110e$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($00a4cde6c819110e$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $00a4cde6c819110e$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $00a4cde6c819110e$var$currentlyRenderingFiber.lanes |= revertLane, $00a4cde6c819110e$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $00a4cde6c819110e$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $00a4cde6c819110e$var$currentlyRenderingFiber.lanes |= updateLane, $00a4cde6c819110e$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$00a4cde6c819110e$var$objectIs(pendingQueue, hook.memoizedState) && ($00a4cde6c819110e$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $00a4cde6c819110e$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $00a4cde6c819110e$var$rerenderReducer(reducer) {
    var hook = $00a4cde6c819110e$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $00a4cde6c819110e$var$objectIs(newState, hook.memoizedState) || ($00a4cde6c819110e$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $00a4cde6c819110e$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $00a4cde6c819110e$var$currentlyRenderingFiber, hook = $00a4cde6c819110e$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $00a4cde6c819110e$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$00a4cde6c819110e$var$objectIs(($00a4cde6c819110e$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $00a4cde6c819110e$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $00a4cde6c819110e$var$updateEffect($00a4cde6c819110e$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $00a4cde6c819110e$var$workInProgressHook && $00a4cde6c819110e$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $00a4cde6c819110e$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $00a4cde6c819110e$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $00a4cde6c819110e$var$workInProgressRoot) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($00a4cde6c819110e$var$renderLanes & 127) || $00a4cde6c819110e$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $00a4cde6c819110e$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $00a4cde6c819110e$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $00a4cde6c819110e$var$createFunctionComponentUpdateQueue(), $00a4cde6c819110e$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $00a4cde6c819110e$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $00a4cde6c819110e$var$checkIfSnapshotChanged(inst) && $00a4cde6c819110e$var$forceStoreRerender(fiber);
}
function $00a4cde6c819110e$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $00a4cde6c819110e$var$checkIfSnapshotChanged(inst) && $00a4cde6c819110e$var$forceStoreRerender(fiber);
    });
}
function $00a4cde6c819110e$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$00a4cde6c819110e$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $00a4cde6c819110e$var$forceStoreRerender(fiber) {
    var root = $00a4cde6c819110e$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $00a4cde6c819110e$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $00a4cde6c819110e$var$mountStateImpl(initialState) {
    var hook = $00a4cde6c819110e$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($00a4cde6c819110e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $00a4cde6c819110e$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $00a4cde6c819110e$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $00a4cde6c819110e$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $00a4cde6c819110e$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $00a4cde6c819110e$var$updateReducerImpl(hook, $00a4cde6c819110e$var$currentHook, "function" === typeof reducer ? reducer : $00a4cde6c819110e$var$basicStateReducer);
}
function $00a4cde6c819110e$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($00a4cde6c819110e$var$isRenderPhaseUpdate(fiber)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $00a4cde6c819110e$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $00a4cde6c819110e$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $00a4cde6c819110e$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $00a4cde6c819110e$var$ReactSharedInternals.T, currentTransition = {};
        $00a4cde6c819110e$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $00a4cde6c819110e$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $00a4cde6c819110e$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $00a4cde6c819110e$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $00a4cde6c819110e$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $00a4cde6c819110e$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $00a4cde6c819110e$var$onActionError(actionQueue, node, error$66);
    }
}
function $00a4cde6c819110e$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $00a4cde6c819110e$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $00a4cde6c819110e$var$onActionError(actionQueue, node, error);
    }) : $00a4cde6c819110e$var$onActionSuccess(actionQueue, node, returnValue);
}
function $00a4cde6c819110e$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $00a4cde6c819110e$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $00a4cde6c819110e$var$runActionStateAction(actionQueue, nextState)));
}
function $00a4cde6c819110e$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $00a4cde6c819110e$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $00a4cde6c819110e$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $00a4cde6c819110e$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $00a4cde6c819110e$var$mountActionState(action, initialStateProp) {
    if ($00a4cde6c819110e$var$isHydrating) {
        var ssrFormState = $00a4cde6c819110e$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $00a4cde6c819110e$var$currentlyRenderingFiber;
                if ($00a4cde6c819110e$var$isHydrating) {
                    if ($00a4cde6c819110e$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $00a4cde6c819110e$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $00a4cde6c819110e$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $00a4cde6c819110e$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $00a4cde6c819110e$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $00a4cde6c819110e$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $00a4cde6c819110e$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $00a4cde6c819110e$var$dispatchSetState.bind(null, $00a4cde6c819110e$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $00a4cde6c819110e$var$mountStateImpl(!1);
    inRootOrSingleton = $00a4cde6c819110e$var$dispatchOptimisticSetState.bind(null, $00a4cde6c819110e$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $00a4cde6c819110e$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $00a4cde6c819110e$var$dispatchActionState.bind(null, $00a4cde6c819110e$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $00a4cde6c819110e$var$updateActionState(action) {
    var stateHook = $00a4cde6c819110e$var$updateWorkInProgressHook();
    return $00a4cde6c819110e$var$updateActionStateImpl(stateHook, $00a4cde6c819110e$var$currentHook, action);
}
function $00a4cde6c819110e$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $00a4cde6c819110e$var$updateReducerImpl(stateHook, currentStateHook, $00a4cde6c819110e$var$actionStateReducer)[0];
    stateHook = $00a4cde6c819110e$var$updateReducer($00a4cde6c819110e$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $00a4cde6c819110e$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $00a4cde6c819110e$var$SuspenseException) throw $00a4cde6c819110e$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $00a4cde6c819110e$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($00a4cde6c819110e$var$currentlyRenderingFiber.flags |= 2048, $00a4cde6c819110e$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $00a4cde6c819110e$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $00a4cde6c819110e$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $00a4cde6c819110e$var$rerenderActionState(action) {
    var stateHook = $00a4cde6c819110e$var$updateWorkInProgressHook(), currentStateHook = $00a4cde6c819110e$var$currentHook;
    if (null !== currentStateHook) return $00a4cde6c819110e$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $00a4cde6c819110e$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $00a4cde6c819110e$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $00a4cde6c819110e$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $00a4cde6c819110e$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $00a4cde6c819110e$var$createFunctionComponentUpdateQueue(), $00a4cde6c819110e$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $00a4cde6c819110e$var$updateRef() {
    return $00a4cde6c819110e$var$updateWorkInProgressHook().memoizedState;
}
function $00a4cde6c819110e$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $00a4cde6c819110e$var$mountWorkInProgressHook();
    $00a4cde6c819110e$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $00a4cde6c819110e$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $00a4cde6c819110e$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $00a4cde6c819110e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $00a4cde6c819110e$var$currentHook && null !== deps && $00a4cde6c819110e$var$areHookInputsEqual(deps, $00a4cde6c819110e$var$currentHook.memoizedState.deps) ? hook.memoizedState = $00a4cde6c819110e$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($00a4cde6c819110e$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $00a4cde6c819110e$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $00a4cde6c819110e$var$mountEffect(create, deps) {
    $00a4cde6c819110e$var$mountEffectImpl(8390656, 8, create, deps);
}
function $00a4cde6c819110e$var$updateEffect(create, deps) {
    $00a4cde6c819110e$var$updateEffectImpl(2048, 8, create, deps);
}
function $00a4cde6c819110e$var$useEffectEventImpl(payload) {
    $00a4cde6c819110e$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $00a4cde6c819110e$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $00a4cde6c819110e$var$createFunctionComponentUpdateQueue(), $00a4cde6c819110e$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $00a4cde6c819110e$var$updateEvent(callback) {
    var ref = $00a4cde6c819110e$var$updateWorkInProgressHook().memoizedState;
    $00a4cde6c819110e$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($00a4cde6c819110e$var$executionContext & 2)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $00a4cde6c819110e$var$updateInsertionEffect(create, deps) {
    return $00a4cde6c819110e$var$updateEffectImpl(4, 2, create, deps);
}
function $00a4cde6c819110e$var$updateLayoutEffect(create, deps) {
    return $00a4cde6c819110e$var$updateEffectImpl(4, 4, create, deps);
}
function $00a4cde6c819110e$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $00a4cde6c819110e$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $00a4cde6c819110e$var$updateEffectImpl(4, 4, $00a4cde6c819110e$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $00a4cde6c819110e$var$mountDebugValue() {}
function $00a4cde6c819110e$var$updateCallback(callback, deps) {
    var hook = $00a4cde6c819110e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $00a4cde6c819110e$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $00a4cde6c819110e$var$updateMemo(nextCreate, deps) {
    var hook = $00a4cde6c819110e$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $00a4cde6c819110e$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($00a4cde6c819110e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $00a4cde6c819110e$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $00a4cde6c819110e$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $00a4cde6c819110e$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($00a4cde6c819110e$var$renderLanes & 1073741824) && 0 === ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $00a4cde6c819110e$var$requestDeferredLane();
    $00a4cde6c819110e$var$currentlyRenderingFiber.lanes |= hook;
    $00a4cde6c819110e$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $00a4cde6c819110e$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($00a4cde6c819110e$var$objectIs(value, prevValue)) return value;
    if (null !== $00a4cde6c819110e$var$currentTreeHiddenStackCursor.current) return hook = $00a4cde6c819110e$var$mountDeferredValueImpl(hook, value, initialValue), $00a4cde6c819110e$var$objectIs(hook, prevValue) || ($00a4cde6c819110e$var$didReceiveUpdate = !0), hook;
    if (0 === ($00a4cde6c819110e$var$renderLanes & 42) || 0 !== ($00a4cde6c819110e$var$renderLanes & 1073741824) && 0 === ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 261930)) return $00a4cde6c819110e$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $00a4cde6c819110e$var$requestDeferredLane();
    $00a4cde6c819110e$var$currentlyRenderingFiber.lanes |= hook;
    $00a4cde6c819110e$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $00a4cde6c819110e$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
    $00a4cde6c819110e$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $00a4cde6c819110e$var$ReactSharedInternals.T, currentTransition = {};
    $00a4cde6c819110e$var$ReactSharedInternals.T = currentTransition;
    $00a4cde6c819110e$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $00a4cde6c819110e$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $00a4cde6c819110e$var$chainThenableValue(returnValue, finishedState);
            $00a4cde6c819110e$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $00a4cde6c819110e$var$requestUpdateLane(fiber));
        } else $00a4cde6c819110e$var$dispatchSetStateInternal(fiber, queue, finishedState, $00a4cde6c819110e$var$requestUpdateLane(fiber));
    } catch (error) {
        $00a4cde6c819110e$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $00a4cde6c819110e$var$requestUpdateLane());
    } finally{
        $00a4cde6c819110e$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $00a4cde6c819110e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00a4cde6c819110e$var$noop() {}
function $00a4cde6c819110e$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(476));
    var queue = $00a4cde6c819110e$var$ensureFormComponentIsStateful(formFiber).queue;
    $00a4cde6c819110e$var$startTransition(formFiber, queue, pendingState, $00a4cde6c819110e$var$sharedNotPendingObject, null === action ? $00a4cde6c819110e$var$noop : function() {
        $00a4cde6c819110e$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $00a4cde6c819110e$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $00a4cde6c819110e$var$sharedNotPendingObject,
        baseState: $00a4cde6c819110e$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $00a4cde6c819110e$var$basicStateReducer,
            lastRenderedState: $00a4cde6c819110e$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $00a4cde6c819110e$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $00a4cde6c819110e$var$requestFormReset$1(formFiber) {
    var stateHook = $00a4cde6c819110e$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $00a4cde6c819110e$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $00a4cde6c819110e$var$requestUpdateLane());
}
function $00a4cde6c819110e$var$useHostTransitionStatus() {
    return $00a4cde6c819110e$var$readContext($00a4cde6c819110e$var$HostTransitionContext);
}
function $00a4cde6c819110e$var$updateId() {
    return $00a4cde6c819110e$var$updateWorkInProgressHook().memoizedState;
}
function $00a4cde6c819110e$var$updateRefresh() {
    return $00a4cde6c819110e$var$updateWorkInProgressHook().memoizedState;
}
function $00a4cde6c819110e$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $00a4cde6c819110e$var$requestUpdateLane();
                fiber = $00a4cde6c819110e$var$createUpdate(lane);
                var root$69 = $00a4cde6c819110e$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($00a4cde6c819110e$var$scheduleUpdateOnFiber(root$69, provider, lane), $00a4cde6c819110e$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $00a4cde6c819110e$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $00a4cde6c819110e$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $00a4cde6c819110e$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $00a4cde6c819110e$var$isRenderPhaseUpdate(fiber) ? $00a4cde6c819110e$var$enqueueRenderPhaseUpdate(queue, action) : (action = $00a4cde6c819110e$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($00a4cde6c819110e$var$scheduleUpdateOnFiber(action, fiber, lane), $00a4cde6c819110e$var$entangleTransitionUpdate(action, queue, lane)));
}
function $00a4cde6c819110e$var$dispatchSetState(fiber, queue, action) {
    var lane = $00a4cde6c819110e$var$requestUpdateLane();
    $00a4cde6c819110e$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $00a4cde6c819110e$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($00a4cde6c819110e$var$isRenderPhaseUpdate(fiber)) $00a4cde6c819110e$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($00a4cde6c819110e$var$objectIs(eagerState, currentState)) return $00a4cde6c819110e$var$enqueueUpdate$1(fiber, queue, update, 0), null === $00a4cde6c819110e$var$workInProgressRoot && $00a4cde6c819110e$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $00a4cde6c819110e$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $00a4cde6c819110e$var$scheduleUpdateOnFiber(action, fiber, lane), $00a4cde6c819110e$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $00a4cde6c819110e$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $00a4cde6c819110e$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($00a4cde6c819110e$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $00a4cde6c819110e$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $00a4cde6c819110e$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $00a4cde6c819110e$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $00a4cde6c819110e$var$currentlyRenderingFiber || null !== alternate && alternate === $00a4cde6c819110e$var$currentlyRenderingFiber;
}
function $00a4cde6c819110e$var$enqueueRenderPhaseUpdate(queue, update) {
    $00a4cde6c819110e$var$didScheduleRenderPhaseUpdateDuringThisPass = $00a4cde6c819110e$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $00a4cde6c819110e$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $00a4cde6c819110e$var$markRootEntangled(root, lane);
    }
}
var $00a4cde6c819110e$var$ContextOnlyDispatcher = {
    readContext: $00a4cde6c819110e$var$readContext,
    use: $00a4cde6c819110e$var$use,
    useCallback: $00a4cde6c819110e$var$throwInvalidHookError,
    useContext: $00a4cde6c819110e$var$throwInvalidHookError,
    useEffect: $00a4cde6c819110e$var$throwInvalidHookError,
    useImperativeHandle: $00a4cde6c819110e$var$throwInvalidHookError,
    useLayoutEffect: $00a4cde6c819110e$var$throwInvalidHookError,
    useInsertionEffect: $00a4cde6c819110e$var$throwInvalidHookError,
    useMemo: $00a4cde6c819110e$var$throwInvalidHookError,
    useReducer: $00a4cde6c819110e$var$throwInvalidHookError,
    useRef: $00a4cde6c819110e$var$throwInvalidHookError,
    useState: $00a4cde6c819110e$var$throwInvalidHookError,
    useDebugValue: $00a4cde6c819110e$var$throwInvalidHookError,
    useDeferredValue: $00a4cde6c819110e$var$throwInvalidHookError,
    useTransition: $00a4cde6c819110e$var$throwInvalidHookError,
    useSyncExternalStore: $00a4cde6c819110e$var$throwInvalidHookError,
    useId: $00a4cde6c819110e$var$throwInvalidHookError,
    useHostTransitionStatus: $00a4cde6c819110e$var$throwInvalidHookError,
    useFormState: $00a4cde6c819110e$var$throwInvalidHookError,
    useActionState: $00a4cde6c819110e$var$throwInvalidHookError,
    useOptimistic: $00a4cde6c819110e$var$throwInvalidHookError,
    useMemoCache: $00a4cde6c819110e$var$throwInvalidHookError,
    useCacheRefresh: $00a4cde6c819110e$var$throwInvalidHookError
};
$00a4cde6c819110e$var$ContextOnlyDispatcher.useEffectEvent = $00a4cde6c819110e$var$throwInvalidHookError;
var $00a4cde6c819110e$var$HooksDispatcherOnMount = {
    readContext: $00a4cde6c819110e$var$readContext,
    use: $00a4cde6c819110e$var$use,
    useCallback: function(callback, deps) {
        $00a4cde6c819110e$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $00a4cde6c819110e$var$readContext,
    useEffect: $00a4cde6c819110e$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $00a4cde6c819110e$var$mountEffectImpl(4194308, 4, $00a4cde6c819110e$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $00a4cde6c819110e$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $00a4cde6c819110e$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $00a4cde6c819110e$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($00a4cde6c819110e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $00a4cde6c819110e$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $00a4cde6c819110e$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $00a4cde6c819110e$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($00a4cde6c819110e$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $00a4cde6c819110e$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $00a4cde6c819110e$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $00a4cde6c819110e$var$dispatchReducerAction.bind(null, $00a4cde6c819110e$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $00a4cde6c819110e$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $00a4cde6c819110e$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $00a4cde6c819110e$var$dispatchSetState.bind(null, $00a4cde6c819110e$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $00a4cde6c819110e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00a4cde6c819110e$var$mountWorkInProgressHook();
        return $00a4cde6c819110e$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $00a4cde6c819110e$var$mountStateImpl(!1);
        stateHook = $00a4cde6c819110e$var$startTransition.bind(null, $00a4cde6c819110e$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $00a4cde6c819110e$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $00a4cde6c819110e$var$currentlyRenderingFiber, hook = $00a4cde6c819110e$var$mountWorkInProgressHook();
        if ($00a4cde6c819110e$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $00a4cde6c819110e$var$workInProgressRoot) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(349));
            0 !== ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 127) || $00a4cde6c819110e$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $00a4cde6c819110e$var$mountEffect($00a4cde6c819110e$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $00a4cde6c819110e$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $00a4cde6c819110e$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $00a4cde6c819110e$var$mountWorkInProgressHook(), identifierPrefix = $00a4cde6c819110e$var$workInProgressRoot.identifierPrefix;
        if ($00a4cde6c819110e$var$isHydrating) {
            var JSCompiler_inline_result = $00a4cde6c819110e$var$treeContextOverflow;
            var idWithLeadingBit = $00a4cde6c819110e$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $00a4cde6c819110e$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $00a4cde6c819110e$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $00a4cde6c819110e$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $00a4cde6c819110e$var$useHostTransitionStatus,
    useFormState: $00a4cde6c819110e$var$mountActionState,
    useActionState: $00a4cde6c819110e$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $00a4cde6c819110e$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $00a4cde6c819110e$var$dispatchOptimisticSetState.bind(null, $00a4cde6c819110e$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $00a4cde6c819110e$var$useMemoCache,
    useCacheRefresh: function() {
        return $00a4cde6c819110e$var$mountWorkInProgressHook().memoizedState = $00a4cde6c819110e$var$refreshCache.bind(null, $00a4cde6c819110e$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $00a4cde6c819110e$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($00a4cde6c819110e$var$executionContext & 2)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $00a4cde6c819110e$var$HooksDispatcherOnUpdate = {
    readContext: $00a4cde6c819110e$var$readContext,
    use: $00a4cde6c819110e$var$use,
    useCallback: $00a4cde6c819110e$var$updateCallback,
    useContext: $00a4cde6c819110e$var$readContext,
    useEffect: $00a4cde6c819110e$var$updateEffect,
    useImperativeHandle: $00a4cde6c819110e$var$updateImperativeHandle,
    useInsertionEffect: $00a4cde6c819110e$var$updateInsertionEffect,
    useLayoutEffect: $00a4cde6c819110e$var$updateLayoutEffect,
    useMemo: $00a4cde6c819110e$var$updateMemo,
    useReducer: $00a4cde6c819110e$var$updateReducer,
    useRef: $00a4cde6c819110e$var$updateRef,
    useState: function() {
        return $00a4cde6c819110e$var$updateReducer($00a4cde6c819110e$var$basicStateReducer);
    },
    useDebugValue: $00a4cde6c819110e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00a4cde6c819110e$var$updateWorkInProgressHook();
        return $00a4cde6c819110e$var$updateDeferredValueImpl(hook, $00a4cde6c819110e$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $00a4cde6c819110e$var$updateReducer($00a4cde6c819110e$var$basicStateReducer)[0], start = $00a4cde6c819110e$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $00a4cde6c819110e$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $00a4cde6c819110e$var$updateSyncExternalStore,
    useId: $00a4cde6c819110e$var$updateId,
    useHostTransitionStatus: $00a4cde6c819110e$var$useHostTransitionStatus,
    useFormState: $00a4cde6c819110e$var$updateActionState,
    useActionState: $00a4cde6c819110e$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $00a4cde6c819110e$var$updateWorkInProgressHook();
        return $00a4cde6c819110e$var$updateOptimisticImpl(hook, $00a4cde6c819110e$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $00a4cde6c819110e$var$useMemoCache,
    useCacheRefresh: $00a4cde6c819110e$var$updateRefresh
};
$00a4cde6c819110e$var$HooksDispatcherOnUpdate.useEffectEvent = $00a4cde6c819110e$var$updateEvent;
var $00a4cde6c819110e$var$HooksDispatcherOnRerender = {
    readContext: $00a4cde6c819110e$var$readContext,
    use: $00a4cde6c819110e$var$use,
    useCallback: $00a4cde6c819110e$var$updateCallback,
    useContext: $00a4cde6c819110e$var$readContext,
    useEffect: $00a4cde6c819110e$var$updateEffect,
    useImperativeHandle: $00a4cde6c819110e$var$updateImperativeHandle,
    useInsertionEffect: $00a4cde6c819110e$var$updateInsertionEffect,
    useLayoutEffect: $00a4cde6c819110e$var$updateLayoutEffect,
    useMemo: $00a4cde6c819110e$var$updateMemo,
    useReducer: $00a4cde6c819110e$var$rerenderReducer,
    useRef: $00a4cde6c819110e$var$updateRef,
    useState: function() {
        return $00a4cde6c819110e$var$rerenderReducer($00a4cde6c819110e$var$basicStateReducer);
    },
    useDebugValue: $00a4cde6c819110e$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00a4cde6c819110e$var$updateWorkInProgressHook();
        return null === $00a4cde6c819110e$var$currentHook ? $00a4cde6c819110e$var$mountDeferredValueImpl(hook, value, initialValue) : $00a4cde6c819110e$var$updateDeferredValueImpl(hook, $00a4cde6c819110e$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $00a4cde6c819110e$var$rerenderReducer($00a4cde6c819110e$var$basicStateReducer)[0], start = $00a4cde6c819110e$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $00a4cde6c819110e$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $00a4cde6c819110e$var$updateSyncExternalStore,
    useId: $00a4cde6c819110e$var$updateId,
    useHostTransitionStatus: $00a4cde6c819110e$var$useHostTransitionStatus,
    useFormState: $00a4cde6c819110e$var$rerenderActionState,
    useActionState: $00a4cde6c819110e$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $00a4cde6c819110e$var$updateWorkInProgressHook();
        if (null !== $00a4cde6c819110e$var$currentHook) return $00a4cde6c819110e$var$updateOptimisticImpl(hook, $00a4cde6c819110e$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $00a4cde6c819110e$var$useMemoCache,
    useCacheRefresh: $00a4cde6c819110e$var$updateRefresh
};
$00a4cde6c819110e$var$HooksDispatcherOnRerender.useEffectEvent = $00a4cde6c819110e$var$updateEvent;
function $00a4cde6c819110e$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $00a4cde6c819110e$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $00a4cde6c819110e$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $00a4cde6c819110e$var$requestUpdateLane(), update = $00a4cde6c819110e$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $00a4cde6c819110e$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($00a4cde6c819110e$var$scheduleUpdateOnFiber(payload, inst, lane), $00a4cde6c819110e$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $00a4cde6c819110e$var$requestUpdateLane(), update = $00a4cde6c819110e$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $00a4cde6c819110e$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($00a4cde6c819110e$var$scheduleUpdateOnFiber(payload, inst, lane), $00a4cde6c819110e$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $00a4cde6c819110e$var$requestUpdateLane(), update = $00a4cde6c819110e$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $00a4cde6c819110e$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($00a4cde6c819110e$var$scheduleUpdateOnFiber(callback, inst, lane), $00a4cde6c819110e$var$entangleTransitions(callback, inst, lane));
    }
};
function $00a4cde6c819110e$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$00a4cde6c819110e$var$shallowEqual(oldProps, newProps) || !$00a4cde6c819110e$var$shallowEqual(oldState, newState) : !0;
}
function $00a4cde6c819110e$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $00a4cde6c819110e$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $00a4cde6c819110e$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $00a4cde6c819110e$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $00a4cde6c819110e$var$defaultOnUncaughtError(error) {
    $00a4cde6c819110e$var$reportGlobalError(error);
}
function $00a4cde6c819110e$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $00a4cde6c819110e$var$defaultOnRecoverableError(error) {
    $00a4cde6c819110e$var$reportGlobalError(error);
}
function $00a4cde6c819110e$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $00a4cde6c819110e$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $00a4cde6c819110e$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $00a4cde6c819110e$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $00a4cde6c819110e$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $00a4cde6c819110e$var$createClassErrorUpdate(lane) {
    lane = $00a4cde6c819110e$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $00a4cde6c819110e$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $00a4cde6c819110e$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $00a4cde6c819110e$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed ? $00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $00a4cde6c819110e$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $00a4cde6c819110e$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $00a4cde6c819110e$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $00a4cde6c819110e$var$shellBoundary ? $00a4cde6c819110e$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $00a4cde6c819110e$var$workInProgressRootExitStatus && ($00a4cde6c819110e$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $00a4cde6c819110e$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $00a4cde6c819110e$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $00a4cde6c819110e$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $00a4cde6c819110e$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($00a4cde6c819110e$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $00a4cde6c819110e$var$attachPingListener(root, value, rootRenderLanes);
        $00a4cde6c819110e$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($00a4cde6c819110e$var$isHydrating) return returnFiber = $00a4cde6c819110e$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $00a4cde6c819110e$var$HydrationMismatchException && (root = Error($00a4cde6c819110e$var$formatProdErrorMessage(422), {
        cause: value
    }), $00a4cde6c819110e$var$queueHydrationError($00a4cde6c819110e$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $00a4cde6c819110e$var$HydrationMismatchException && (returnFiber = Error($00a4cde6c819110e$var$formatProdErrorMessage(423), {
        cause: value
    }), $00a4cde6c819110e$var$queueHydrationError($00a4cde6c819110e$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $00a4cde6c819110e$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $00a4cde6c819110e$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $00a4cde6c819110e$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $00a4cde6c819110e$var$workInProgressRootExitStatus && ($00a4cde6c819110e$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($00a4cde6c819110e$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $00a4cde6c819110e$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $00a4cde6c819110e$var$workInProgressRootConcurrentErrors ? $00a4cde6c819110e$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $00a4cde6c819110e$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $00a4cde6c819110e$var$workInProgressRootExitStatus && ($00a4cde6c819110e$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $00a4cde6c819110e$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $00a4cde6c819110e$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $00a4cde6c819110e$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed || !$00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $00a4cde6c819110e$var$createClassErrorUpdate(rootRenderLanes), $00a4cde6c819110e$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $00a4cde6c819110e$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $00a4cde6c819110e$var$SelectiveHydrationException = Error($00a4cde6c819110e$var$formatProdErrorMessage(461)), $00a4cde6c819110e$var$didReceiveUpdate = !1;
function $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $00a4cde6c819110e$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $00a4cde6c819110e$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $00a4cde6c819110e$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $00a4cde6c819110e$var$prepareToReadContext(workInProgress);
    nextProps = $00a4cde6c819110e$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $00a4cde6c819110e$var$checkDidRenderIdHook();
    if (null !== current && !$00a4cde6c819110e$var$didReceiveUpdate) return $00a4cde6c819110e$var$bailoutHooks(current, workInProgress, renderLanes), $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00a4cde6c819110e$var$isHydrating && key && $00a4cde6c819110e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $00a4cde6c819110e$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$00a4cde6c819110e$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $00a4cde6c819110e$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $00a4cde6c819110e$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$00a4cde6c819110e$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $00a4cde6c819110e$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $00a4cde6c819110e$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $00a4cde6c819110e$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($00a4cde6c819110e$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($00a4cde6c819110e$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $00a4cde6c819110e$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($00a4cde6c819110e$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $00a4cde6c819110e$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $00a4cde6c819110e$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $00a4cde6c819110e$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $00a4cde6c819110e$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $00a4cde6c819110e$var$pushHiddenContext(workInProgress, prevState) : $00a4cde6c819110e$var$reuseHiddenContextOnStack(), $00a4cde6c819110e$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $00a4cde6c819110e$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($00a4cde6c819110e$var$pushTransition(workInProgress, prevState.cachePool), $00a4cde6c819110e$var$pushHiddenContext(workInProgress, prevState), $00a4cde6c819110e$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $00a4cde6c819110e$var$pushTransition(workInProgress, null), $00a4cde6c819110e$var$reuseHiddenContextOnStack(), $00a4cde6c819110e$var$reuseSuspenseHandlerOnStack(workInProgress));
    $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $00a4cde6c819110e$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $00a4cde6c819110e$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $00a4cde6c819110e$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $00a4cde6c819110e$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $00a4cde6c819110e$var$pushTransition(workInProgress, null);
    $00a4cde6c819110e$var$reuseHiddenContextOnStack();
    $00a4cde6c819110e$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $00a4cde6c819110e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $00a4cde6c819110e$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $00a4cde6c819110e$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $00a4cde6c819110e$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $00a4cde6c819110e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $00a4cde6c819110e$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $00a4cde6c819110e$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $00a4cde6c819110e$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($00a4cde6c819110e$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $00a4cde6c819110e$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $00a4cde6c819110e$var$bailoutOffscreenComponent(null, current);
            $00a4cde6c819110e$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $00a4cde6c819110e$var$nextHydratableInstance) ? (current = $00a4cde6c819110e$var$canHydrateHydrationBoundary(current, $00a4cde6c819110e$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $00a4cde6c819110e$var$treeContextProvider ? {
                    id: $00a4cde6c819110e$var$treeContextId,
                    overflow: $00a4cde6c819110e$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $00a4cde6c819110e$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $00a4cde6c819110e$var$hydrationParentFiber = workInProgress, $00a4cde6c819110e$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $00a4cde6c819110e$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $00a4cde6c819110e$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $00a4cde6c819110e$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $00a4cde6c819110e$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($00a4cde6c819110e$var$formatProdErrorMessage(558));
        } else if ($00a4cde6c819110e$var$didReceiveUpdate || $00a4cde6c819110e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $00a4cde6c819110e$var$didReceiveUpdate || didSuspend) {
            nextProps = $00a4cde6c819110e$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $00a4cde6c819110e$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $00a4cde6c819110e$var$enqueueConcurrentRenderForLane(current, dehydrated), $00a4cde6c819110e$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $00a4cde6c819110e$var$SelectiveHydrationException;
            $00a4cde6c819110e$var$renderDidSuspendDelayIfPossible();
            workInProgress = $00a4cde6c819110e$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$getNextHydratable(dehydrated.nextSibling), $00a4cde6c819110e$var$hydrationParentFiber = workInProgress, $00a4cde6c819110e$var$isHydrating = !0, $00a4cde6c819110e$var$hydrationErrors = null, $00a4cde6c819110e$var$rootOrSingletonContext = !1, null !== current && $00a4cde6c819110e$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $00a4cde6c819110e$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $00a4cde6c819110e$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $00a4cde6c819110e$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $00a4cde6c819110e$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $00a4cde6c819110e$var$prepareToReadContext(workInProgress);
    Component = $00a4cde6c819110e$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $00a4cde6c819110e$var$checkDidRenderIdHook();
    if (null !== current && !$00a4cde6c819110e$var$didReceiveUpdate) return $00a4cde6c819110e$var$bailoutHooks(current, workInProgress, renderLanes), $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00a4cde6c819110e$var$isHydrating && nextProps && $00a4cde6c819110e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $00a4cde6c819110e$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $00a4cde6c819110e$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $00a4cde6c819110e$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $00a4cde6c819110e$var$finishRenderingHooks(current);
    Component = $00a4cde6c819110e$var$checkDidRenderIdHook();
    if (null !== current && !$00a4cde6c819110e$var$didReceiveUpdate) return $00a4cde6c819110e$var$bailoutHooks(current, workInProgress, renderLanes), $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00a4cde6c819110e$var$isHydrating && Component && $00a4cde6c819110e$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $00a4cde6c819110e$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $00a4cde6c819110e$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $00a4cde6c819110e$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $00a4cde6c819110e$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $00a4cde6c819110e$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $00a4cde6c819110e$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $00a4cde6c819110e$var$readContext(contextType) : $00a4cde6c819110e$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($00a4cde6c819110e$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $00a4cde6c819110e$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $00a4cde6c819110e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $00a4cde6c819110e$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $00a4cde6c819110e$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $00a4cde6c819110e$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $00a4cde6c819110e$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $00a4cde6c819110e$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $00a4cde6c819110e$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $00a4cde6c819110e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $00a4cde6c819110e$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $00a4cde6c819110e$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($00a4cde6c819110e$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $00a4cde6c819110e$var$hasForceUpdate || $00a4cde6c819110e$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $00a4cde6c819110e$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $00a4cde6c819110e$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $00a4cde6c819110e$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $00a4cde6c819110e$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $00a4cde6c819110e$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $00a4cde6c819110e$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $00a4cde6c819110e$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $00a4cde6c819110e$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $00a4cde6c819110e$var$hasForceUpdate || null !== current && null !== current.dependencies && $00a4cde6c819110e$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($00a4cde6c819110e$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $00a4cde6c819110e$var$hasForceUpdate || $00a4cde6c819110e$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $00a4cde6c819110e$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $00a4cde6c819110e$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $00a4cde6c819110e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $00a4cde6c819110e$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $00a4cde6c819110e$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $00a4cde6c819110e$var$resetHydrationState();
    workInProgress.flags |= 256;
    $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $00a4cde6c819110e$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $00a4cde6c819110e$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $00a4cde6c819110e$var$getSuspendedCache()
    };
}
function $00a4cde6c819110e$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $00a4cde6c819110e$var$workInProgressDeferredLane);
    return current;
}
function $00a4cde6c819110e$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($00a4cde6c819110e$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($00a4cde6c819110e$var$isHydrating) {
            showFallback ? $00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $00a4cde6c819110e$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $00a4cde6c819110e$var$nextHydratableInstance) ? (current = $00a4cde6c819110e$var$canHydrateHydrationBoundary(current, $00a4cde6c819110e$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $00a4cde6c819110e$var$treeContextProvider ? {
                    id: $00a4cde6c819110e$var$treeContextId,
                    overflow: $00a4cde6c819110e$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $00a4cde6c819110e$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $00a4cde6c819110e$var$hydrationParentFiber = workInProgress, $00a4cde6c819110e$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $00a4cde6c819110e$var$throwOnHydrationMismatch(workInProgress);
            $00a4cde6c819110e$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $00a4cde6c819110e$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $00a4cde6c819110e$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $00a4cde6c819110e$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $00a4cde6c819110e$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $00a4cde6c819110e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $00a4cde6c819110e$var$SUSPENDED_MARKER, $00a4cde6c819110e$var$bailoutOffscreenComponent(null, nextProps);
        $00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $00a4cde6c819110e$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $00a4cde6c819110e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($00a4cde6c819110e$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($00a4cde6c819110e$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $00a4cde6c819110e$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $00a4cde6c819110e$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $00a4cde6c819110e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $00a4cde6c819110e$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $00a4cde6c819110e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $00a4cde6c819110e$var$SUSPENDED_MARKER, workInProgress = $00a4cde6c819110e$var$bailoutOffscreenComponent(null, nextProps));
        else if ($00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(workInProgress), $00a4cde6c819110e$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($00a4cde6c819110e$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $00a4cde6c819110e$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $00a4cde6c819110e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($00a4cde6c819110e$var$didReceiveUpdate || $00a4cde6c819110e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $00a4cde6c819110e$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $00a4cde6c819110e$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $00a4cde6c819110e$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $00a4cde6c819110e$var$enqueueConcurrentRenderForLane(current, nextProps), $00a4cde6c819110e$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $00a4cde6c819110e$var$SelectiveHydrationException;
            $00a4cde6c819110e$var$isSuspenseInstancePending(nextPrimaryChildren) || $00a4cde6c819110e$var$renderDidSuspendDelayIfPossible();
            workInProgress = $00a4cde6c819110e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $00a4cde6c819110e$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$getNextHydratable(nextPrimaryChildren.nextSibling), $00a4cde6c819110e$var$hydrationParentFiber = workInProgress, $00a4cde6c819110e$var$isHydrating = !0, $00a4cde6c819110e$var$hydrationErrors = null, $00a4cde6c819110e$var$rootOrSingletonContext = !1, null !== current && $00a4cde6c819110e$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $00a4cde6c819110e$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $00a4cde6c819110e$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $00a4cde6c819110e$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $00a4cde6c819110e$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $00a4cde6c819110e$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $00a4cde6c819110e$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $00a4cde6c819110e$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $00a4cde6c819110e$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $00a4cde6c819110e$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $00a4cde6c819110e$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $00a4cde6c819110e$var$SUSPENDED_MARKER, $00a4cde6c819110e$var$bailoutOffscreenComponent(current.child, nextProps);
    $00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $00a4cde6c819110e$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $00a4cde6c819110e$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $00a4cde6c819110e$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $00a4cde6c819110e$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $00a4cde6c819110e$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $00a4cde6c819110e$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $00a4cde6c819110e$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $00a4cde6c819110e$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $00a4cde6c819110e$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $00a4cde6c819110e$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $00a4cde6c819110e$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $00a4cde6c819110e$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $00a4cde6c819110e$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseStackCursor, suspenseContext);
    $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $00a4cde6c819110e$var$isHydrating ? $00a4cde6c819110e$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $00a4cde6c819110e$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $00a4cde6c819110e$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $00a4cde6c819110e$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $00a4cde6c819110e$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $00a4cde6c819110e$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $00a4cde6c819110e$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $00a4cde6c819110e$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $00a4cde6c819110e$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($00a4cde6c819110e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $00a4cde6c819110e$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $00a4cde6c819110e$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $00a4cde6c819110e$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $00a4cde6c819110e$var$checkIfContextChanged(current) ? !0 : !1;
}
function $00a4cde6c819110e$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $00a4cde6c819110e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $00a4cde6c819110e$var$pushProvider(workInProgress, $00a4cde6c819110e$var$CacheContext, current.memoizedState.cache);
            $00a4cde6c819110e$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $00a4cde6c819110e$var$pushHostContext(workInProgress);
            break;
        case 4:
            $00a4cde6c819110e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $00a4cde6c819110e$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $00a4cde6c819110e$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $00a4cde6c819110e$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $00a4cde6c819110e$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($00a4cde6c819110e$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $00a4cde6c819110e$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseStackCursor, $00a4cde6c819110e$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $00a4cde6c819110e$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $00a4cde6c819110e$var$pushProvider(workInProgress, $00a4cde6c819110e$var$CacheContext, current.memoizedState.cache);
    }
    return $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $00a4cde6c819110e$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $00a4cde6c819110e$var$didReceiveUpdate = !0;
        else {
            if (!$00a4cde6c819110e$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $00a4cde6c819110e$var$didReceiveUpdate = !1, $00a4cde6c819110e$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $00a4cde6c819110e$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $00a4cde6c819110e$var$didReceiveUpdate = !1, $00a4cde6c819110e$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $00a4cde6c819110e$var$pushTreeId(workInProgress, $00a4cde6c819110e$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $00a4cde6c819110e$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $00a4cde6c819110e$var$shouldConstruct(current) ? (props = $00a4cde6c819110e$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $00a4cde6c819110e$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $00a4cde6c819110e$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $00a4cde6c819110e$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $00a4cde6c819110e$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $00a4cde6c819110e$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $00a4cde6c819110e$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $00a4cde6c819110e$var$getComponentNameFromType(current) || current;
                    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $00a4cde6c819110e$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $00a4cde6c819110e$var$resolveClassComponentProps(props, workInProgress.pendingProps), $00a4cde6c819110e$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $00a4cde6c819110e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $00a4cde6c819110e$var$cloneUpdateQueue(current, workInProgress);
                $00a4cde6c819110e$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $00a4cde6c819110e$var$pushProvider(workInProgress, $00a4cde6c819110e$var$CacheContext, props);
                props !== prevState.cache && $00a4cde6c819110e$var$propagateContextChanges(workInProgress, [
                    $00a4cde6c819110e$var$CacheContext
                ], renderLanes, !0);
                $00a4cde6c819110e$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $00a4cde6c819110e$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $00a4cde6c819110e$var$createCapturedValueAtFiber(Error($00a4cde6c819110e$var$formatProdErrorMessage(424)), workInProgress);
                        $00a4cde6c819110e$var$queueHydrationError($$typeof);
                        workInProgress = $00a4cde6c819110e$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$getNextHydratable(current.firstChild);
                        $00a4cde6c819110e$var$hydrationParentFiber = workInProgress;
                        $00a4cde6c819110e$var$isHydrating = !0;
                        $00a4cde6c819110e$var$hydrationErrors = null;
                        $00a4cde6c819110e$var$rootOrSingletonContext = !0;
                        renderLanes = $00a4cde6c819110e$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $00a4cde6c819110e$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $00a4cde6c819110e$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $00a4cde6c819110e$var$markRef(current, workInProgress), null === current ? (renderLanes = $00a4cde6c819110e$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $00a4cde6c819110e$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $00a4cde6c819110e$var$getOwnerDocumentFromRootContainer($00a4cde6c819110e$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$00a4cde6c819110e$var$internalInstanceKey] = workInProgress, props[$00a4cde6c819110e$var$internalPropsKey] = current, $00a4cde6c819110e$var$setInitialProperties(props, renderLanes, current), $00a4cde6c819110e$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $00a4cde6c819110e$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $00a4cde6c819110e$var$pushHostContext(workInProgress), null === current && $00a4cde6c819110e$var$isHydrating && (props = workInProgress.stateNode = $00a4cde6c819110e$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $00a4cde6c819110e$var$rootInstanceStackCursor.current), $00a4cde6c819110e$var$hydrationParentFiber = workInProgress, $00a4cde6c819110e$var$rootOrSingletonContext = !0, $$typeof = $00a4cde6c819110e$var$nextHydratableInstance, $00a4cde6c819110e$var$isSingletonScope(workInProgress.type) ? ($00a4cde6c819110e$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$getNextHydratable(props.firstChild)) : $00a4cde6c819110e$var$nextHydratableInstance = $$typeof), $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $00a4cde6c819110e$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $00a4cde6c819110e$var$isHydrating) {
                if ($$typeof = props = $00a4cde6c819110e$var$nextHydratableInstance) props = $00a4cde6c819110e$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $00a4cde6c819110e$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $00a4cde6c819110e$var$hydrationParentFiber = workInProgress, $00a4cde6c819110e$var$nextHydratableInstance = $00a4cde6c819110e$var$getNextHydratable(props.firstChild), $00a4cde6c819110e$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $00a4cde6c819110e$var$throwOnHydrationMismatch(workInProgress);
            }
            $00a4cde6c819110e$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $00a4cde6c819110e$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $00a4cde6c819110e$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $00a4cde6c819110e$var$renderWithHooks(current, workInProgress, $00a4cde6c819110e$var$TransitionAwareHostComponent, null, null, renderLanes), $00a4cde6c819110e$var$HostTransitionContext._currentValue = $$typeof);
            $00a4cde6c819110e$var$markRef(current, workInProgress);
            $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $00a4cde6c819110e$var$isHydrating) {
                if (current = renderLanes = $00a4cde6c819110e$var$nextHydratableInstance) renderLanes = $00a4cde6c819110e$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $00a4cde6c819110e$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $00a4cde6c819110e$var$hydrationParentFiber = workInProgress, $00a4cde6c819110e$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $00a4cde6c819110e$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $00a4cde6c819110e$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $00a4cde6c819110e$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $00a4cde6c819110e$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $00a4cde6c819110e$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $00a4cde6c819110e$var$pushProvider(workInProgress, workInProgress.type, props.value), $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $00a4cde6c819110e$var$prepareToReadContext(workInProgress), $$typeof = $00a4cde6c819110e$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $00a4cde6c819110e$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $00a4cde6c819110e$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $00a4cde6c819110e$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $00a4cde6c819110e$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $00a4cde6c819110e$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $00a4cde6c819110e$var$prepareToReadContext(workInProgress), props = $00a4cde6c819110e$var$readContext($00a4cde6c819110e$var$CacheContext), null === current ? ($$typeof = $00a4cde6c819110e$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $00a4cde6c819110e$var$workInProgressRoot, prevState = $00a4cde6c819110e$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $00a4cde6c819110e$var$initializeUpdateQueue(workInProgress), $00a4cde6c819110e$var$pushProvider(workInProgress, $00a4cde6c819110e$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($00a4cde6c819110e$var$cloneUpdateQueue(current, workInProgress), $00a4cde6c819110e$var$processUpdateQueue(workInProgress, null, null, renderLanes), $00a4cde6c819110e$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $00a4cde6c819110e$var$pushProvider(workInProgress, $00a4cde6c819110e$var$CacheContext, props)) : (props = prevState.cache, $00a4cde6c819110e$var$pushProvider(workInProgress, $00a4cde6c819110e$var$CacheContext, props), props !== $$typeof.cache && $00a4cde6c819110e$var$propagateContextChanges(workInProgress, [
                $00a4cde6c819110e$var$CacheContext
            ], renderLanes, !0))), $00a4cde6c819110e$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $00a4cde6c819110e$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $00a4cde6c819110e$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($00a4cde6c819110e$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $00a4cde6c819110e$var$suspendedThenable = $00a4cde6c819110e$var$noopSuspenseyCommitThenable, $00a4cde6c819110e$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $00a4cde6c819110e$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$00a4cde6c819110e$var$preloadResource(resource)) {
        if ($00a4cde6c819110e$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $00a4cde6c819110e$var$suspendedThenable = $00a4cde6c819110e$var$noopSuspenseyCommitThenable, $00a4cde6c819110e$var$SuspenseyCommitException;
    }
}
function $00a4cde6c819110e$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $00a4cde6c819110e$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $00a4cde6c819110e$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $00a4cde6c819110e$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$00a4cde6c819110e$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $00a4cde6c819110e$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $00a4cde6c819110e$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $00a4cde6c819110e$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $00a4cde6c819110e$var$bubbleProperties(workInProgress), null;
        case 1:
            return $00a4cde6c819110e$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $00a4cde6c819110e$var$popProvider($00a4cde6c819110e$var$CacheContext);
            $00a4cde6c819110e$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $00a4cde6c819110e$var$popHydrationState(workInProgress) ? $00a4cde6c819110e$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $00a4cde6c819110e$var$upgradeHydrationErrorsToRecoverable());
            $00a4cde6c819110e$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($00a4cde6c819110e$var$markUpdate(workInProgress), null !== nextResource ? ($00a4cde6c819110e$var$bubbleProperties(workInProgress), $00a4cde6c819110e$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($00a4cde6c819110e$var$bubbleProperties(workInProgress), $00a4cde6c819110e$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($00a4cde6c819110e$var$markUpdate(workInProgress), $00a4cde6c819110e$var$bubbleProperties(workInProgress), $00a4cde6c819110e$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($00a4cde6c819110e$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $00a4cde6c819110e$var$markUpdate(workInProgress), $00a4cde6c819110e$var$bubbleProperties(workInProgress), $00a4cde6c819110e$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $00a4cde6c819110e$var$popHostContext(workInProgress);
            renderLanes = $00a4cde6c819110e$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00a4cde6c819110e$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(166));
                    $00a4cde6c819110e$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $00a4cde6c819110e$var$contextStackCursor.current;
                $00a4cde6c819110e$var$popHydrationState(workInProgress) ? $00a4cde6c819110e$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $00a4cde6c819110e$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $00a4cde6c819110e$var$markUpdate(workInProgress));
            }
            $00a4cde6c819110e$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $00a4cde6c819110e$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00a4cde6c819110e$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(166));
                    $00a4cde6c819110e$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $00a4cde6c819110e$var$contextStackCursor.current;
                if ($00a4cde6c819110e$var$popHydrationState(workInProgress)) $00a4cde6c819110e$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $00a4cde6c819110e$var$getOwnerDocumentFromRootContainer($00a4cde6c819110e$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$00a4cde6c819110e$var$internalInstanceKey] = workInProgress;
                    nextResource[$00a4cde6c819110e$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($00a4cde6c819110e$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $00a4cde6c819110e$var$markUpdate(workInProgress);
                }
            }
            $00a4cde6c819110e$var$bubbleProperties(workInProgress);
            $00a4cde6c819110e$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00a4cde6c819110e$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(166));
                current = $00a4cde6c819110e$var$rootInstanceStackCursor.current;
                if ($00a4cde6c819110e$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $00a4cde6c819110e$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$00a4cde6c819110e$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $00a4cde6c819110e$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $00a4cde6c819110e$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $00a4cde6c819110e$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$00a4cde6c819110e$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $00a4cde6c819110e$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $00a4cde6c819110e$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(557));
                        current[$00a4cde6c819110e$var$internalInstanceKey] = workInProgress;
                    } else $00a4cde6c819110e$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $00a4cde6c819110e$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $00a4cde6c819110e$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $00a4cde6c819110e$var$popSuspenseHandler(workInProgress), workInProgress;
                    $00a4cde6c819110e$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(558));
            }
            $00a4cde6c819110e$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $00a4cde6c819110e$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(317));
                        type[$00a4cde6c819110e$var$internalInstanceKey] = workInProgress;
                    } else $00a4cde6c819110e$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $00a4cde6c819110e$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $00a4cde6c819110e$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $00a4cde6c819110e$var$popSuspenseHandler(workInProgress), workInProgress;
                    $00a4cde6c819110e$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $00a4cde6c819110e$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $00a4cde6c819110e$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $00a4cde6c819110e$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $00a4cde6c819110e$var$popHostContainer(), null === current && $00a4cde6c819110e$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $00a4cde6c819110e$var$bubbleProperties(workInProgress), null;
        case 10:
            return $00a4cde6c819110e$var$popProvider(workInProgress.type), $00a4cde6c819110e$var$bubbleProperties(workInProgress), null;
        case 19:
            $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $00a4cde6c819110e$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $00a4cde6c819110e$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $00a4cde6c819110e$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $00a4cde6c819110e$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $00a4cde6c819110e$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $00a4cde6c819110e$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$00a4cde6c819110e$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseStackCursor, $00a4cde6c819110e$var$suspenseStackCursor.current & 1 | 2);
                            $00a4cde6c819110e$var$isHydrating && $00a4cde6c819110e$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $00a4cde6c819110e$var$now() > $00a4cde6c819110e$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $00a4cde6c819110e$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $00a4cde6c819110e$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $00a4cde6c819110e$var$scheduleRetryEffect(workInProgress, current), $00a4cde6c819110e$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$00a4cde6c819110e$var$isHydrating) return $00a4cde6c819110e$var$bubbleProperties(workInProgress), null;
                    } else 2 * $00a4cde6c819110e$var$now() - newProps.renderingStartTime > $00a4cde6c819110e$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $00a4cde6c819110e$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $00a4cde6c819110e$var$now(), current.sibling = null, renderLanes = $00a4cde6c819110e$var$suspenseStackCursor.current, $00a4cde6c819110e$var$push($00a4cde6c819110e$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $00a4cde6c819110e$var$isHydrating && $00a4cde6c819110e$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $00a4cde6c819110e$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $00a4cde6c819110e$var$popSuspenseHandler(workInProgress), $00a4cde6c819110e$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($00a4cde6c819110e$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $00a4cde6c819110e$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $00a4cde6c819110e$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $00a4cde6c819110e$var$popProvider($00a4cde6c819110e$var$CacheContext), $00a4cde6c819110e$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $00a4cde6c819110e$var$unwindWork(current, workInProgress) {
    $00a4cde6c819110e$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $00a4cde6c819110e$var$popProvider($00a4cde6c819110e$var$CacheContext), $00a4cde6c819110e$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $00a4cde6c819110e$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $00a4cde6c819110e$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(340));
                $00a4cde6c819110e$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $00a4cde6c819110e$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(340));
                $00a4cde6c819110e$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$suspenseStackCursor), null;
        case 4:
            return $00a4cde6c819110e$var$popHostContainer(), null;
        case 10:
            return $00a4cde6c819110e$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $00a4cde6c819110e$var$popSuspenseHandler(workInProgress), $00a4cde6c819110e$var$popHiddenContext(), null !== current && $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $00a4cde6c819110e$var$popProvider($00a4cde6c819110e$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $00a4cde6c819110e$var$unwindInterruptedWork(current, interruptedWork) {
    $00a4cde6c819110e$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $00a4cde6c819110e$var$popProvider($00a4cde6c819110e$var$CacheContext);
            $00a4cde6c819110e$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $00a4cde6c819110e$var$popHostContext(interruptedWork);
            break;
        case 4:
            $00a4cde6c819110e$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $00a4cde6c819110e$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $00a4cde6c819110e$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$suspenseStackCursor);
            break;
        case 10:
            $00a4cde6c819110e$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $00a4cde6c819110e$var$popSuspenseHandler(interruptedWork);
            $00a4cde6c819110e$var$popHiddenContext();
            null !== current && $00a4cde6c819110e$var$pop($00a4cde6c819110e$var$resumedCache);
            break;
        case 24:
            $00a4cde6c819110e$var$popProvider($00a4cde6c819110e$var$CacheContext);
    }
}
function $00a4cde6c819110e$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00a4cde6c819110e$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $00a4cde6c819110e$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00a4cde6c819110e$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $00a4cde6c819110e$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $00a4cde6c819110e$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $00a4cde6c819110e$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $00a4cde6c819110e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $00a4cde6c819110e$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $00a4cde6c819110e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $00a4cde6c819110e$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $00a4cde6c819110e$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $00a4cde6c819110e$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $00a4cde6c819110e$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00a4cde6c819110e$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $00a4cde6c819110e$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$00a4cde6c819110e$var$internalPropsKey] = newProps;
    } catch (error) {
        $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00a4cde6c819110e$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $00a4cde6c819110e$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $00a4cde6c819110e$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $00a4cde6c819110e$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $00a4cde6c819110e$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $00a4cde6c819110e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $00a4cde6c819110e$var$noop$1));
    else if (4 !== tag && (27 === tag && $00a4cde6c819110e$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($00a4cde6c819110e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$00a4cde6c819110e$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $00a4cde6c819110e$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $00a4cde6c819110e$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($00a4cde6c819110e$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$00a4cde6c819110e$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $00a4cde6c819110e$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $00a4cde6c819110e$var$setInitialProperties(singleton, type, props);
        singleton[$00a4cde6c819110e$var$internalInstanceKey] = finishedWork;
        singleton[$00a4cde6c819110e$var$internalPropsKey] = props;
    } catch (error) {
        $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $00a4cde6c819110e$var$offscreenSubtreeIsHidden = !1, $00a4cde6c819110e$var$offscreenSubtreeWasHidden = !1, $00a4cde6c819110e$var$needsFormReset = !1, $00a4cde6c819110e$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $00a4cde6c819110e$var$nextEffect = null;
function $00a4cde6c819110e$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $00a4cde6c819110e$var$eventsEnabled = $00a4cde6c819110e$var$_enabled;
    root = $00a4cde6c819110e$var$getActiveElementDeep(root);
    if ($00a4cde6c819110e$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $00a4cde6c819110e$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $00a4cde6c819110e$var$_enabled = !1;
    for($00a4cde6c819110e$var$nextEffect = firstChild; null !== $00a4cde6c819110e$var$nextEffect;)if (firstChild = $00a4cde6c819110e$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $00a4cde6c819110e$var$nextEffect = root;
    else for(; null !== $00a4cde6c819110e$var$nextEffect;){
        firstChild = $00a4cde6c819110e$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $00a4cde6c819110e$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $00a4cde6c819110e$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $00a4cde6c819110e$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $00a4cde6c819110e$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $00a4cde6c819110e$var$nextEffect = root;
            break;
        }
        $00a4cde6c819110e$var$nextEffect = firstChild.return;
    }
}
function $00a4cde6c819110e$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00a4cde6c819110e$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $00a4cde6c819110e$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $00a4cde6c819110e$var$commitClassCallbacks(finishedWork);
            flags & 512 && $00a4cde6c819110e$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $00a4cde6c819110e$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $00a4cde6c819110e$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $00a4cde6c819110e$var$commitHostMount(finishedWork);
            flags & 512 && $00a4cde6c819110e$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00a4cde6c819110e$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00a4cde6c819110e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $00a4cde6c819110e$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $00a4cde6c819110e$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $00a4cde6c819110e$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $00a4cde6c819110e$var$offscreenSubtreeWasHidden;
                prevProps = $00a4cde6c819110e$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $00a4cde6c819110e$var$offscreenSubtreeWasHidden;
                $00a4cde6c819110e$var$offscreenSubtreeIsHidden = flags;
                ($00a4cde6c819110e$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $00a4cde6c819110e$var$offscreenSubtreeIsHidden = prevProps;
                $00a4cde6c819110e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $00a4cde6c819110e$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $00a4cde6c819110e$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $00a4cde6c819110e$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $00a4cde6c819110e$var$hostParent = null, $00a4cde6c819110e$var$hostParentIsContainer = !1;
function $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$00a4cde6c819110e$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $00a4cde6c819110e$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($00a4cde6c819110e$var$injectedHook && "function" === typeof $00a4cde6c819110e$var$injectedHook.onCommitFiberUnmount) try {
        $00a4cde6c819110e$var$injectedHook.onCommitFiberUnmount($00a4cde6c819110e$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden || $00a4cde6c819110e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden || $00a4cde6c819110e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $00a4cde6c819110e$var$hostParent, prevHostParentIsContainer = $00a4cde6c819110e$var$hostParentIsContainer;
            $00a4cde6c819110e$var$isSingletonScope(deletedFiber.type) && ($00a4cde6c819110e$var$hostParent = deletedFiber.stateNode, $00a4cde6c819110e$var$hostParentIsContainer = !1);
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00a4cde6c819110e$var$releaseSingletonInstance(deletedFiber.stateNode);
            $00a4cde6c819110e$var$hostParent = prevHostParent;
            $00a4cde6c819110e$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden || $00a4cde6c819110e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $00a4cde6c819110e$var$hostParent;
            prevHostParentIsContainer = $00a4cde6c819110e$var$hostParentIsContainer;
            $00a4cde6c819110e$var$hostParent = null;
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00a4cde6c819110e$var$hostParent = prevHostParent;
            $00a4cde6c819110e$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $00a4cde6c819110e$var$hostParent) {
                if ($00a4cde6c819110e$var$hostParentIsContainer) try {
                    (9 === $00a4cde6c819110e$var$hostParent.nodeType ? $00a4cde6c819110e$var$hostParent.body : "HTML" === $00a4cde6c819110e$var$hostParent.nodeName ? $00a4cde6c819110e$var$hostParent.ownerDocument.body : $00a4cde6c819110e$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $00a4cde6c819110e$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $00a4cde6c819110e$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $00a4cde6c819110e$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $00a4cde6c819110e$var$hostParent && ($00a4cde6c819110e$var$hostParentIsContainer ? (finishedRoot = $00a4cde6c819110e$var$hostParent, $00a4cde6c819110e$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $00a4cde6c819110e$var$retryIfBlockedOn(finishedRoot)) : $00a4cde6c819110e$var$clearHydrationBoundary($00a4cde6c819110e$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $00a4cde6c819110e$var$hostParent;
            prevHostParentIsContainer = $00a4cde6c819110e$var$hostParentIsContainer;
            $00a4cde6c819110e$var$hostParent = deletedFiber.stateNode.containerInfo;
            $00a4cde6c819110e$var$hostParentIsContainer = !0;
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00a4cde6c819110e$var$hostParent = prevHostParent;
            $00a4cde6c819110e$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $00a4cde6c819110e$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden || $00a4cde6c819110e$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden || ($00a4cde6c819110e$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $00a4cde6c819110e$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden = (prevHostParent = $00a4cde6c819110e$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $00a4cde6c819110e$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $00a4cde6c819110e$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $00a4cde6c819110e$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $00a4cde6c819110e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $00a4cde6c819110e$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00a4cde6c819110e$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $00a4cde6c819110e$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $00a4cde6c819110e$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($00a4cde6c819110e$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $00a4cde6c819110e$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $00a4cde6c819110e$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $00a4cde6c819110e$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($00a4cde6c819110e$var$isSingletonScope(parent.type)) {
                        $00a4cde6c819110e$var$hostParent = parent.stateNode;
                        $00a4cde6c819110e$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $00a4cde6c819110e$var$hostParent = parent.stateNode;
                    $00a4cde6c819110e$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $00a4cde6c819110e$var$hostParent = parent.stateNode.containerInfo;
                    $00a4cde6c819110e$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $00a4cde6c819110e$var$hostParent) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(160));
        $00a4cde6c819110e$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $00a4cde6c819110e$var$hostParent = null;
        $00a4cde6c819110e$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$00a4cde6c819110e$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $00a4cde6c819110e$var$currentHoistableRoot = null;
function $00a4cde6c819110e$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($00a4cde6c819110e$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $00a4cde6c819110e$var$commitHookEffectListMount(3, finishedWork), $00a4cde6c819110e$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00a4cde6c819110e$var$offscreenSubtreeWasHidden || null === current || $00a4cde6c819110e$var$safelyDetachRef(current, current.return));
            flags & 64 && $00a4cde6c819110e$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $00a4cde6c819110e$var$currentHoistableRoot;
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00a4cde6c819110e$var$offscreenSubtreeWasHidden || null === current || $00a4cde6c819110e$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$00a4cde6c819110e$var$internalHoistableMarker] || currentResource[$00a4cde6c819110e$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $00a4cde6c819110e$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$00a4cde6c819110e$var$internalInstanceKey] = finishedWork;
                                        $00a4cde6c819110e$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $00a4cde6c819110e$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $00a4cde6c819110e$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $00a4cde6c819110e$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $00a4cde6c819110e$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($00a4cde6c819110e$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$00a4cde6c819110e$var$internalInstanceKey] = finishedWork;
                                $00a4cde6c819110e$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $00a4cde6c819110e$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $00a4cde6c819110e$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $00a4cde6c819110e$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $00a4cde6c819110e$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $00a4cde6c819110e$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00a4cde6c819110e$var$offscreenSubtreeWasHidden || null === current || $00a4cde6c819110e$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $00a4cde6c819110e$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00a4cde6c819110e$var$offscreenSubtreeWasHidden || null === current || $00a4cde6c819110e$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $00a4cde6c819110e$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $00a4cde6c819110e$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($00a4cde6c819110e$var$needsFormReset = !0);
            break;
        case 6:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $00a4cde6c819110e$var$tagCaches = null;
            hoistableRoot = $00a4cde6c819110e$var$currentHoistableRoot;
            $00a4cde6c819110e$var$currentHoistableRoot = $00a4cde6c819110e$var$getHoistableRoot(root.containerInfo);
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$currentHoistableRoot = hoistableRoot;
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $00a4cde6c819110e$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $00a4cde6c819110e$var$needsFormReset && ($00a4cde6c819110e$var$needsFormReset = !1, $00a4cde6c819110e$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $00a4cde6c819110e$var$currentHoistableRoot;
            $00a4cde6c819110e$var$currentHoistableRoot = $00a4cde6c819110e$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            $00a4cde6c819110e$var$currentHoistableRoot = flags;
            break;
        case 12:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $00a4cde6c819110e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($00a4cde6c819110e$var$globalMostRecentFallbackTime = $00a4cde6c819110e$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $00a4cde6c819110e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $00a4cde6c819110e$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $00a4cde6c819110e$var$offscreenSubtreeWasHidden;
            $00a4cde6c819110e$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $00a4cde6c819110e$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $00a4cde6c819110e$var$offscreenSubtreeIsHidden || $00a4cde6c819110e$var$offscreenSubtreeWasHidden || $00a4cde6c819110e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $00a4cde6c819110e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $00a4cde6c819110e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $00a4cde6c819110e$var$hideOrUnhideDehydratedBoundary(instance, !0) : $00a4cde6c819110e$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $00a4cde6c819110e$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $00a4cde6c819110e$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $00a4cde6c819110e$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $00a4cde6c819110e$var$recursivelyTraverseMutationEffects(root, finishedWork), $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork);
    }
}
function $00a4cde6c819110e$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($00a4cde6c819110e$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $00a4cde6c819110e$var$getHostSibling(finishedWork);
                    $00a4cde6c819110e$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($00a4cde6c819110e$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $00a4cde6c819110e$var$getHostSibling(finishedWork);
                    $00a4cde6c819110e$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $00a4cde6c819110e$var$getHostSibling(finishedWork);
                    $00a4cde6c819110e$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $00a4cde6c819110e$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $00a4cde6c819110e$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $00a4cde6c819110e$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$00a4cde6c819110e$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $00a4cde6c819110e$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $00a4cde6c819110e$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $00a4cde6c819110e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $00a4cde6c819110e$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $00a4cde6c819110e$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $00a4cde6c819110e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $00a4cde6c819110e$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $00a4cde6c819110e$var$safelyDetachRef(finishedWork, finishedWork.return);
                $00a4cde6c819110e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $00a4cde6c819110e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $00a4cde6c819110e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $00a4cde6c819110e$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $00a4cde6c819110e$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $00a4cde6c819110e$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$00a4cde6c819110e$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $00a4cde6c819110e$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $00a4cde6c819110e$var$commitClassCallbacks(finishedWork);
                $00a4cde6c819110e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $00a4cde6c819110e$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $00a4cde6c819110e$var$commitHostMount(finishedWork);
                $00a4cde6c819110e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $00a4cde6c819110e$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $00a4cde6c819110e$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $00a4cde6c819110e$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $00a4cde6c819110e$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00a4cde6c819110e$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $00a4cde6c819110e$var$releaseCache(previousCache));
}
function $00a4cde6c819110e$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $00a4cde6c819110e$var$releaseCache(current));
}
function $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$00a4cde6c819110e$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $00a4cde6c819110e$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $00a4cde6c819110e$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $00a4cde6c819110e$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $00a4cde6c819110e$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $00a4cde6c819110e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $00a4cde6c819110e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $00a4cde6c819110e$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $00a4cde6c819110e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $00a4cde6c819110e$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $00a4cde6c819110e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $00a4cde6c819110e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $00a4cde6c819110e$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $00a4cde6c819110e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $00a4cde6c819110e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $00a4cde6c819110e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $00a4cde6c819110e$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $00a4cde6c819110e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $00a4cde6c819110e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $00a4cde6c819110e$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00a4cde6c819110e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $00a4cde6c819110e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $00a4cde6c819110e$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $00a4cde6c819110e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $00a4cde6c819110e$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $00a4cde6c819110e$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $00a4cde6c819110e$var$suspenseyCommitFlag = 8192;
function $00a4cde6c819110e$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $00a4cde6c819110e$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$00a4cde6c819110e$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $00a4cde6c819110e$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $00a4cde6c819110e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $00a4cde6c819110e$var$suspenseyCommitFlag && null !== fiber.memoizedState && $00a4cde6c819110e$var$suspendResource(suspendedState, $00a4cde6c819110e$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $00a4cde6c819110e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $00a4cde6c819110e$var$currentHoistableRoot;
            $00a4cde6c819110e$var$currentHoistableRoot = $00a4cde6c819110e$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $00a4cde6c819110e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $00a4cde6c819110e$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $00a4cde6c819110e$var$suspenseyCommitFlag, $00a4cde6c819110e$var$suspenseyCommitFlag = 16777216, $00a4cde6c819110e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $00a4cde6c819110e$var$suspenseyCommitFlag = previousHoistableRoot) : $00a4cde6c819110e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $00a4cde6c819110e$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $00a4cde6c819110e$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $00a4cde6c819110e$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $00a4cde6c819110e$var$nextEffect = childToDelete;
            $00a4cde6c819110e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $00a4cde6c819110e$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$00a4cde6c819110e$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $00a4cde6c819110e$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00a4cde6c819110e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $00a4cde6c819110e$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $00a4cde6c819110e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $00a4cde6c819110e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $00a4cde6c819110e$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $00a4cde6c819110e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $00a4cde6c819110e$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $00a4cde6c819110e$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $00a4cde6c819110e$var$nextEffect = childToDelete;
            $00a4cde6c819110e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $00a4cde6c819110e$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $00a4cde6c819110e$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $00a4cde6c819110e$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $00a4cde6c819110e$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $00a4cde6c819110e$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00a4cde6c819110e$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $00a4cde6c819110e$var$nextEffect;){
        var fiber = $00a4cde6c819110e$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $00a4cde6c819110e$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $00a4cde6c819110e$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $00a4cde6c819110e$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $00a4cde6c819110e$var$nextEffect;){
            cache = $00a4cde6c819110e$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $00a4cde6c819110e$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $00a4cde6c819110e$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $00a4cde6c819110e$var$nextEffect = sibling;
                break a;
            }
            $00a4cde6c819110e$var$nextEffect = returnFiber;
        }
    }
}
var $00a4cde6c819110e$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $00a4cde6c819110e$var$readContext($00a4cde6c819110e$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $00a4cde6c819110e$var$readContext($00a4cde6c819110e$var$CacheContext).controller.signal;
    }
}, $00a4cde6c819110e$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $00a4cde6c819110e$var$executionContext = 0, $00a4cde6c819110e$var$workInProgressRoot = null, $00a4cde6c819110e$var$workInProgress = null, $00a4cde6c819110e$var$workInProgressRootRenderLanes = 0, $00a4cde6c819110e$var$workInProgressSuspendedReason = 0, $00a4cde6c819110e$var$workInProgressThrownValue = null, $00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings = !1, $00a4cde6c819110e$var$workInProgressRootIsPrerendering = !1, $00a4cde6c819110e$var$workInProgressRootDidAttachPingListener = !1, $00a4cde6c819110e$var$entangledRenderLanes = 0, $00a4cde6c819110e$var$workInProgressRootExitStatus = 0, $00a4cde6c819110e$var$workInProgressRootSkippedLanes = 0, $00a4cde6c819110e$var$workInProgressRootInterleavedUpdatedLanes = 0, $00a4cde6c819110e$var$workInProgressRootPingedLanes = 0, $00a4cde6c819110e$var$workInProgressDeferredLane = 0, $00a4cde6c819110e$var$workInProgressSuspendedRetryLanes = 0, $00a4cde6c819110e$var$workInProgressRootConcurrentErrors = null, $00a4cde6c819110e$var$workInProgressRootRecoverableErrors = null, $00a4cde6c819110e$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $00a4cde6c819110e$var$globalMostRecentFallbackTime = 0, $00a4cde6c819110e$var$globalMostRecentTransitionTime = 0, $00a4cde6c819110e$var$workInProgressRootRenderTargetTime = Infinity, $00a4cde6c819110e$var$workInProgressTransitions = null, $00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed = null, $00a4cde6c819110e$var$pendingEffectsStatus = 0, $00a4cde6c819110e$var$pendingEffectsRoot = null, $00a4cde6c819110e$var$pendingFinishedWork = null, $00a4cde6c819110e$var$pendingEffectsLanes = 0, $00a4cde6c819110e$var$pendingEffectsRemainingLanes = 0, $00a4cde6c819110e$var$pendingPassiveTransitions = null, $00a4cde6c819110e$var$pendingRecoverableErrors = null, $00a4cde6c819110e$var$nestedUpdateCount = 0, $00a4cde6c819110e$var$rootWithNestedUpdates = null;
function $00a4cde6c819110e$var$requestUpdateLane() {
    return 0 !== ($00a4cde6c819110e$var$executionContext & 2) && 0 !== $00a4cde6c819110e$var$workInProgressRootRenderLanes ? $00a4cde6c819110e$var$workInProgressRootRenderLanes & -$00a4cde6c819110e$var$workInProgressRootRenderLanes : null !== $00a4cde6c819110e$var$ReactSharedInternals.T ? $00a4cde6c819110e$var$requestTransitionLane() : $00a4cde6c819110e$var$resolveUpdatePriority();
}
function $00a4cde6c819110e$var$requestDeferredLane() {
    if (0 === $00a4cde6c819110e$var$workInProgressDeferredLane) {
        if (0 === ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 536870912) || $00a4cde6c819110e$var$isHydrating) {
            var lane = $00a4cde6c819110e$var$nextTransitionDeferredLane;
            $00a4cde6c819110e$var$nextTransitionDeferredLane <<= 1;
            0 === ($00a4cde6c819110e$var$nextTransitionDeferredLane & 3932160) && ($00a4cde6c819110e$var$nextTransitionDeferredLane = 262144);
            $00a4cde6c819110e$var$workInProgressDeferredLane = lane;
        } else $00a4cde6c819110e$var$workInProgressDeferredLane = 536870912;
    }
    lane = $00a4cde6c819110e$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $00a4cde6c819110e$var$workInProgressDeferredLane;
}
function $00a4cde6c819110e$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $00a4cde6c819110e$var$workInProgressRoot && (2 === $00a4cde6c819110e$var$workInProgressSuspendedReason || 9 === $00a4cde6c819110e$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $00a4cde6c819110e$var$prepareFreshStack(root, 0), $00a4cde6c819110e$var$markRootSuspended(root, $00a4cde6c819110e$var$workInProgressRootRenderLanes, $00a4cde6c819110e$var$workInProgressDeferredLane, !1);
    $00a4cde6c819110e$var$markRootUpdated$1(root, lane);
    if (0 === ($00a4cde6c819110e$var$executionContext & 2) || root !== $00a4cde6c819110e$var$workInProgressRoot) root === $00a4cde6c819110e$var$workInProgressRoot && (0 === ($00a4cde6c819110e$var$executionContext & 2) && ($00a4cde6c819110e$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $00a4cde6c819110e$var$workInProgressRootExitStatus && $00a4cde6c819110e$var$markRootSuspended(root, $00a4cde6c819110e$var$workInProgressRootRenderLanes, $00a4cde6c819110e$var$workInProgressDeferredLane, !1)), $00a4cde6c819110e$var$ensureRootIsScheduled(root);
}
function $00a4cde6c819110e$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($00a4cde6c819110e$var$executionContext & 6)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $00a4cde6c819110e$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $00a4cde6c819110e$var$renderRootConcurrent(root$jscomp$0, lanes) : $00a4cde6c819110e$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $00a4cde6c819110e$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $00a4cde6c819110e$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$00a4cde6c819110e$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $00a4cde6c819110e$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $00a4cde6c819110e$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($00a4cde6c819110e$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $00a4cde6c819110e$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($00a4cde6c819110e$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $00a4cde6c819110e$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $00a4cde6c819110e$var$workInProgressRootRecoverableErrors;
                            $00a4cde6c819110e$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $00a4cde6c819110e$var$workInProgressRootRecoverableErrors ? $00a4cde6c819110e$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $00a4cde6c819110e$var$workInProgressRootRecoverableErrors.push.apply($00a4cde6c819110e$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $00a4cde6c819110e$var$prepareFreshStack(root$jscomp$0, 0);
                $00a4cde6c819110e$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($00a4cde6c819110e$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $00a4cde6c819110e$var$markRootSuspended(shouldTimeSlice, lanes, $00a4cde6c819110e$var$workInProgressDeferredLane, !$00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $00a4cde6c819110e$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($00a4cde6c819110e$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $00a4cde6c819110e$var$globalMostRecentFallbackTime + 300 - $00a4cde6c819110e$var$now(), 10 < exitStatus)) {
                    $00a4cde6c819110e$var$markRootSuspended(shouldTimeSlice, lanes, $00a4cde6c819110e$var$workInProgressDeferredLane, !$00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $00a4cde6c819110e$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $00a4cde6c819110e$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $00a4cde6c819110e$var$scheduleTimeout($00a4cde6c819110e$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $00a4cde6c819110e$var$workInProgressRootRecoverableErrors, $00a4cde6c819110e$var$workInProgressTransitions, $00a4cde6c819110e$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $00a4cde6c819110e$var$workInProgressDeferredLane, $00a4cde6c819110e$var$workInProgressRootInterleavedUpdatedLanes, $00a4cde6c819110e$var$workInProgressSuspendedRetryLanes, $00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $00a4cde6c819110e$var$commitRootWhenReady(shouldTimeSlice, forceSync, $00a4cde6c819110e$var$workInProgressRootRecoverableErrors, $00a4cde6c819110e$var$workInProgressTransitions, $00a4cde6c819110e$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $00a4cde6c819110e$var$workInProgressDeferredLane, $00a4cde6c819110e$var$workInProgressRootInterleavedUpdatedLanes, $00a4cde6c819110e$var$workInProgressSuspendedRetryLanes, $00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $00a4cde6c819110e$var$ensureRootIsScheduled(root$jscomp$0);
}
function $00a4cde6c819110e$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $00a4cde6c819110e$var$noop$1
        };
        $00a4cde6c819110e$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $00a4cde6c819110e$var$globalMostRecentFallbackTime - $00a4cde6c819110e$var$now() : (lanes & 4194048) === lanes ? $00a4cde6c819110e$var$globalMostRecentTransitionTime - $00a4cde6c819110e$var$now() : 0;
        timeoutOffset = $00a4cde6c819110e$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $00a4cde6c819110e$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($00a4cde6c819110e$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $00a4cde6c819110e$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $00a4cde6c819110e$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $00a4cde6c819110e$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$00a4cde6c819110e$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $00a4cde6c819110e$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$00a4cde6c819110e$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$00a4cde6c819110e$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $00a4cde6c819110e$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $00a4cde6c819110e$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $00a4cde6c819110e$var$flushSyncWork$1() {
    return 0 === ($00a4cde6c819110e$var$executionContext & 6) ? ($00a4cde6c819110e$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $00a4cde6c819110e$var$resetWorkInProgressStack() {
    if (null !== $00a4cde6c819110e$var$workInProgress) {
        if (0 === $00a4cde6c819110e$var$workInProgressSuspendedReason) var interruptedWork = $00a4cde6c819110e$var$workInProgress.return;
        else interruptedWork = $00a4cde6c819110e$var$workInProgress, $00a4cde6c819110e$var$lastContextDependency = $00a4cde6c819110e$var$currentlyRenderingFiber$1 = null, $00a4cde6c819110e$var$resetHooksOnUnwind(interruptedWork), $00a4cde6c819110e$var$thenableState$1 = null, $00a4cde6c819110e$var$thenableIndexCounter$1 = 0, interruptedWork = $00a4cde6c819110e$var$workInProgress;
        for(; null !== interruptedWork;)$00a4cde6c819110e$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $00a4cde6c819110e$var$workInProgress = null;
    }
}
function $00a4cde6c819110e$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $00a4cde6c819110e$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $00a4cde6c819110e$var$pendingEffectsLanes = 0;
    $00a4cde6c819110e$var$resetWorkInProgressStack();
    $00a4cde6c819110e$var$workInProgressRoot = root;
    $00a4cde6c819110e$var$workInProgress = timeoutHandle = $00a4cde6c819110e$var$createWorkInProgress(root.current, null);
    $00a4cde6c819110e$var$workInProgressRootRenderLanes = lanes;
    $00a4cde6c819110e$var$workInProgressSuspendedReason = 0;
    $00a4cde6c819110e$var$workInProgressThrownValue = null;
    $00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $00a4cde6c819110e$var$workInProgressRootIsPrerendering = $00a4cde6c819110e$var$checkIfRootIsPrerendering(root, lanes);
    $00a4cde6c819110e$var$workInProgressRootDidAttachPingListener = !1;
    $00a4cde6c819110e$var$workInProgressSuspendedRetryLanes = $00a4cde6c819110e$var$workInProgressDeferredLane = $00a4cde6c819110e$var$workInProgressRootPingedLanes = $00a4cde6c819110e$var$workInProgressRootInterleavedUpdatedLanes = $00a4cde6c819110e$var$workInProgressRootSkippedLanes = $00a4cde6c819110e$var$workInProgressRootExitStatus = 0;
    $00a4cde6c819110e$var$workInProgressRootRecoverableErrors = $00a4cde6c819110e$var$workInProgressRootConcurrentErrors = null;
    $00a4cde6c819110e$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $00a4cde6c819110e$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $00a4cde6c819110e$var$entangledRenderLanes = lanes;
    $00a4cde6c819110e$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $00a4cde6c819110e$var$handleThrow(root, thrownValue) {
    $00a4cde6c819110e$var$currentlyRenderingFiber = null;
    $00a4cde6c819110e$var$ReactSharedInternals.H = $00a4cde6c819110e$var$ContextOnlyDispatcher;
    thrownValue === $00a4cde6c819110e$var$SuspenseException || thrownValue === $00a4cde6c819110e$var$SuspenseActionException ? (thrownValue = $00a4cde6c819110e$var$getSuspendedThenable(), $00a4cde6c819110e$var$workInProgressSuspendedReason = 3) : thrownValue === $00a4cde6c819110e$var$SuspenseyCommitException ? (thrownValue = $00a4cde6c819110e$var$getSuspendedThenable(), $00a4cde6c819110e$var$workInProgressSuspendedReason = 4) : $00a4cde6c819110e$var$workInProgressSuspendedReason = thrownValue === $00a4cde6c819110e$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $00a4cde6c819110e$var$workInProgressThrownValue = thrownValue;
    null === $00a4cde6c819110e$var$workInProgress && ($00a4cde6c819110e$var$workInProgressRootExitStatus = 1, $00a4cde6c819110e$var$logUncaughtError(root, $00a4cde6c819110e$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $00a4cde6c819110e$var$shouldRemainOnPreviousScreen() {
    var handler = $00a4cde6c819110e$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 4194048) === $00a4cde6c819110e$var$workInProgressRootRenderLanes ? null === $00a4cde6c819110e$var$shellBoundary ? !0 : !1 : ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 62914560) === $00a4cde6c819110e$var$workInProgressRootRenderLanes || 0 !== ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 536870912) ? handler === $00a4cde6c819110e$var$shellBoundary : !1;
}
function $00a4cde6c819110e$var$pushDispatcher() {
    var prevDispatcher = $00a4cde6c819110e$var$ReactSharedInternals.H;
    $00a4cde6c819110e$var$ReactSharedInternals.H = $00a4cde6c819110e$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $00a4cde6c819110e$var$ContextOnlyDispatcher : prevDispatcher;
}
function $00a4cde6c819110e$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $00a4cde6c819110e$var$ReactSharedInternals.A;
    $00a4cde6c819110e$var$ReactSharedInternals.A = $00a4cde6c819110e$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $00a4cde6c819110e$var$renderDidSuspendDelayIfPossible() {
    $00a4cde6c819110e$var$workInProgressRootExitStatus = 4;
    $00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings || ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 4194048) !== $00a4cde6c819110e$var$workInProgressRootRenderLanes && null !== $00a4cde6c819110e$var$suspenseHandlerStackCursor.current || ($00a4cde6c819110e$var$workInProgressRootIsPrerendering = !0);
    0 === ($00a4cde6c819110e$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($00a4cde6c819110e$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $00a4cde6c819110e$var$workInProgressRoot || $00a4cde6c819110e$var$markRootSuspended($00a4cde6c819110e$var$workInProgressRoot, $00a4cde6c819110e$var$workInProgressRootRenderLanes, $00a4cde6c819110e$var$workInProgressDeferredLane, !1);
}
function $00a4cde6c819110e$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $00a4cde6c819110e$var$executionContext;
    $00a4cde6c819110e$var$executionContext |= 2;
    var prevDispatcher = $00a4cde6c819110e$var$pushDispatcher(), prevAsyncDispatcher = $00a4cde6c819110e$var$pushAsyncDispatcher();
    if ($00a4cde6c819110e$var$workInProgressRoot !== root || $00a4cde6c819110e$var$workInProgressRootRenderLanes !== lanes) $00a4cde6c819110e$var$workInProgressTransitions = null, $00a4cde6c819110e$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $00a4cde6c819110e$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $00a4cde6c819110e$var$workInProgressSuspendedReason && null !== $00a4cde6c819110e$var$workInProgress) {
            var unitOfWork = $00a4cde6c819110e$var$workInProgress, thrownValue = $00a4cde6c819110e$var$workInProgressThrownValue;
            switch($00a4cde6c819110e$var$workInProgressSuspendedReason){
                case 8:
                    $00a4cde6c819110e$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $00a4cde6c819110e$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $00a4cde6c819110e$var$workInProgressSuspendedReason;
                    $00a4cde6c819110e$var$workInProgressSuspendedReason = 0;
                    $00a4cde6c819110e$var$workInProgressThrownValue = null;
                    $00a4cde6c819110e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $00a4cde6c819110e$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $00a4cde6c819110e$var$workInProgressSuspendedReason, $00a4cde6c819110e$var$workInProgressSuspendedReason = 0, $00a4cde6c819110e$var$workInProgressThrownValue = null, $00a4cde6c819110e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $00a4cde6c819110e$var$workLoopSync();
        exitStatus = $00a4cde6c819110e$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $00a4cde6c819110e$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $00a4cde6c819110e$var$lastContextDependency = $00a4cde6c819110e$var$currentlyRenderingFiber$1 = null;
    $00a4cde6c819110e$var$executionContext = prevExecutionContext;
    $00a4cde6c819110e$var$ReactSharedInternals.H = prevDispatcher;
    $00a4cde6c819110e$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $00a4cde6c819110e$var$workInProgress && ($00a4cde6c819110e$var$workInProgressRoot = null, $00a4cde6c819110e$var$workInProgressRootRenderLanes = 0, $00a4cde6c819110e$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $00a4cde6c819110e$var$workLoopSync() {
    for(; null !== $00a4cde6c819110e$var$workInProgress;)$00a4cde6c819110e$var$performUnitOfWork($00a4cde6c819110e$var$workInProgress);
}
function $00a4cde6c819110e$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $00a4cde6c819110e$var$executionContext;
    $00a4cde6c819110e$var$executionContext |= 2;
    var prevDispatcher = $00a4cde6c819110e$var$pushDispatcher(), prevAsyncDispatcher = $00a4cde6c819110e$var$pushAsyncDispatcher();
    $00a4cde6c819110e$var$workInProgressRoot !== root || $00a4cde6c819110e$var$workInProgressRootRenderLanes !== lanes ? ($00a4cde6c819110e$var$workInProgressTransitions = null, $00a4cde6c819110e$var$workInProgressRootRenderTargetTime = $00a4cde6c819110e$var$now() + 500, $00a4cde6c819110e$var$prepareFreshStack(root, lanes)) : $00a4cde6c819110e$var$workInProgressRootIsPrerendering = $00a4cde6c819110e$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $00a4cde6c819110e$var$workInProgressSuspendedReason && null !== $00a4cde6c819110e$var$workInProgress) {
            lanes = $00a4cde6c819110e$var$workInProgress;
            var thrownValue = $00a4cde6c819110e$var$workInProgressThrownValue;
            b: switch($00a4cde6c819110e$var$workInProgressSuspendedReason){
                case 1:
                    $00a4cde6c819110e$var$workInProgressSuspendedReason = 0;
                    $00a4cde6c819110e$var$workInProgressThrownValue = null;
                    $00a4cde6c819110e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($00a4cde6c819110e$var$isThenableResolved(thrownValue)) {
                        $00a4cde6c819110e$var$workInProgressSuspendedReason = 0;
                        $00a4cde6c819110e$var$workInProgressThrownValue = null;
                        $00a4cde6c819110e$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $00a4cde6c819110e$var$workInProgressSuspendedReason && 9 !== $00a4cde6c819110e$var$workInProgressSuspendedReason || $00a4cde6c819110e$var$workInProgressRoot !== root || ($00a4cde6c819110e$var$workInProgressSuspendedReason = 7);
                        $00a4cde6c819110e$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $00a4cde6c819110e$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $00a4cde6c819110e$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $00a4cde6c819110e$var$isThenableResolved(thrownValue) ? ($00a4cde6c819110e$var$workInProgressSuspendedReason = 0, $00a4cde6c819110e$var$workInProgressThrownValue = null, $00a4cde6c819110e$var$replaySuspendedUnitOfWork(lanes)) : ($00a4cde6c819110e$var$workInProgressSuspendedReason = 0, $00a4cde6c819110e$var$workInProgressThrownValue = null, $00a4cde6c819110e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($00a4cde6c819110e$var$workInProgress.tag){
                        case 26:
                            resource = $00a4cde6c819110e$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $00a4cde6c819110e$var$workInProgress;
                            if (resource ? $00a4cde6c819110e$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $00a4cde6c819110e$var$workInProgressSuspendedReason = 0;
                                $00a4cde6c819110e$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $00a4cde6c819110e$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($00a4cde6c819110e$var$workInProgress = returnFiber, $00a4cde6c819110e$var$completeUnitOfWork(returnFiber)) : $00a4cde6c819110e$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $00a4cde6c819110e$var$workInProgressSuspendedReason = 0;
                    $00a4cde6c819110e$var$workInProgressThrownValue = null;
                    $00a4cde6c819110e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $00a4cde6c819110e$var$workInProgressSuspendedReason = 0;
                    $00a4cde6c819110e$var$workInProgressThrownValue = null;
                    $00a4cde6c819110e$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $00a4cde6c819110e$var$resetWorkInProgressStack();
                    $00a4cde6c819110e$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(462));
            }
        }
        $00a4cde6c819110e$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $00a4cde6c819110e$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $00a4cde6c819110e$var$lastContextDependency = $00a4cde6c819110e$var$currentlyRenderingFiber$1 = null;
    $00a4cde6c819110e$var$ReactSharedInternals.H = prevDispatcher;
    $00a4cde6c819110e$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $00a4cde6c819110e$var$executionContext = prevExecutionContext;
    if (null !== $00a4cde6c819110e$var$workInProgress) return 0;
    $00a4cde6c819110e$var$workInProgressRoot = null;
    $00a4cde6c819110e$var$workInProgressRootRenderLanes = 0;
    $00a4cde6c819110e$var$finishQueueingConcurrentUpdates();
    return $00a4cde6c819110e$var$workInProgressRootExitStatus;
}
function $00a4cde6c819110e$var$workLoopConcurrentByScheduler() {
    for(; null !== $00a4cde6c819110e$var$workInProgress && !$00a4cde6c819110e$var$shouldYield();)$00a4cde6c819110e$var$performUnitOfWork($00a4cde6c819110e$var$workInProgress);
}
function $00a4cde6c819110e$var$performUnitOfWork(unitOfWork) {
    var next = $00a4cde6c819110e$var$beginWork(unitOfWork.alternate, unitOfWork, $00a4cde6c819110e$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $00a4cde6c819110e$var$completeUnitOfWork(unitOfWork) : $00a4cde6c819110e$var$workInProgress = next;
}
function $00a4cde6c819110e$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $00a4cde6c819110e$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $00a4cde6c819110e$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $00a4cde6c819110e$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $00a4cde6c819110e$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $00a4cde6c819110e$var$resetHooksOnUnwind(next);
        default:
            $00a4cde6c819110e$var$unwindInterruptedWork(current, next), next = $00a4cde6c819110e$var$workInProgress = $00a4cde6c819110e$var$resetWorkInProgress(next, $00a4cde6c819110e$var$entangledRenderLanes), next = $00a4cde6c819110e$var$beginWork(current, next, $00a4cde6c819110e$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $00a4cde6c819110e$var$completeUnitOfWork(unitOfWork) : $00a4cde6c819110e$var$workInProgress = next;
}
function $00a4cde6c819110e$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $00a4cde6c819110e$var$lastContextDependency = $00a4cde6c819110e$var$currentlyRenderingFiber$1 = null;
    $00a4cde6c819110e$var$resetHooksOnUnwind(unitOfWork);
    $00a4cde6c819110e$var$thenableState$1 = null;
    $00a4cde6c819110e$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($00a4cde6c819110e$var$throwException(root, returnFiber, unitOfWork, thrownValue, $00a4cde6c819110e$var$workInProgressRootRenderLanes)) {
            $00a4cde6c819110e$var$workInProgressRootExitStatus = 1;
            $00a4cde6c819110e$var$logUncaughtError(root, $00a4cde6c819110e$var$createCapturedValueAtFiber(thrownValue, root.current));
            $00a4cde6c819110e$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $00a4cde6c819110e$var$workInProgress = returnFiber, error;
        $00a4cde6c819110e$var$workInProgressRootExitStatus = 1;
        $00a4cde6c819110e$var$logUncaughtError(root, $00a4cde6c819110e$var$createCapturedValueAtFiber(thrownValue, root.current));
        $00a4cde6c819110e$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($00a4cde6c819110e$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($00a4cde6c819110e$var$workInProgressRootIsPrerendering || 0 !== ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $00a4cde6c819110e$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $00a4cde6c819110e$var$unwindUnitOfWork(unitOfWork, root);
    } else $00a4cde6c819110e$var$completeUnitOfWork(unitOfWork);
}
function $00a4cde6c819110e$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $00a4cde6c819110e$var$unwindUnitOfWork(completedWork, $00a4cde6c819110e$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $00a4cde6c819110e$var$completeWork(completedWork.alternate, completedWork, $00a4cde6c819110e$var$entangledRenderLanes);
        if (null !== next) {
            $00a4cde6c819110e$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $00a4cde6c819110e$var$workInProgress = completedWork;
            return;
        }
        $00a4cde6c819110e$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $00a4cde6c819110e$var$workInProgressRootExitStatus && ($00a4cde6c819110e$var$workInProgressRootExitStatus = 5);
}
function $00a4cde6c819110e$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $00a4cde6c819110e$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $00a4cde6c819110e$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $00a4cde6c819110e$var$workInProgress = unitOfWork;
            return;
        }
        $00a4cde6c819110e$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $00a4cde6c819110e$var$workInProgressRootExitStatus = 6;
    $00a4cde6c819110e$var$workInProgress = null;
}
function $00a4cde6c819110e$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $00a4cde6c819110e$var$flushPendingEffects();
    while (0 !== $00a4cde6c819110e$var$pendingEffectsStatus);
    if (0 !== ($00a4cde6c819110e$var$executionContext & 6)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $00a4cde6c819110e$var$concurrentlyUpdatedLanes;
        $00a4cde6c819110e$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $00a4cde6c819110e$var$workInProgressRoot && ($00a4cde6c819110e$var$workInProgress = $00a4cde6c819110e$var$workInProgressRoot = null, $00a4cde6c819110e$var$workInProgressRootRenderLanes = 0);
        $00a4cde6c819110e$var$pendingFinishedWork = finishedWork;
        $00a4cde6c819110e$var$pendingEffectsRoot = root;
        $00a4cde6c819110e$var$pendingEffectsLanes = lanes;
        $00a4cde6c819110e$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $00a4cde6c819110e$var$pendingPassiveTransitions = transitions;
        $00a4cde6c819110e$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $00a4cde6c819110e$var$scheduleCallback$1($00a4cde6c819110e$var$NormalPriority$1, function() {
            $00a4cde6c819110e$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $00a4cde6c819110e$var$ReactSharedInternals.T;
            $00a4cde6c819110e$var$ReactSharedInternals.T = null;
            transitions = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
            $00a4cde6c819110e$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $00a4cde6c819110e$var$executionContext;
            $00a4cde6c819110e$var$executionContext |= 4;
            try {
                $00a4cde6c819110e$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $00a4cde6c819110e$var$executionContext = spawnedLane, $00a4cde6c819110e$var$ReactDOMSharedInternals.p = transitions, $00a4cde6c819110e$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $00a4cde6c819110e$var$pendingEffectsStatus = 1;
        $00a4cde6c819110e$var$flushMutationEffects();
        $00a4cde6c819110e$var$flushLayoutEffects();
        $00a4cde6c819110e$var$flushSpawnedWork();
    }
}
function $00a4cde6c819110e$var$flushMutationEffects() {
    if (1 === $00a4cde6c819110e$var$pendingEffectsStatus) {
        $00a4cde6c819110e$var$pendingEffectsStatus = 0;
        var root = $00a4cde6c819110e$var$pendingEffectsRoot, finishedWork = $00a4cde6c819110e$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $00a4cde6c819110e$var$ReactSharedInternals.T;
            $00a4cde6c819110e$var$ReactSharedInternals.T = null;
            var previousPriority = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
            $00a4cde6c819110e$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $00a4cde6c819110e$var$executionContext;
            $00a4cde6c819110e$var$executionContext |= 4;
            try {
                $00a4cde6c819110e$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $00a4cde6c819110e$var$selectionInformation, curFocusedElem = $00a4cde6c819110e$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $00a4cde6c819110e$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $00a4cde6c819110e$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $00a4cde6c819110e$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $00a4cde6c819110e$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $00a4cde6c819110e$var$_enabled = !!$00a4cde6c819110e$var$eventsEnabled;
                $00a4cde6c819110e$var$selectionInformation = $00a4cde6c819110e$var$eventsEnabled = null;
            } finally{
                $00a4cde6c819110e$var$executionContext = prevExecutionContext, $00a4cde6c819110e$var$ReactDOMSharedInternals.p = previousPriority, $00a4cde6c819110e$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $00a4cde6c819110e$var$pendingEffectsStatus = 2;
    }
}
function $00a4cde6c819110e$var$flushLayoutEffects() {
    if (2 === $00a4cde6c819110e$var$pendingEffectsStatus) {
        $00a4cde6c819110e$var$pendingEffectsStatus = 0;
        var root = $00a4cde6c819110e$var$pendingEffectsRoot, finishedWork = $00a4cde6c819110e$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $00a4cde6c819110e$var$ReactSharedInternals.T;
            $00a4cde6c819110e$var$ReactSharedInternals.T = null;
            var previousPriority = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
            $00a4cde6c819110e$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $00a4cde6c819110e$var$executionContext;
            $00a4cde6c819110e$var$executionContext |= 4;
            try {
                $00a4cde6c819110e$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $00a4cde6c819110e$var$executionContext = prevExecutionContext, $00a4cde6c819110e$var$ReactDOMSharedInternals.p = previousPriority, $00a4cde6c819110e$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $00a4cde6c819110e$var$pendingEffectsStatus = 3;
    }
}
function $00a4cde6c819110e$var$flushSpawnedWork() {
    if (4 === $00a4cde6c819110e$var$pendingEffectsStatus || 3 === $00a4cde6c819110e$var$pendingEffectsStatus) {
        $00a4cde6c819110e$var$pendingEffectsStatus = 0;
        $00a4cde6c819110e$var$requestPaint();
        var root = $00a4cde6c819110e$var$pendingEffectsRoot, finishedWork = $00a4cde6c819110e$var$pendingFinishedWork, lanes = $00a4cde6c819110e$var$pendingEffectsLanes, recoverableErrors = $00a4cde6c819110e$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $00a4cde6c819110e$var$pendingEffectsStatus = 5 : ($00a4cde6c819110e$var$pendingEffectsStatus = 0, $00a4cde6c819110e$var$pendingFinishedWork = $00a4cde6c819110e$var$pendingEffectsRoot = null, $00a4cde6c819110e$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $00a4cde6c819110e$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($00a4cde6c819110e$var$injectedHook && "function" === typeof $00a4cde6c819110e$var$injectedHook.onCommitFiberRoot) try {
            $00a4cde6c819110e$var$injectedHook.onCommitFiberRoot($00a4cde6c819110e$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $00a4cde6c819110e$var$ReactSharedInternals.T;
            remainingLanes = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
            $00a4cde6c819110e$var$ReactDOMSharedInternals.p = 2;
            $00a4cde6c819110e$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $00a4cde6c819110e$var$ReactSharedInternals.T = finishedWork, $00a4cde6c819110e$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($00a4cde6c819110e$var$pendingEffectsLanes & 3) && $00a4cde6c819110e$var$flushPendingEffects();
        $00a4cde6c819110e$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $00a4cde6c819110e$var$rootWithNestedUpdates ? $00a4cde6c819110e$var$nestedUpdateCount++ : ($00a4cde6c819110e$var$nestedUpdateCount = 0, $00a4cde6c819110e$var$rootWithNestedUpdates = root) : $00a4cde6c819110e$var$nestedUpdateCount = 0;
        $00a4cde6c819110e$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $00a4cde6c819110e$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $00a4cde6c819110e$var$releaseCache(remainingLanes)));
}
function $00a4cde6c819110e$var$flushPendingEffects() {
    $00a4cde6c819110e$var$flushMutationEffects();
    $00a4cde6c819110e$var$flushLayoutEffects();
    $00a4cde6c819110e$var$flushSpawnedWork();
    return $00a4cde6c819110e$var$flushPassiveEffects();
}
function $00a4cde6c819110e$var$flushPassiveEffects() {
    if (5 !== $00a4cde6c819110e$var$pendingEffectsStatus) return !1;
    var root = $00a4cde6c819110e$var$pendingEffectsRoot, remainingLanes = $00a4cde6c819110e$var$pendingEffectsRemainingLanes;
    $00a4cde6c819110e$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $00a4cde6c819110e$var$lanesToEventPriority($00a4cde6c819110e$var$pendingEffectsLanes), prevTransition = $00a4cde6c819110e$var$ReactSharedInternals.T, previousPriority = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
    try {
        $00a4cde6c819110e$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $00a4cde6c819110e$var$ReactSharedInternals.T = null;
        renderPriority = $00a4cde6c819110e$var$pendingPassiveTransitions;
        $00a4cde6c819110e$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $00a4cde6c819110e$var$pendingEffectsRoot, lanes = $00a4cde6c819110e$var$pendingEffectsLanes;
        $00a4cde6c819110e$var$pendingEffectsStatus = 0;
        $00a4cde6c819110e$var$pendingFinishedWork = $00a4cde6c819110e$var$pendingEffectsRoot = null;
        $00a4cde6c819110e$var$pendingEffectsLanes = 0;
        if (0 !== ($00a4cde6c819110e$var$executionContext & 6)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(331));
        var prevExecutionContext = $00a4cde6c819110e$var$executionContext;
        $00a4cde6c819110e$var$executionContext |= 4;
        $00a4cde6c819110e$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $00a4cde6c819110e$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $00a4cde6c819110e$var$executionContext = prevExecutionContext;
        $00a4cde6c819110e$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($00a4cde6c819110e$var$injectedHook && "function" === typeof $00a4cde6c819110e$var$injectedHook.onPostCommitFiberRoot) try {
            $00a4cde6c819110e$var$injectedHook.onPostCommitFiberRoot($00a4cde6c819110e$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $00a4cde6c819110e$var$ReactDOMSharedInternals.p = previousPriority, $00a4cde6c819110e$var$ReactSharedInternals.T = prevTransition, $00a4cde6c819110e$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $00a4cde6c819110e$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $00a4cde6c819110e$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $00a4cde6c819110e$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $00a4cde6c819110e$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($00a4cde6c819110e$var$markRootUpdated$1(rootFiber, 2), $00a4cde6c819110e$var$ensureRootIsScheduled(rootFiber));
}
function $00a4cde6c819110e$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $00a4cde6c819110e$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $00a4cde6c819110e$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed || !$00a4cde6c819110e$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $00a4cde6c819110e$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $00a4cde6c819110e$var$createClassErrorUpdate(2);
                instance = $00a4cde6c819110e$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($00a4cde6c819110e$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $00a4cde6c819110e$var$markRootUpdated$1(instance, 2), $00a4cde6c819110e$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $00a4cde6c819110e$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $00a4cde6c819110e$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($00a4cde6c819110e$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $00a4cde6c819110e$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $00a4cde6c819110e$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $00a4cde6c819110e$var$workInProgressRoot === root && ($00a4cde6c819110e$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $00a4cde6c819110e$var$workInProgressRootExitStatus || 3 === $00a4cde6c819110e$var$workInProgressRootExitStatus && ($00a4cde6c819110e$var$workInProgressRootRenderLanes & 62914560) === $00a4cde6c819110e$var$workInProgressRootRenderLanes && 300 > $00a4cde6c819110e$var$now() - $00a4cde6c819110e$var$globalMostRecentFallbackTime ? 0 === ($00a4cde6c819110e$var$executionContext & 2) && $00a4cde6c819110e$var$prepareFreshStack(root, 0) : $00a4cde6c819110e$var$workInProgressRootPingedLanes |= pingedLanes, $00a4cde6c819110e$var$workInProgressSuspendedRetryLanes === $00a4cde6c819110e$var$workInProgressRootRenderLanes && ($00a4cde6c819110e$var$workInProgressSuspendedRetryLanes = 0));
    $00a4cde6c819110e$var$ensureRootIsScheduled(root);
}
function $00a4cde6c819110e$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $00a4cde6c819110e$var$claimNextRetryLane());
    boundaryFiber = $00a4cde6c819110e$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($00a4cde6c819110e$var$markRootUpdated$1(boundaryFiber, retryLane), $00a4cde6c819110e$var$ensureRootIsScheduled(boundaryFiber));
}
function $00a4cde6c819110e$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $00a4cde6c819110e$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $00a4cde6c819110e$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($00a4cde6c819110e$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $00a4cde6c819110e$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $00a4cde6c819110e$var$scheduleCallback$1(priorityLevel, callback) {
    return $00a4cde6c819110e$var$scheduleCallback$3(priorityLevel, callback);
}
var $00a4cde6c819110e$var$firstScheduledRoot = null, $00a4cde6c819110e$var$lastScheduledRoot = null, $00a4cde6c819110e$var$didScheduleMicrotask = !1, $00a4cde6c819110e$var$mightHavePendingSyncWork = !1, $00a4cde6c819110e$var$isFlushingWork = !1, $00a4cde6c819110e$var$currentEventTransitionLane = 0;
function $00a4cde6c819110e$var$ensureRootIsScheduled(root) {
    root !== $00a4cde6c819110e$var$lastScheduledRoot && null === root.next && (null === $00a4cde6c819110e$var$lastScheduledRoot ? $00a4cde6c819110e$var$firstScheduledRoot = $00a4cde6c819110e$var$lastScheduledRoot = root : $00a4cde6c819110e$var$lastScheduledRoot = $00a4cde6c819110e$var$lastScheduledRoot.next = root);
    $00a4cde6c819110e$var$mightHavePendingSyncWork = !0;
    $00a4cde6c819110e$var$didScheduleMicrotask || ($00a4cde6c819110e$var$didScheduleMicrotask = !0, $00a4cde6c819110e$var$scheduleImmediateRootScheduleTask());
}
function $00a4cde6c819110e$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$00a4cde6c819110e$var$isFlushingWork && $00a4cde6c819110e$var$mightHavePendingSyncWork) {
        $00a4cde6c819110e$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $00a4cde6c819110e$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $00a4cde6c819110e$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $00a4cde6c819110e$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $00a4cde6c819110e$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $00a4cde6c819110e$var$getNextLanes(root$170, root$170 === $00a4cde6c819110e$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $00a4cde6c819110e$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $00a4cde6c819110e$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $00a4cde6c819110e$var$isFlushingWork = !1;
    }
}
function $00a4cde6c819110e$var$processRootScheduleInImmediateTask() {
    $00a4cde6c819110e$var$processRootScheduleInMicrotask();
}
function $00a4cde6c819110e$var$processRootScheduleInMicrotask() {
    $00a4cde6c819110e$var$mightHavePendingSyncWork = $00a4cde6c819110e$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $00a4cde6c819110e$var$currentEventTransitionLane && $00a4cde6c819110e$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $00a4cde6c819110e$var$currentEventTransitionLane);
    for(var currentTime = $00a4cde6c819110e$var$now(), prev = null, root = $00a4cde6c819110e$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $00a4cde6c819110e$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $00a4cde6c819110e$var$firstScheduledRoot = next : prev.next = next, null === next && ($00a4cde6c819110e$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $00a4cde6c819110e$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $00a4cde6c819110e$var$pendingEffectsStatus && 5 !== $00a4cde6c819110e$var$pendingEffectsStatus || $00a4cde6c819110e$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $00a4cde6c819110e$var$currentEventTransitionLane && ($00a4cde6c819110e$var$currentEventTransitionLane = 0);
}
function $00a4cde6c819110e$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $00a4cde6c819110e$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $00a4cde6c819110e$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $00a4cde6c819110e$var$workInProgressRoot;
    suspendedLanes = $00a4cde6c819110e$var$workInProgressRootRenderLanes;
    suspendedLanes = $00a4cde6c819110e$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $00a4cde6c819110e$var$workInProgressSuspendedReason || 9 === $00a4cde6c819110e$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $00a4cde6c819110e$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $00a4cde6c819110e$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $00a4cde6c819110e$var$cancelCallback$1(pingedLanes);
        switch($00a4cde6c819110e$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $00a4cde6c819110e$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $00a4cde6c819110e$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $00a4cde6c819110e$var$IdlePriority;
                break;
            default:
                suspendedLanes = $00a4cde6c819110e$var$NormalPriority$1;
        }
        pingedLanes = $00a4cde6c819110e$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $00a4cde6c819110e$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $00a4cde6c819110e$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $00a4cde6c819110e$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $00a4cde6c819110e$var$pendingEffectsStatus && 5 !== $00a4cde6c819110e$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($00a4cde6c819110e$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $00a4cde6c819110e$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $00a4cde6c819110e$var$getNextLanes(root, root === $00a4cde6c819110e$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $00a4cde6c819110e$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $00a4cde6c819110e$var$scheduleTaskForRootDuringMicrotask(root, $00a4cde6c819110e$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $00a4cde6c819110e$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $00a4cde6c819110e$var$performSyncWorkOnRoot(root, lanes) {
    if ($00a4cde6c819110e$var$flushPendingEffects()) return null;
    $00a4cde6c819110e$var$performWorkOnRoot(root, lanes, !0);
}
function $00a4cde6c819110e$var$scheduleImmediateRootScheduleTask() {
    $00a4cde6c819110e$var$scheduleMicrotask(function() {
        0 !== ($00a4cde6c819110e$var$executionContext & 6) ? $00a4cde6c819110e$var$scheduleCallback$3($00a4cde6c819110e$var$ImmediatePriority, $00a4cde6c819110e$var$processRootScheduleInImmediateTask) : $00a4cde6c819110e$var$processRootScheduleInMicrotask();
    });
}
function $00a4cde6c819110e$var$requestTransitionLane() {
    if (0 === $00a4cde6c819110e$var$currentEventTransitionLane) {
        var actionScopeLane = $00a4cde6c819110e$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $00a4cde6c819110e$var$nextTransitionUpdateLane, $00a4cde6c819110e$var$nextTransitionUpdateLane <<= 1, 0 === ($00a4cde6c819110e$var$nextTransitionUpdateLane & 261888) && ($00a4cde6c819110e$var$nextTransitionUpdateLane = 256));
        $00a4cde6c819110e$var$currentEventTransitionLane = actionScopeLane;
    }
    return $00a4cde6c819110e$var$currentEventTransitionLane;
}
function $00a4cde6c819110e$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $00a4cde6c819110e$var$sanitizeURL("" + actionProp);
}
function $00a4cde6c819110e$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $00a4cde6c819110e$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $00a4cde6c819110e$var$coerceFormActionProp((nativeEventTarget[$00a4cde6c819110e$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$00a4cde6c819110e$var$internalPropsKey] || null) ? $00a4cde6c819110e$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $00a4cde6c819110e$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $00a4cde6c819110e$var$currentEventTransitionLane) {
                                var formData = submitter ? $00a4cde6c819110e$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $00a4cde6c819110e$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $00a4cde6c819110e$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $00a4cde6c819110e$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $00a4cde6c819110e$var$i$jscomp$inline_1577 = 0; $00a4cde6c819110e$var$i$jscomp$inline_1577 < $00a4cde6c819110e$var$simpleEventPluginEvents.length; $00a4cde6c819110e$var$i$jscomp$inline_1577++){
    var $00a4cde6c819110e$var$eventName$jscomp$inline_1578 = $00a4cde6c819110e$var$simpleEventPluginEvents[$00a4cde6c819110e$var$i$jscomp$inline_1577], $00a4cde6c819110e$var$domEventName$jscomp$inline_1579 = $00a4cde6c819110e$var$eventName$jscomp$inline_1578.toLowerCase(), $00a4cde6c819110e$var$capitalizedEvent$jscomp$inline_1580 = $00a4cde6c819110e$var$eventName$jscomp$inline_1578[0].toUpperCase() + $00a4cde6c819110e$var$eventName$jscomp$inline_1578.slice(1);
    $00a4cde6c819110e$var$registerSimpleEvent($00a4cde6c819110e$var$domEventName$jscomp$inline_1579, "on" + $00a4cde6c819110e$var$capitalizedEvent$jscomp$inline_1580);
}
$00a4cde6c819110e$var$registerSimpleEvent($00a4cde6c819110e$var$ANIMATION_END, "onAnimationEnd");
$00a4cde6c819110e$var$registerSimpleEvent($00a4cde6c819110e$var$ANIMATION_ITERATION, "onAnimationIteration");
$00a4cde6c819110e$var$registerSimpleEvent($00a4cde6c819110e$var$ANIMATION_START, "onAnimationStart");
$00a4cde6c819110e$var$registerSimpleEvent("dblclick", "onDoubleClick");
$00a4cde6c819110e$var$registerSimpleEvent("focusin", "onFocus");
$00a4cde6c819110e$var$registerSimpleEvent("focusout", "onBlur");
$00a4cde6c819110e$var$registerSimpleEvent($00a4cde6c819110e$var$TRANSITION_RUN, "onTransitionRun");
$00a4cde6c819110e$var$registerSimpleEvent($00a4cde6c819110e$var$TRANSITION_START, "onTransitionStart");
$00a4cde6c819110e$var$registerSimpleEvent($00a4cde6c819110e$var$TRANSITION_CANCEL, "onTransitionCancel");
$00a4cde6c819110e$var$registerSimpleEvent($00a4cde6c819110e$var$TRANSITION_END, "onTransitionEnd");
$00a4cde6c819110e$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$00a4cde6c819110e$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$00a4cde6c819110e$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$00a4cde6c819110e$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$00a4cde6c819110e$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$00a4cde6c819110e$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$00a4cde6c819110e$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$00a4cde6c819110e$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$00a4cde6c819110e$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$00a4cde6c819110e$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $00a4cde6c819110e$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $00a4cde6c819110e$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($00a4cde6c819110e$var$mediaEventTypes));
function $00a4cde6c819110e$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $00a4cde6c819110e$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $00a4cde6c819110e$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $00a4cde6c819110e$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$00a4cde6c819110e$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$00a4cde6c819110e$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($00a4cde6c819110e$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $00a4cde6c819110e$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $00a4cde6c819110e$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $00a4cde6c819110e$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $00a4cde6c819110e$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$00a4cde6c819110e$var$listeningMarker]) {
        rootContainerElement[$00a4cde6c819110e$var$listeningMarker] = !0;
        $00a4cde6c819110e$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($00a4cde6c819110e$var$nonDelegatedEvents.has(domEventName) || $00a4cde6c819110e$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $00a4cde6c819110e$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$00a4cde6c819110e$var$listeningMarker] || (ownerDocument[$00a4cde6c819110e$var$listeningMarker] = !0, $00a4cde6c819110e$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $00a4cde6c819110e$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($00a4cde6c819110e$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $00a4cde6c819110e$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $00a4cde6c819110e$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $00a4cde6c819110e$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$00a4cde6c819110e$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $00a4cde6c819110e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $00a4cde6c819110e$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $00a4cde6c819110e$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $00a4cde6c819110e$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $00a4cde6c819110e$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $00a4cde6c819110e$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticTouchEvent;
                        break;
                    case $00a4cde6c819110e$var$ANIMATION_END:
                    case $00a4cde6c819110e$var$ANIMATION_ITERATION:
                    case $00a4cde6c819110e$var$ANIMATION_START:
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticAnimationEvent;
                        break;
                    case $00a4cde6c819110e$var$TRANSITION_END:
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $00a4cde6c819110e$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $00a4cde6c819110e$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($00a4cde6c819110e$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $00a4cde6c819110e$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($00a4cde6c819110e$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$00a4cde6c819110e$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $00a4cde6c819110e$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $00a4cde6c819110e$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $00a4cde6c819110e$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $00a4cde6c819110e$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $00a4cde6c819110e$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $00a4cde6c819110e$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $00a4cde6c819110e$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $00a4cde6c819110e$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $00a4cde6c819110e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $00a4cde6c819110e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $00a4cde6c819110e$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $00a4cde6c819110e$var$getTargetInstForChangeEvent;
                else if ($00a4cde6c819110e$var$isTextInputElement(reactName)) {
                    if ($00a4cde6c819110e$var$isInputEventSupported) getTargetInstFunc = $00a4cde6c819110e$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $00a4cde6c819110e$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $00a4cde6c819110e$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $00a4cde6c819110e$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $00a4cde6c819110e$var$getTargetInstForChangeEvent) : getTargetInstFunc = $00a4cde6c819110e$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $00a4cde6c819110e$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $00a4cde6c819110e$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $00a4cde6c819110e$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($00a4cde6c819110e$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $00a4cde6c819110e$var$activeElement = handleEventFunc, $00a4cde6c819110e$var$activeElementInst = targetInst, $00a4cde6c819110e$var$lastSelection = null;
                    break;
                case "focusout":
                    $00a4cde6c819110e$var$lastSelection = $00a4cde6c819110e$var$activeElementInst = $00a4cde6c819110e$var$activeElement = null;
                    break;
                case "mousedown":
                    $00a4cde6c819110e$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $00a4cde6c819110e$var$mouseDown = !1;
                    $00a4cde6c819110e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($00a4cde6c819110e$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $00a4cde6c819110e$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($00a4cde6c819110e$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $00a4cde6c819110e$var$isComposing ? $00a4cde6c819110e$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($00a4cde6c819110e$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($00a4cde6c819110e$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $00a4cde6c819110e$var$isComposing && (fallbackData = $00a4cde6c819110e$var$getData()) : ($00a4cde6c819110e$var$root = nativeEventTarget, $00a4cde6c819110e$var$startText = "value" in $00a4cde6c819110e$var$root ? $00a4cde6c819110e$var$root.value : $00a4cde6c819110e$var$root.textContent, $00a4cde6c819110e$var$isComposing = !0)), handleEventFunc = $00a4cde6c819110e$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $00a4cde6c819110e$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $00a4cde6c819110e$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $00a4cde6c819110e$var$canUseTextInputEvent ? $00a4cde6c819110e$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $00a4cde6c819110e$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $00a4cde6c819110e$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $00a4cde6c819110e$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $00a4cde6c819110e$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $00a4cde6c819110e$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $00a4cde6c819110e$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $00a4cde6c819110e$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $00a4cde6c819110e$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($00a4cde6c819110e$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $00a4cde6c819110e$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($00a4cde6c819110e$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $00a4cde6c819110e$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $00a4cde6c819110e$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $00a4cde6c819110e$var$getListener(target, registrationName), null != stateNode && listeners.unshift($00a4cde6c819110e$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $00a4cde6c819110e$var$getListener(target, registrationName), null != stateNode && listeners.push($00a4cde6c819110e$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $00a4cde6c819110e$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $00a4cde6c819110e$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $00a4cde6c819110e$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($00a4cde6c819110e$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($00a4cde6c819110e$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $00a4cde6c819110e$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $00a4cde6c819110e$var$normalizeMarkupForTextOrAttribute(clientText);
    return $00a4cde6c819110e$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $00a4cde6c819110e$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $00a4cde6c819110e$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $00a4cde6c819110e$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $00a4cde6c819110e$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $00a4cde6c819110e$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $00a4cde6c819110e$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $00a4cde6c819110e$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $00a4cde6c819110e$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $00a4cde6c819110e$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $00a4cde6c819110e$var$setProp(domElement, tag, "name", props.name, props, null), $00a4cde6c819110e$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $00a4cde6c819110e$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $00a4cde6c819110e$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($00a4cde6c819110e$var$setProp(domElement, tag, "encType", props.encType, props, null), $00a4cde6c819110e$var$setProp(domElement, tag, "method", props.method, props, null), $00a4cde6c819110e$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $00a4cde6c819110e$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $00a4cde6c819110e$var$noop$1);
            break;
        case "onScroll":
            null != value && $00a4cde6c819110e$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $00a4cde6c819110e$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $00a4cde6c819110e$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("toggle", domElement);
            $00a4cde6c819110e$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $00a4cde6c819110e$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $00a4cde6c819110e$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $00a4cde6c819110e$var$aliases.get(key) || key, $00a4cde6c819110e$var$setValueForAttribute(domElement, key, value);
    }
}
function $00a4cde6c819110e$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $00a4cde6c819110e$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $00a4cde6c819110e$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $00a4cde6c819110e$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $00a4cde6c819110e$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $00a4cde6c819110e$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $00a4cde6c819110e$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$00a4cde6c819110e$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$00a4cde6c819110e$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $00a4cde6c819110e$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $00a4cde6c819110e$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("error", domElement);
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($00a4cde6c819110e$var$formatProdErrorMessage(137, tag));
                    default:
                        $00a4cde6c819110e$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $00a4cde6c819110e$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $00a4cde6c819110e$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $00a4cde6c819110e$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $00a4cde6c819110e$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $00a4cde6c819110e$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $00a4cde6c819110e$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $00a4cde6c819110e$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(91));
                    break;
                default:
                    $00a4cde6c819110e$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $00a4cde6c819110e$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $00a4cde6c819110e$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("toggle", domElement);
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("cancel", domElement);
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $00a4cde6c819110e$var$mediaEventTypes.length; hasSrc++)$00a4cde6c819110e$var$listenToNonDelegatedEvent($00a4cde6c819110e$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("error", domElement);
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $00a4cde6c819110e$var$listenToNonDelegatedEvent("error", domElement), $00a4cde6c819110e$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($00a4cde6c819110e$var$formatProdErrorMessage(137, tag));
                default:
                    $00a4cde6c819110e$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($00a4cde6c819110e$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $00a4cde6c819110e$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $00a4cde6c819110e$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $00a4cde6c819110e$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $00a4cde6c819110e$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $00a4cde6c819110e$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $00a4cde6c819110e$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $00a4cde6c819110e$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $00a4cde6c819110e$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $00a4cde6c819110e$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $00a4cde6c819110e$var$updateOptions(domElement, !!lastProps, tag, !0) : $00a4cde6c819110e$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $00a4cde6c819110e$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $00a4cde6c819110e$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $00a4cde6c819110e$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $00a4cde6c819110e$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $00a4cde6c819110e$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $00a4cde6c819110e$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $00a4cde6c819110e$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($00a4cde6c819110e$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $00a4cde6c819110e$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $00a4cde6c819110e$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $00a4cde6c819110e$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $00a4cde6c819110e$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $00a4cde6c819110e$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $00a4cde6c819110e$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $00a4cde6c819110e$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $00a4cde6c819110e$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $00a4cde6c819110e$var$eventsEnabled = null, $00a4cde6c819110e$var$selectionInformation = null;
function $00a4cde6c819110e$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $00a4cde6c819110e$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $00a4cde6c819110e$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $00a4cde6c819110e$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $00a4cde6c819110e$var$currentPopstateTransitionEvent = null;
function $00a4cde6c819110e$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $00a4cde6c819110e$var$currentPopstateTransitionEvent) return !1;
        $00a4cde6c819110e$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $00a4cde6c819110e$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $00a4cde6c819110e$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $00a4cde6c819110e$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $00a4cde6c819110e$var$localPromise = "function" === typeof Promise ? Promise : void 0, $00a4cde6c819110e$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $00a4cde6c819110e$var$localPromise ? function(callback) {
    return $00a4cde6c819110e$var$localPromise.resolve(null).then(callback).catch($00a4cde6c819110e$var$handleErrorInNextTick);
} : $00a4cde6c819110e$var$scheduleTimeout;
function $00a4cde6c819110e$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $00a4cde6c819110e$var$isSingletonScope(type) {
    return "head" === type;
}
function $00a4cde6c819110e$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $00a4cde6c819110e$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $00a4cde6c819110e$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $00a4cde6c819110e$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$00a4cde6c819110e$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $00a4cde6c819110e$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $00a4cde6c819110e$var$retryIfBlockedOn(hydrationInstance);
}
function $00a4cde6c819110e$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $00a4cde6c819110e$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $00a4cde6c819110e$var$clearContainerSparingly(node);
                $00a4cde6c819110e$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $00a4cde6c819110e$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$00a4cde6c819110e$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $00a4cde6c819110e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $00a4cde6c819110e$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $00a4cde6c819110e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $00a4cde6c819110e$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $00a4cde6c819110e$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $00a4cde6c819110e$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $00a4cde6c819110e$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $00a4cde6c819110e$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $00a4cde6c819110e$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $00a4cde6c819110e$var$previousHydratableOnEnteringScopedSingleton = null;
function $00a4cde6c819110e$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $00a4cde6c819110e$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $00a4cde6c819110e$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $00a4cde6c819110e$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $00a4cde6c819110e$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($00a4cde6c819110e$var$formatProdErrorMessage(451));
    }
}
function $00a4cde6c819110e$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $00a4cde6c819110e$var$detachDeletedInstance(instance);
}
var $00a4cde6c819110e$var$preloadPropsMap = new Map(), $00a4cde6c819110e$var$preconnectsSet = new Set();
function $00a4cde6c819110e$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $00a4cde6c819110e$var$previousDispatcher = $00a4cde6c819110e$var$ReactDOMSharedInternals.d;
$00a4cde6c819110e$var$ReactDOMSharedInternals.d = {
    f: $00a4cde6c819110e$var$flushSyncWork,
    r: $00a4cde6c819110e$var$requestFormReset,
    D: $00a4cde6c819110e$var$prefetchDNS,
    C: $00a4cde6c819110e$var$preconnect,
    L: $00a4cde6c819110e$var$preload,
    m: $00a4cde6c819110e$var$preloadModule,
    X: $00a4cde6c819110e$var$preinitScript,
    S: $00a4cde6c819110e$var$preinitStyle,
    M: $00a4cde6c819110e$var$preinitModuleScript
};
function $00a4cde6c819110e$var$flushSyncWork() {
    var previousWasRendering = $00a4cde6c819110e$var$previousDispatcher.f(), wasRendering = $00a4cde6c819110e$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $00a4cde6c819110e$var$requestFormReset(form) {
    var formInst = $00a4cde6c819110e$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $00a4cde6c819110e$var$requestFormReset$1(formInst) : $00a4cde6c819110e$var$previousDispatcher.r(form);
}
var $00a4cde6c819110e$var$globalDocument = "undefined" === typeof document ? null : document;
function $00a4cde6c819110e$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $00a4cde6c819110e$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $00a4cde6c819110e$var$preconnectsSet.has(limitedEscapedHref) || ($00a4cde6c819110e$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $00a4cde6c819110e$var$setInitialProperties(href, "link", rel), $00a4cde6c819110e$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $00a4cde6c819110e$var$prefetchDNS(href) {
    $00a4cde6c819110e$var$previousDispatcher.D(href);
    $00a4cde6c819110e$var$preconnectAs("dns-prefetch", href, null);
}
function $00a4cde6c819110e$var$preconnect(href, crossOrigin) {
    $00a4cde6c819110e$var$previousDispatcher.C(href, crossOrigin);
    $00a4cde6c819110e$var$preconnectAs("preconnect", href, crossOrigin);
}
function $00a4cde6c819110e$var$preload(href, as, options) {
    $00a4cde6c819110e$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $00a4cde6c819110e$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $00a4cde6c819110e$var$getStyleKey(href);
                break;
            case "script":
                key = $00a4cde6c819110e$var$getScriptKey(href);
        }
        $00a4cde6c819110e$var$preloadPropsMap.has(key) || (href = $00a4cde6c819110e$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $00a4cde6c819110e$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($00a4cde6c819110e$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($00a4cde6c819110e$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $00a4cde6c819110e$var$setInitialProperties(as, "link", href), $00a4cde6c819110e$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $00a4cde6c819110e$var$preloadModule(href, options) {
    $00a4cde6c819110e$var$previousDispatcher.m(href, options);
    var ownerDocument = $00a4cde6c819110e$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $00a4cde6c819110e$var$getScriptKey(href);
        }
        if (!$00a4cde6c819110e$var$preloadPropsMap.has(key) && (href = $00a4cde6c819110e$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $00a4cde6c819110e$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($00a4cde6c819110e$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $00a4cde6c819110e$var$setInitialProperties(as, "link", href);
            $00a4cde6c819110e$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $00a4cde6c819110e$var$preinitStyle(href, precedence, options) {
    $00a4cde6c819110e$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $00a4cde6c819110e$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $00a4cde6c819110e$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $00a4cde6c819110e$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($00a4cde6c819110e$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $00a4cde6c819110e$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $00a4cde6c819110e$var$preloadPropsMap.get(key)) && $00a4cde6c819110e$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $00a4cde6c819110e$var$markNodeAsHoistable(link);
                $00a4cde6c819110e$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $00a4cde6c819110e$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $00a4cde6c819110e$var$preinitScript(src, options) {
    $00a4cde6c819110e$var$previousDispatcher.X(src, options);
    var ownerDocument = $00a4cde6c819110e$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $00a4cde6c819110e$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $00a4cde6c819110e$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($00a4cde6c819110e$var$getScriptSelectorFromKey(key)), resource || (src = $00a4cde6c819110e$var$assign({
            src: src,
            async: !0
        }, options), (options = $00a4cde6c819110e$var$preloadPropsMap.get(key)) && $00a4cde6c819110e$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $00a4cde6c819110e$var$markNodeAsHoistable(resource), $00a4cde6c819110e$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $00a4cde6c819110e$var$preinitModuleScript(src, options) {
    $00a4cde6c819110e$var$previousDispatcher.M(src, options);
    var ownerDocument = $00a4cde6c819110e$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $00a4cde6c819110e$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $00a4cde6c819110e$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($00a4cde6c819110e$var$getScriptSelectorFromKey(key)), resource || (src = $00a4cde6c819110e$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $00a4cde6c819110e$var$preloadPropsMap.get(key)) && $00a4cde6c819110e$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $00a4cde6c819110e$var$markNodeAsHoistable(resource), $00a4cde6c819110e$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $00a4cde6c819110e$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $00a4cde6c819110e$var$rootInstanceStackCursor.current) ? $00a4cde6c819110e$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $00a4cde6c819110e$var$getStyleKey(pendingProps.href), pendingProps = $00a4cde6c819110e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $00a4cde6c819110e$var$getStyleKey(pendingProps.href);
                var styles$243 = $00a4cde6c819110e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($00a4cde6c819110e$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $00a4cde6c819110e$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $00a4cde6c819110e$var$preloadPropsMap.set(type, pendingProps), styles$243 || $00a4cde6c819110e$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $00a4cde6c819110e$var$getScriptKey(pendingProps), pendingProps = $00a4cde6c819110e$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($00a4cde6c819110e$var$formatProdErrorMessage(444, type));
    }
}
function $00a4cde6c819110e$var$getStyleKey(href) {
    return 'href="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $00a4cde6c819110e$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $00a4cde6c819110e$var$stylesheetPropsFromRawProps(rawProps) {
    return $00a4cde6c819110e$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $00a4cde6c819110e$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $00a4cde6c819110e$var$setInitialProperties(key, "link", preloadProps), $00a4cde6c819110e$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $00a4cde6c819110e$var$getScriptKey(src) {
    return '[src="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $00a4cde6c819110e$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $00a4cde6c819110e$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $00a4cde6c819110e$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $00a4cde6c819110e$var$markNodeAsHoistable(instance), instance;
            var styleProps = $00a4cde6c819110e$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $00a4cde6c819110e$var$markNodeAsHoistable(instance);
            $00a4cde6c819110e$var$setInitialProperties(instance, "style", styleProps);
            $00a4cde6c819110e$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $00a4cde6c819110e$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($00a4cde6c819110e$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $00a4cde6c819110e$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $00a4cde6c819110e$var$stylesheetPropsFromRawProps(props);
            (styleProps = $00a4cde6c819110e$var$preloadPropsMap.get(styleProps)) && $00a4cde6c819110e$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $00a4cde6c819110e$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $00a4cde6c819110e$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $00a4cde6c819110e$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $00a4cde6c819110e$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($00a4cde6c819110e$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $00a4cde6c819110e$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $00a4cde6c819110e$var$preloadPropsMap.get(instance$249)) instance = $00a4cde6c819110e$var$assign({}, props), $00a4cde6c819110e$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $00a4cde6c819110e$var$markNodeAsHoistable(styleProps);
            $00a4cde6c819110e$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($00a4cde6c819110e$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $00a4cde6c819110e$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $00a4cde6c819110e$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $00a4cde6c819110e$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $00a4cde6c819110e$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $00a4cde6c819110e$var$tagCaches = null;
function $00a4cde6c819110e$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $00a4cde6c819110e$var$tagCaches) {
        var cache = new Map();
        var caches = $00a4cde6c819110e$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $00a4cde6c819110e$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$00a4cde6c819110e$var$internalHoistableMarker] || node[$00a4cde6c819110e$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $00a4cde6c819110e$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $00a4cde6c819110e$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $00a4cde6c819110e$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $00a4cde6c819110e$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $00a4cde6c819110e$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($00a4cde6c819110e$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $00a4cde6c819110e$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $00a4cde6c819110e$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $00a4cde6c819110e$var$stylesheetPropsFromRawProps(props);
            (key = $00a4cde6c819110e$var$preloadPropsMap.get(key)) && $00a4cde6c819110e$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $00a4cde6c819110e$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $00a4cde6c819110e$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $00a4cde6c819110e$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $00a4cde6c819110e$var$estimatedBytesWithinLimit = 0;
function $00a4cde6c819110e$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $00a4cde6c819110e$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $00a4cde6c819110e$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $00a4cde6c819110e$var$estimatedBytesWithinLimit && ($00a4cde6c819110e$var$estimatedBytesWithinLimit = 62500 * $00a4cde6c819110e$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $00a4cde6c819110e$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $00a4cde6c819110e$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $00a4cde6c819110e$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $00a4cde6c819110e$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $00a4cde6c819110e$var$precedencesByRoot = null;
function $00a4cde6c819110e$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $00a4cde6c819110e$var$precedencesByRoot = new Map(), resources.forEach($00a4cde6c819110e$var$insertStylesheetIntoRoot, state), $00a4cde6c819110e$var$precedencesByRoot = null, $00a4cde6c819110e$var$onUnsuspend.call(state));
}
function $00a4cde6c819110e$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $00a4cde6c819110e$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $00a4cde6c819110e$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $00a4cde6c819110e$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $00a4cde6c819110e$var$HostTransitionContext = {
    $$typeof: $00a4cde6c819110e$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $00a4cde6c819110e$var$sharedNotPendingObject,
    _currentValue2: $00a4cde6c819110e$var$sharedNotPendingObject,
    _threadCount: 0
};
function $00a4cde6c819110e$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $00a4cde6c819110e$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $00a4cde6c819110e$var$createLaneMap(0);
    this.hiddenUpdates = $00a4cde6c819110e$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $00a4cde6c819110e$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $00a4cde6c819110e$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $00a4cde6c819110e$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $00a4cde6c819110e$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $00a4cde6c819110e$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $00a4cde6c819110e$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $00a4cde6c819110e$var$emptyContextObject;
    parentComponent = $00a4cde6c819110e$var$emptyContextObject;
    return parentComponent;
}
function $00a4cde6c819110e$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $00a4cde6c819110e$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $00a4cde6c819110e$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $00a4cde6c819110e$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($00a4cde6c819110e$var$scheduleUpdateOnFiber(element, rootFiber, lane), $00a4cde6c819110e$var$entangleTransitions(element, rootFiber, lane));
}
function $00a4cde6c819110e$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $00a4cde6c819110e$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $00a4cde6c819110e$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $00a4cde6c819110e$var$markRetryLaneImpl(fiber, retryLane);
}
function $00a4cde6c819110e$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $00a4cde6c819110e$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $00a4cde6c819110e$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $00a4cde6c819110e$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $00a4cde6c819110e$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $00a4cde6c819110e$var$requestUpdateLane();
        lane = $00a4cde6c819110e$var$getBumpedLaneForHydrationByLane(lane);
        var root = $00a4cde6c819110e$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $00a4cde6c819110e$var$scheduleUpdateOnFiber(root, fiber, lane);
        $00a4cde6c819110e$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $00a4cde6c819110e$var$_enabled = !0;
function $00a4cde6c819110e$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $00a4cde6c819110e$var$ReactSharedInternals.T;
    $00a4cde6c819110e$var$ReactSharedInternals.T = null;
    var previousPriority = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
    try {
        $00a4cde6c819110e$var$ReactDOMSharedInternals.p = 2, $00a4cde6c819110e$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $00a4cde6c819110e$var$ReactDOMSharedInternals.p = previousPriority, $00a4cde6c819110e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00a4cde6c819110e$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $00a4cde6c819110e$var$ReactSharedInternals.T;
    $00a4cde6c819110e$var$ReactSharedInternals.T = null;
    var previousPriority = $00a4cde6c819110e$var$ReactDOMSharedInternals.p;
    try {
        $00a4cde6c819110e$var$ReactDOMSharedInternals.p = 8, $00a4cde6c819110e$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $00a4cde6c819110e$var$ReactDOMSharedInternals.p = previousPriority, $00a4cde6c819110e$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00a4cde6c819110e$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($00a4cde6c819110e$var$_enabled) {
        var blockedOn = $00a4cde6c819110e$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $00a4cde6c819110e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $00a4cde6c819110e$var$return_targetInst, targetContainer), $00a4cde6c819110e$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($00a4cde6c819110e$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($00a4cde6c819110e$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $00a4cde6c819110e$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $00a4cde6c819110e$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $00a4cde6c819110e$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $00a4cde6c819110e$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $00a4cde6c819110e$var$ensureRootIsScheduled(fiber);
                                0 === ($00a4cde6c819110e$var$executionContext & 6) && ($00a4cde6c819110e$var$workInProgressRootRenderTargetTime = $00a4cde6c819110e$var$now() + 500, $00a4cde6c819110e$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $00a4cde6c819110e$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $00a4cde6c819110e$var$scheduleUpdateOnFiber(root, fiber, 2), $00a4cde6c819110e$var$flushSyncWork$1(), $00a4cde6c819110e$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $00a4cde6c819110e$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $00a4cde6c819110e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $00a4cde6c819110e$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $00a4cde6c819110e$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $00a4cde6c819110e$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $00a4cde6c819110e$var$getEventTarget(nativeEvent);
    return $00a4cde6c819110e$var$findInstanceBlockingTarget(nativeEvent);
}
var $00a4cde6c819110e$var$return_targetInst = null;
function $00a4cde6c819110e$var$findInstanceBlockingTarget(targetNode) {
    $00a4cde6c819110e$var$return_targetInst = null;
    targetNode = $00a4cde6c819110e$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $00a4cde6c819110e$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $00a4cde6c819110e$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $00a4cde6c819110e$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $00a4cde6c819110e$var$return_targetInst = targetNode;
    return null;
}
function $00a4cde6c819110e$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($00a4cde6c819110e$var$getCurrentPriorityLevel()){
                case $00a4cde6c819110e$var$ImmediatePriority:
                    return 2;
                case $00a4cde6c819110e$var$UserBlockingPriority:
                    return 8;
                case $00a4cde6c819110e$var$NormalPriority$1:
                case $00a4cde6c819110e$var$LowPriority:
                    return 32;
                case $00a4cde6c819110e$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $00a4cde6c819110e$var$hasScheduledReplayAttempt = !1, $00a4cde6c819110e$var$queuedFocus = null, $00a4cde6c819110e$var$queuedDrag = null, $00a4cde6c819110e$var$queuedMouse = null, $00a4cde6c819110e$var$queuedPointers = new Map(), $00a4cde6c819110e$var$queuedPointerCaptures = new Map(), $00a4cde6c819110e$var$queuedExplicitHydrationTargets = [], $00a4cde6c819110e$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $00a4cde6c819110e$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $00a4cde6c819110e$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $00a4cde6c819110e$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $00a4cde6c819110e$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $00a4cde6c819110e$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $00a4cde6c819110e$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $00a4cde6c819110e$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $00a4cde6c819110e$var$getInstanceFromNode(blockedOn), null !== blockedOn && $00a4cde6c819110e$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $00a4cde6c819110e$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $00a4cde6c819110e$var$queuedFocus = $00a4cde6c819110e$var$accumulateOrCreateContinuousQueuedReplayableEvent($00a4cde6c819110e$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $00a4cde6c819110e$var$queuedDrag = $00a4cde6c819110e$var$accumulateOrCreateContinuousQueuedReplayableEvent($00a4cde6c819110e$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $00a4cde6c819110e$var$queuedMouse = $00a4cde6c819110e$var$accumulateOrCreateContinuousQueuedReplayableEvent($00a4cde6c819110e$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $00a4cde6c819110e$var$queuedPointers.set(pointerId, $00a4cde6c819110e$var$accumulateOrCreateContinuousQueuedReplayableEvent($00a4cde6c819110e$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $00a4cde6c819110e$var$queuedPointerCaptures.set(pointerId, $00a4cde6c819110e$var$accumulateOrCreateContinuousQueuedReplayableEvent($00a4cde6c819110e$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $00a4cde6c819110e$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $00a4cde6c819110e$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $00a4cde6c819110e$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $00a4cde6c819110e$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $00a4cde6c819110e$var$runWithPriority(queuedTarget.priority, function() {
                        $00a4cde6c819110e$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $00a4cde6c819110e$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $00a4cde6c819110e$var$runWithPriority(queuedTarget.priority, function() {
                        $00a4cde6c819110e$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $00a4cde6c819110e$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $00a4cde6c819110e$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $00a4cde6c819110e$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $00a4cde6c819110e$var$currentReplayingEvent = null;
        } else return targetContainers = $00a4cde6c819110e$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $00a4cde6c819110e$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $00a4cde6c819110e$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $00a4cde6c819110e$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $00a4cde6c819110e$var$replayUnblockedEvents() {
    $00a4cde6c819110e$var$hasScheduledReplayAttempt = !1;
    null !== $00a4cde6c819110e$var$queuedFocus && $00a4cde6c819110e$var$attemptReplayContinuousQueuedEvent($00a4cde6c819110e$var$queuedFocus) && ($00a4cde6c819110e$var$queuedFocus = null);
    null !== $00a4cde6c819110e$var$queuedDrag && $00a4cde6c819110e$var$attemptReplayContinuousQueuedEvent($00a4cde6c819110e$var$queuedDrag) && ($00a4cde6c819110e$var$queuedDrag = null);
    null !== $00a4cde6c819110e$var$queuedMouse && $00a4cde6c819110e$var$attemptReplayContinuousQueuedEvent($00a4cde6c819110e$var$queuedMouse) && ($00a4cde6c819110e$var$queuedMouse = null);
    $00a4cde6c819110e$var$queuedPointers.forEach($00a4cde6c819110e$var$attemptReplayContinuousQueuedEventInMap);
    $00a4cde6c819110e$var$queuedPointerCaptures.forEach($00a4cde6c819110e$var$attemptReplayContinuousQueuedEventInMap);
}
function $00a4cde6c819110e$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $00a4cde6c819110e$var$hasScheduledReplayAttempt || ($00a4cde6c819110e$var$hasScheduledReplayAttempt = !0, $aczbN.unstable_scheduleCallback($aczbN.unstable_NormalPriority, $00a4cde6c819110e$var$replayUnblockedEvents)));
}
var $00a4cde6c819110e$var$lastScheduledReplayQueue = null;
function $00a4cde6c819110e$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $00a4cde6c819110e$var$lastScheduledReplayQueue !== formReplayingQueue && ($00a4cde6c819110e$var$lastScheduledReplayQueue = formReplayingQueue, $aczbN.unstable_scheduleCallback($aczbN.unstable_NormalPriority, function() {
        $00a4cde6c819110e$var$lastScheduledReplayQueue === formReplayingQueue && ($00a4cde6c819110e$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $00a4cde6c819110e$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $00a4cde6c819110e$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $00a4cde6c819110e$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $00a4cde6c819110e$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $00a4cde6c819110e$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $00a4cde6c819110e$var$queuedFocus && $00a4cde6c819110e$var$scheduleCallbackIfUnblocked($00a4cde6c819110e$var$queuedFocus, unblocked);
    null !== $00a4cde6c819110e$var$queuedDrag && $00a4cde6c819110e$var$scheduleCallbackIfUnblocked($00a4cde6c819110e$var$queuedDrag, unblocked);
    null !== $00a4cde6c819110e$var$queuedMouse && $00a4cde6c819110e$var$scheduleCallbackIfUnblocked($00a4cde6c819110e$var$queuedMouse, unblocked);
    $00a4cde6c819110e$var$queuedPointers.forEach(unblock);
    $00a4cde6c819110e$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $00a4cde6c819110e$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $00a4cde6c819110e$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $00a4cde6c819110e$var$queuedExplicitHydrationTargets.length && (i = $00a4cde6c819110e$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$00a4cde6c819110e$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $00a4cde6c819110e$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$00a4cde6c819110e$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $00a4cde6c819110e$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$00a4cde6c819110e$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $00a4cde6c819110e$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $00a4cde6c819110e$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $00a4cde6c819110e$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $00a4cde6c819110e$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$00a4cde6c819110e$var$ReactDOMHydrationRoot.prototype.render = $00a4cde6c819110e$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(409));
    var current = root.current, lane = $00a4cde6c819110e$var$requestUpdateLane();
    $00a4cde6c819110e$var$updateContainerImpl(current, lane, children, root, null, null);
};
$00a4cde6c819110e$var$ReactDOMHydrationRoot.prototype.unmount = $00a4cde6c819110e$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $00a4cde6c819110e$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $00a4cde6c819110e$var$flushSyncWork$1();
        container[$00a4cde6c819110e$var$internalContainerInstanceKey] = null;
    }
};
function $00a4cde6c819110e$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$00a4cde6c819110e$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $00a4cde6c819110e$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $00a4cde6c819110e$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $00a4cde6c819110e$var$queuedExplicitHydrationTargets[i].priority; i++);
        $00a4cde6c819110e$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $00a4cde6c819110e$var$attemptExplicitHydrationTarget(target);
    }
};
var $00a4cde6c819110e$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $d1Z4Y.version;
if ("19.2.8" !== $00a4cde6c819110e$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(527, $00a4cde6c819110e$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$00a4cde6c819110e$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($00a4cde6c819110e$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $00a4cde6c819110e$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $00a4cde6c819110e$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $00a4cde6c819110e$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $00a4cde6c819110e$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $00a4cde6c819110e$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$00a4cde6c819110e$var$hook$jscomp$inline_2348.isDisabled && $00a4cde6c819110e$var$hook$jscomp$inline_2348.supportsFiber) try {
        $00a4cde6c819110e$var$rendererID = $00a4cde6c819110e$var$hook$jscomp$inline_2348.inject($00a4cde6c819110e$var$internals$jscomp$inline_2347), $00a4cde6c819110e$var$injectedHook = $00a4cde6c819110e$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$00a4cde6c819110e$export$882461b6382ed46c = function(container, options) {
    if (!$00a4cde6c819110e$var$isValidContainer(container)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $00a4cde6c819110e$var$defaultOnUncaughtError, onCaughtError = $00a4cde6c819110e$var$defaultOnCaughtError, onRecoverableError = $00a4cde6c819110e$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $00a4cde6c819110e$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $00a4cde6c819110e$var$defaultOnDefaultTransitionIndicator);
    container[$00a4cde6c819110e$var$internalContainerInstanceKey] = options.current;
    $00a4cde6c819110e$var$listenToAllSupportedEvents(container);
    return new $00a4cde6c819110e$var$ReactDOMRoot(options);
};
$00a4cde6c819110e$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$00a4cde6c819110e$var$isValidContainer(container)) throw Error($00a4cde6c819110e$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $00a4cde6c819110e$var$defaultOnUncaughtError, onCaughtError = $00a4cde6c819110e$var$defaultOnCaughtError, onRecoverableError = $00a4cde6c819110e$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $00a4cde6c819110e$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $00a4cde6c819110e$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $00a4cde6c819110e$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $00a4cde6c819110e$var$requestUpdateLane();
    isStrictMode = $00a4cde6c819110e$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $00a4cde6c819110e$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $00a4cde6c819110e$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $00a4cde6c819110e$var$markRootUpdated$1(initialChildren, options);
    $00a4cde6c819110e$var$ensureRootIsScheduled(initialChildren);
    container[$00a4cde6c819110e$var$internalContainerInstanceKey] = initialChildren.current;
    $00a4cde6c819110e$var$listenToAllSupportedEvents(container);
    return new $00a4cde6c819110e$var$ReactDOMHydrationRoot(initialChildren);
};
$00a4cde6c819110e$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("aczbN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7HAmK"));

});
parcelRegister("7HAmK", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $59b8c20f1d578b00$export$c4744153514ff05d; }, function (v) { return $59b8c20f1d578b00$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $59b8c20f1d578b00$export$3e506c1ccc9cc1a7; }, function (v) { return $59b8c20f1d578b00$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $59b8c20f1d578b00$export$e26fe2ed2fa76875; }, function (v) { return $59b8c20f1d578b00$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $59b8c20f1d578b00$export$502329bbf4b505b1; }, function (v) { return $59b8c20f1d578b00$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $59b8c20f1d578b00$export$6e3807111c4874c4; }, function (v) { return $59b8c20f1d578b00$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $59b8c20f1d578b00$export$c27134553091fb3a; }, function (v) { return $59b8c20f1d578b00$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $59b8c20f1d578b00$export$33ee1acdc04fd2a2; }, function (v) { return $59b8c20f1d578b00$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $59b8c20f1d578b00$export$b00a404bbd5edef2; }, function (v) { return $59b8c20f1d578b00$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $59b8c20f1d578b00$export$d66a1c1c77bd778b; }, function (v) { return $59b8c20f1d578b00$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $59b8c20f1d578b00$export$d3dfb8e4810cb555; }, function (v) { return $59b8c20f1d578b00$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $59b8c20f1d578b00$export$72fdf0e06517287b; }, function (v) { return $59b8c20f1d578b00$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $59b8c20f1d578b00$export$816d2913ae6b83b1; }, function (v) { return $59b8c20f1d578b00$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $59b8c20f1d578b00$export$61bcfe829111a1d0; }, function (v) { return $59b8c20f1d578b00$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $59b8c20f1d578b00$export$7ee8c9beb337bc3f; }, function (v) { return $59b8c20f1d578b00$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $59b8c20f1d578b00$export$b5836b71941fa3ed; }, function (v) { return $59b8c20f1d578b00$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $59b8c20f1d578b00$export$cf845f2c119da08a; }, function (v) { return $59b8c20f1d578b00$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $59b8c20f1d578b00$export$c4744153514ff05d;
var $59b8c20f1d578b00$export$3e506c1ccc9cc1a7;
var $59b8c20f1d578b00$export$e26fe2ed2fa76875;
var $59b8c20f1d578b00$export$502329bbf4b505b1;
var $59b8c20f1d578b00$export$6e3807111c4874c4;
var $59b8c20f1d578b00$export$c27134553091fb3a;
var $59b8c20f1d578b00$export$33ee1acdc04fd2a2;
var $59b8c20f1d578b00$export$b00a404bbd5edef2;
var $59b8c20f1d578b00$export$d66a1c1c77bd778b;
var $59b8c20f1d578b00$export$d3dfb8e4810cb555;
var $59b8c20f1d578b00$export$72fdf0e06517287b;
var $59b8c20f1d578b00$export$816d2913ae6b83b1;
var $59b8c20f1d578b00$export$61bcfe829111a1d0;
var $59b8c20f1d578b00$export$7ee8c9beb337bc3f;
var $59b8c20f1d578b00$export$b5836b71941fa3ed;
var $59b8c20f1d578b00$export$cf845f2c119da08a;
"use strict";
function $59b8c20f1d578b00$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $59b8c20f1d578b00$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $59b8c20f1d578b00$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $59b8c20f1d578b00$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $59b8c20f1d578b00$var$compare(left, last)) rightIndex < length && 0 > $59b8c20f1d578b00$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $59b8c20f1d578b00$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $59b8c20f1d578b00$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$59b8c20f1d578b00$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $59b8c20f1d578b00$var$localPerformance = performance;
    $59b8c20f1d578b00$export$c4744153514ff05d = function() {
        return $59b8c20f1d578b00$var$localPerformance.now();
    };
} else {
    var $59b8c20f1d578b00$var$localDate = Date, $59b8c20f1d578b00$var$initialTime = $59b8c20f1d578b00$var$localDate.now();
    $59b8c20f1d578b00$export$c4744153514ff05d = function() {
        return $59b8c20f1d578b00$var$localDate.now() - $59b8c20f1d578b00$var$initialTime;
    };
}
var $59b8c20f1d578b00$var$taskQueue = [], $59b8c20f1d578b00$var$timerQueue = [], $59b8c20f1d578b00$var$taskIdCounter = 1, $59b8c20f1d578b00$var$currentTask = null, $59b8c20f1d578b00$var$currentPriorityLevel = 3, $59b8c20f1d578b00$var$isPerformingWork = !1, $59b8c20f1d578b00$var$isHostCallbackScheduled = !1, $59b8c20f1d578b00$var$isHostTimeoutScheduled = !1, $59b8c20f1d578b00$var$needsPaint = !1, $59b8c20f1d578b00$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $59b8c20f1d578b00$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $59b8c20f1d578b00$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $59b8c20f1d578b00$var$advanceTimers(currentTime) {
    for(var timer = $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$timerQueue); null !== timer;){
        if (null === timer.callback) $59b8c20f1d578b00$var$pop($59b8c20f1d578b00$var$timerQueue);
        else if (timer.startTime <= currentTime) $59b8c20f1d578b00$var$pop($59b8c20f1d578b00$var$timerQueue), timer.sortIndex = timer.expirationTime, $59b8c20f1d578b00$var$push($59b8c20f1d578b00$var$taskQueue, timer);
        else break;
        timer = $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$timerQueue);
    }
}
function $59b8c20f1d578b00$var$handleTimeout(currentTime) {
    $59b8c20f1d578b00$var$isHostTimeoutScheduled = !1;
    $59b8c20f1d578b00$var$advanceTimers(currentTime);
    if (!$59b8c20f1d578b00$var$isHostCallbackScheduled) {
        if (null !== $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$taskQueue)) $59b8c20f1d578b00$var$isHostCallbackScheduled = !0, $59b8c20f1d578b00$var$isMessageLoopRunning || ($59b8c20f1d578b00$var$isMessageLoopRunning = !0, $59b8c20f1d578b00$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$timerQueue);
            null !== firstTimer && $59b8c20f1d578b00$var$requestHostTimeout($59b8c20f1d578b00$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $59b8c20f1d578b00$var$isMessageLoopRunning = !1, $59b8c20f1d578b00$var$taskTimeoutID = -1, $59b8c20f1d578b00$var$frameInterval = 5, $59b8c20f1d578b00$var$startTime = -1;
function $59b8c20f1d578b00$var$shouldYieldToHost() {
    return $59b8c20f1d578b00$var$needsPaint ? !0 : $59b8c20f1d578b00$export$c4744153514ff05d() - $59b8c20f1d578b00$var$startTime < $59b8c20f1d578b00$var$frameInterval ? !1 : !0;
}
function $59b8c20f1d578b00$var$performWorkUntilDeadline() {
    $59b8c20f1d578b00$var$needsPaint = !1;
    if ($59b8c20f1d578b00$var$isMessageLoopRunning) {
        var currentTime = $59b8c20f1d578b00$export$c4744153514ff05d();
        $59b8c20f1d578b00$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $59b8c20f1d578b00$var$isHostCallbackScheduled = !1;
                $59b8c20f1d578b00$var$isHostTimeoutScheduled && ($59b8c20f1d578b00$var$isHostTimeoutScheduled = !1, $59b8c20f1d578b00$var$localClearTimeout($59b8c20f1d578b00$var$taskTimeoutID), $59b8c20f1d578b00$var$taskTimeoutID = -1);
                $59b8c20f1d578b00$var$isPerformingWork = !0;
                var previousPriorityLevel = $59b8c20f1d578b00$var$currentPriorityLevel;
                try {
                    b: {
                        $59b8c20f1d578b00$var$advanceTimers(currentTime);
                        for($59b8c20f1d578b00$var$currentTask = $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$taskQueue); null !== $59b8c20f1d578b00$var$currentTask && !($59b8c20f1d578b00$var$currentTask.expirationTime > currentTime && $59b8c20f1d578b00$var$shouldYieldToHost());){
                            var callback = $59b8c20f1d578b00$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $59b8c20f1d578b00$var$currentTask.callback = null;
                                $59b8c20f1d578b00$var$currentPriorityLevel = $59b8c20f1d578b00$var$currentTask.priorityLevel;
                                var continuationCallback = callback($59b8c20f1d578b00$var$currentTask.expirationTime <= currentTime);
                                currentTime = $59b8c20f1d578b00$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $59b8c20f1d578b00$var$currentTask.callback = continuationCallback;
                                    $59b8c20f1d578b00$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $59b8c20f1d578b00$var$currentTask === $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$taskQueue) && $59b8c20f1d578b00$var$pop($59b8c20f1d578b00$var$taskQueue);
                                $59b8c20f1d578b00$var$advanceTimers(currentTime);
                            } else $59b8c20f1d578b00$var$pop($59b8c20f1d578b00$var$taskQueue);
                            $59b8c20f1d578b00$var$currentTask = $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$taskQueue);
                        }
                        if (null !== $59b8c20f1d578b00$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$timerQueue);
                            null !== firstTimer && $59b8c20f1d578b00$var$requestHostTimeout($59b8c20f1d578b00$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $59b8c20f1d578b00$var$currentTask = null, $59b8c20f1d578b00$var$currentPriorityLevel = previousPriorityLevel, $59b8c20f1d578b00$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $59b8c20f1d578b00$var$schedulePerformWorkUntilDeadline() : $59b8c20f1d578b00$var$isMessageLoopRunning = !1;
        }
    }
}
var $59b8c20f1d578b00$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $59b8c20f1d578b00$var$localSetImmediate) $59b8c20f1d578b00$var$schedulePerformWorkUntilDeadline = function() {
    $59b8c20f1d578b00$var$localSetImmediate($59b8c20f1d578b00$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $59b8c20f1d578b00$var$channel = new MessageChannel(), $59b8c20f1d578b00$var$port = $59b8c20f1d578b00$var$channel.port2;
    $59b8c20f1d578b00$var$channel.port1.onmessage = $59b8c20f1d578b00$var$performWorkUntilDeadline;
    $59b8c20f1d578b00$var$schedulePerformWorkUntilDeadline = function() {
        $59b8c20f1d578b00$var$port.postMessage(null);
    };
} else $59b8c20f1d578b00$var$schedulePerformWorkUntilDeadline = function() {
    $59b8c20f1d578b00$var$localSetTimeout($59b8c20f1d578b00$var$performWorkUntilDeadline, 0);
};
function $59b8c20f1d578b00$var$requestHostTimeout(callback, ms) {
    $59b8c20f1d578b00$var$taskTimeoutID = $59b8c20f1d578b00$var$localSetTimeout(function() {
        callback($59b8c20f1d578b00$export$c4744153514ff05d());
    }, ms);
}
$59b8c20f1d578b00$export$3e506c1ccc9cc1a7 = 5;
$59b8c20f1d578b00$export$e26fe2ed2fa76875 = 1;
$59b8c20f1d578b00$export$502329bbf4b505b1 = 4;
$59b8c20f1d578b00$export$6e3807111c4874c4 = 3;
$59b8c20f1d578b00$export$c27134553091fb3a = null;
$59b8c20f1d578b00$export$33ee1acdc04fd2a2 = 2;
$59b8c20f1d578b00$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$59b8c20f1d578b00$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $59b8c20f1d578b00$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$59b8c20f1d578b00$export$d3dfb8e4810cb555 = function() {
    return $59b8c20f1d578b00$var$currentPriorityLevel;
};
$59b8c20f1d578b00$export$72fdf0e06517287b = function(eventHandler) {
    switch($59b8c20f1d578b00$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $59b8c20f1d578b00$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $59b8c20f1d578b00$var$currentPriorityLevel;
    $59b8c20f1d578b00$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $59b8c20f1d578b00$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$59b8c20f1d578b00$export$816d2913ae6b83b1 = function() {
    $59b8c20f1d578b00$var$needsPaint = !0;
};
$59b8c20f1d578b00$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $59b8c20f1d578b00$var$currentPriorityLevel;
    $59b8c20f1d578b00$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $59b8c20f1d578b00$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$59b8c20f1d578b00$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $59b8c20f1d578b00$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $59b8c20f1d578b00$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $59b8c20f1d578b00$var$push($59b8c20f1d578b00$var$timerQueue, priorityLevel), null === $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$taskQueue) && priorityLevel === $59b8c20f1d578b00$var$peek($59b8c20f1d578b00$var$timerQueue) && ($59b8c20f1d578b00$var$isHostTimeoutScheduled ? ($59b8c20f1d578b00$var$localClearTimeout($59b8c20f1d578b00$var$taskTimeoutID), $59b8c20f1d578b00$var$taskTimeoutID = -1) : $59b8c20f1d578b00$var$isHostTimeoutScheduled = !0, $59b8c20f1d578b00$var$requestHostTimeout($59b8c20f1d578b00$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $59b8c20f1d578b00$var$push($59b8c20f1d578b00$var$taskQueue, priorityLevel), $59b8c20f1d578b00$var$isHostCallbackScheduled || $59b8c20f1d578b00$var$isPerformingWork || ($59b8c20f1d578b00$var$isHostCallbackScheduled = !0, $59b8c20f1d578b00$var$isMessageLoopRunning || ($59b8c20f1d578b00$var$isMessageLoopRunning = !0, $59b8c20f1d578b00$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$59b8c20f1d578b00$export$b5836b71941fa3ed = $59b8c20f1d578b00$var$shouldYieldToHost;
$59b8c20f1d578b00$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $59b8c20f1d578b00$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $59b8c20f1d578b00$var$currentPriorityLevel;
        $59b8c20f1d578b00$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $59b8c20f1d578b00$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("d5tj1", function(module, exports) {
'use strict';
function $987279805ed0689c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($987279805ed0689c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$987279805ed0689c$var$checkDCE();

module.exports = (parcelRequire("66aqb"));

});
parcelRegister("66aqb", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $0125584eb79db8ed$export$69ce8ef3fe5cead0; }, function (v) { return $0125584eb79db8ed$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $0125584eb79db8ed$export$d39a5bbd09211389; }, function (v) { return $0125584eb79db8ed$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0125584eb79db8ed$export$cd75ccfd720a3cd4; }, function (v) { return $0125584eb79db8ed$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $0125584eb79db8ed$export$a0816fa17a9e79be; }, function (v) { return $0125584eb79db8ed$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $0125584eb79db8ed$export$7292efcadded39f3; }, function (v) { return $0125584eb79db8ed$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $0125584eb79db8ed$export$da407abadb9b8f86; }, function (v) { return $0125584eb79db8ed$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $0125584eb79db8ed$export$314cfea32580671c; }, function (v) { return $0125584eb79db8ed$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $0125584eb79db8ed$export$513ccb98c53b8039; }, function (v) { return $0125584eb79db8ed$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $0125584eb79db8ed$export$dbca993bc2d264a; }, function (v) { return $0125584eb79db8ed$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $0125584eb79db8ed$export$4797a8006f0655d0; }, function (v) { return $0125584eb79db8ed$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0125584eb79db8ed$export$c78a37762a8d58e1; }, function (v) { return $0125584eb79db8ed$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $0125584eb79db8ed$export$606f11b2eb45ecc6; }, function (v) { return $0125584eb79db8ed$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $0125584eb79db8ed$export$f7e8a0bf92324b1e; }, function (v) { return $0125584eb79db8ed$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $0125584eb79db8ed$export$83d89fbfd8236492; }, function (v) { return $0125584eb79db8ed$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0125584eb79db8ed$export$69ce8ef3fe5cead0;
var $0125584eb79db8ed$export$d39a5bbd09211389;
var $0125584eb79db8ed$export$cd75ccfd720a3cd4;
var $0125584eb79db8ed$export$a0816fa17a9e79be;
var $0125584eb79db8ed$export$7292efcadded39f3;
var $0125584eb79db8ed$export$da407abadb9b8f86;
var $0125584eb79db8ed$export$314cfea32580671c;
var $0125584eb79db8ed$export$513ccb98c53b8039;
var $0125584eb79db8ed$export$dbca993bc2d264a;
var $0125584eb79db8ed$export$4797a8006f0655d0;
var $0125584eb79db8ed$export$c78a37762a8d58e1;
var $0125584eb79db8ed$export$606f11b2eb45ecc6;
var $0125584eb79db8ed$export$f7e8a0bf92324b1e;
var $0125584eb79db8ed$export$83d89fbfd8236492;
"use strict";

var $d1Z4Y = parcelRequire("d1Z4Y");
function $0125584eb79db8ed$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $0125584eb79db8ed$var$noop() {}
var $0125584eb79db8ed$var$Internals = {
    d: {
        f: $0125584eb79db8ed$var$noop,
        r: function() {
            throw Error($0125584eb79db8ed$var$formatProdErrorMessage(522));
        },
        D: $0125584eb79db8ed$var$noop,
        C: $0125584eb79db8ed$var$noop,
        L: $0125584eb79db8ed$var$noop,
        m: $0125584eb79db8ed$var$noop,
        X: $0125584eb79db8ed$var$noop,
        S: $0125584eb79db8ed$var$noop,
        M: $0125584eb79db8ed$var$noop
    },
    p: 0,
    findDOMNode: null
}, $0125584eb79db8ed$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $0125584eb79db8ed$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0125584eb79db8ed$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $0125584eb79db8ed$var$ReactSharedInternals = $d1Z4Y.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $0125584eb79db8ed$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$0125584eb79db8ed$export$69ce8ef3fe5cead0 = $0125584eb79db8ed$var$Internals;
$0125584eb79db8ed$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($0125584eb79db8ed$var$formatProdErrorMessage(299));
    return $0125584eb79db8ed$var$createPortal$1(children, container, null, key);
};
$0125584eb79db8ed$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $0125584eb79db8ed$var$ReactSharedInternals.T, previousUpdatePriority = $0125584eb79db8ed$var$Internals.p;
    try {
        if ($0125584eb79db8ed$var$ReactSharedInternals.T = null, $0125584eb79db8ed$var$Internals.p = 2, fn) return fn();
    } finally{
        $0125584eb79db8ed$var$ReactSharedInternals.T = previousTransition, $0125584eb79db8ed$var$Internals.p = previousUpdatePriority, $0125584eb79db8ed$var$Internals.d.f();
    }
};
$0125584eb79db8ed$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $0125584eb79db8ed$var$Internals.d.C(href, options));
};
$0125584eb79db8ed$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $0125584eb79db8ed$var$Internals.d.D(href);
};
$0125584eb79db8ed$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $0125584eb79db8ed$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $0125584eb79db8ed$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $0125584eb79db8ed$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$0125584eb79db8ed$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $0125584eb79db8ed$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $0125584eb79db8ed$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $0125584eb79db8ed$var$Internals.d.M(href);
    }
};
$0125584eb79db8ed$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $0125584eb79db8ed$var$getCrossOriginStringAs(as, options.crossOrigin);
        $0125584eb79db8ed$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$0125584eb79db8ed$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $0125584eb79db8ed$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $0125584eb79db8ed$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $0125584eb79db8ed$var$Internals.d.m(href);
    }
};
$0125584eb79db8ed$export$4797a8006f0655d0 = function(form) {
    $0125584eb79db8ed$var$Internals.d.r(form);
};
$0125584eb79db8ed$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$0125584eb79db8ed$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $0125584eb79db8ed$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$0125584eb79db8ed$export$f7e8a0bf92324b1e = function() {
    return $0125584eb79db8ed$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$0125584eb79db8ed$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("jp3Fn", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return $f577eb5369177259$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $f577eb5369177259$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $f577eb5369177259$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "Outlet", function () { return $f577eb5369177259$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $f577eb5369177259$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $f577eb5369177259$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "BrowserRouter", function () { return $f577eb5369177259$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $f577eb5369177259$export$a6c7ac8248d6e38a; });
/**
 * react-router v7.18.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $d1Z4Y = parcelRequire("d1Z4Y");
var $f577eb5369177259$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.18.2_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/react-router/dist/development/chunk-62JRHF6Z.mjs"
});
var $f577eb5369177259$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $f577eb5369177259$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $f577eb5369177259$var$__typeError("Cannot " + msg);
var $f577eb5369177259$var$__privateGet = (obj, member, getter)=>($f577eb5369177259$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $f577eb5369177259$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $f577eb5369177259$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $f577eb5369177259$var$__privateSet = (obj, member, value, setter)=>($f577eb5369177259$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $f577eb5369177259$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $f577eb5369177259$export$825a82322d91916e = /^[\\/]{2}/;
function $f577eb5369177259$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $f577eb5369177259$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($f577eb5369177259$export$e19cd5f9376f8cee || {});
var $f577eb5369177259$var$PopStateEventType = "popstate";
function $f577eb5369177259$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $f577eb5369177259$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $f577eb5369177259$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $f577eb5369177259$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $f577eb5369177259$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $f577eb5369177259$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $f577eb5369177259$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $f577eb5369177259$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $f577eb5369177259$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $f577eb5369177259$export$fe53371bee54353d(to);
    }
    return $f577eb5369177259$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $f577eb5369177259$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f577eb5369177259$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f577eb5369177259$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f577eb5369177259$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f577eb5369177259$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $f577eb5369177259$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f577eb5369177259$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f577eb5369177259$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $f577eb5369177259$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $f577eb5369177259$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $f577eb5369177259$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f577eb5369177259$var$createKey(),
        mask: mask
    };
    return location;
}
function $f577eb5369177259$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $f577eb5369177259$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f577eb5369177259$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $f577eb5369177259$var$isLocation(to) ? to : $f577eb5369177259$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f577eb5369177259$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $f577eb5369177259$var$isLocation(to) ? to : $f577eb5369177259$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f577eb5369177259$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $f577eb5369177259$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($f577eb5369177259$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($f577eb5369177259$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $f577eb5369177259$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $f577eb5369177259$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $f577eb5369177259$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $f577eb5369177259$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $f577eb5369177259$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $f577eb5369177259$var$_map;
var $f577eb5369177259$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $f577eb5369177259$var$__privateAdd(this, $f577eb5369177259$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_map).has(context)) return $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_map).set(context, value);
    }
};
$f577eb5369177259$var$_map = new WeakMap();
var $f577eb5369177259$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f577eb5369177259$var$isUnsupportedLazyRouteObjectKey(key) {
    return $f577eb5369177259$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $f577eb5369177259$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $f577eb5369177259$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $f577eb5369177259$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $f577eb5369177259$var$isIndexRoute(route) {
    return route.index === true;
}
function $f577eb5369177259$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f577eb5369177259$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $f577eb5369177259$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($f577eb5369177259$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $f577eb5369177259$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $f577eb5369177259$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $f577eb5369177259$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $f577eb5369177259$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $f577eb5369177259$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $f577eb5369177259$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $f577eb5369177259$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f577eb5369177259$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $f577eb5369177259$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $f577eb5369177259$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $f577eb5369177259$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $f577eb5369177259$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $f577eb5369177259$var$flattenAndRankRoutes(routes) {
    let branches = $f577eb5369177259$var$flattenRoutes(routes);
    $f577eb5369177259$var$rankRouteBranches(branches);
    return branches;
}
function $f577eb5369177259$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $f577eb5369177259$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f577eb5369177259$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $f577eb5369177259$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $f577eb5369177259$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f577eb5369177259$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $f577eb5369177259$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $f577eb5369177259$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $f577eb5369177259$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f577eb5369177259$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f577eb5369177259$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $f577eb5369177259$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $f577eb5369177259$var$paramRe = /^:[\w-]+$/;
var $f577eb5369177259$var$dynamicSegmentValue = 3;
var $f577eb5369177259$var$indexRouteValue = 2;
var $f577eb5369177259$var$emptySegmentValue = 1;
var $f577eb5369177259$var$staticSegmentValue = 10;
var $f577eb5369177259$var$splatPenalty = -2;
var $f577eb5369177259$var$isSplat = (s)=>s === "*";
function $f577eb5369177259$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f577eb5369177259$var$isSplat)) initialScore += $f577eb5369177259$var$splatPenalty;
    if (index) initialScore += $f577eb5369177259$var$indexRouteValue;
    return segments.filter((s)=>!$f577eb5369177259$var$isSplat(s)).reduce((score, segment)=>score + ($f577eb5369177259$var$paramRe.test(segment) ? $f577eb5369177259$var$dynamicSegmentValue : segment === "" ? $f577eb5369177259$var$emptySegmentValue : $f577eb5369177259$var$staticSegmentValue), initialScore);
}
function $f577eb5369177259$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f577eb5369177259$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $f577eb5369177259$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $f577eb5369177259$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $f577eb5369177259$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f577eb5369177259$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f577eb5369177259$var$normalizePathname($f577eb5369177259$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f577eb5369177259$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $f577eb5369177259$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f577eb5369177259$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $f577eb5369177259$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $f577eb5369177259$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f577eb5369177259$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $f577eb5369177259$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $f577eb5369177259$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f577eb5369177259$var$compilePath(path, caseSensitive = false, end = true) {
    $f577eb5369177259$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $f577eb5369177259$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f577eb5369177259$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $f577eb5369177259$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $f577eb5369177259$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $f577eb5369177259$var$joinPaths([
        basename,
        pathname
    ]);
}
var $f577eb5369177259$var$isAbsoluteUrl = (url)=>$f577eb5369177259$var$ABSOLUTE_URL_REGEX.test(url);
function $f577eb5369177259$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $f577eb5369177259$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $f577eb5369177259$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $f577eb5369177259$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $f577eb5369177259$var$normalizeSearch(search),
        hash: $f577eb5369177259$var$normalizeHash(hash)
    };
}
function $f577eb5369177259$var$resolvePathname(relativePath, fromPathname) {
    let segments = $f577eb5369177259$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f577eb5369177259$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $f577eb5369177259$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $f577eb5369177259$var$getResolveToMatches(matches) {
    let pathMatches = $f577eb5369177259$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $f577eb5369177259$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $f577eb5369177259$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $f577eb5369177259$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $f577eb5369177259$var$getInvalidPathError("?", "pathname", "search", to));
        $f577eb5369177259$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $f577eb5369177259$var$getInvalidPathError("#", "pathname", "hash", to));
        $f577eb5369177259$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $f577eb5369177259$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f577eb5369177259$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $f577eb5369177259$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $f577eb5369177259$var$joinPaths = (paths)=>$f577eb5369177259$var$removeDoubleSlashes(paths.join("/"));
var $f577eb5369177259$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $f577eb5369177259$var$normalizePathname = (pathname)=>$f577eb5369177259$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $f577eb5369177259$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $f577eb5369177259$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $f577eb5369177259$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $f577eb5369177259$export$4051a07651545597(data2, init) {
    return new $f577eb5369177259$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $f577eb5369177259$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $f577eb5369177259$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f577eb5369177259$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $f577eb5369177259$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $f577eb5369177259$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $f577eb5369177259$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $f577eb5369177259$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $f577eb5369177259$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $f577eb5369177259$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $f577eb5369177259$var$joinPaths(parts) || "/";
}
var $f577eb5369177259$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $f577eb5369177259$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$f577eb5369177259$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($f577eb5369177259$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $f577eb5369177259$export$825a82322d91916e.test(to) ? new URL($f577eb5369177259$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $f577eb5369177259$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $f577eb5369177259$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $f577eb5369177259$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $f577eb5369177259$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $f577eb5369177259$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $f577eb5369177259$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$f577eb5369177259$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $f577eb5369177259$var$wrapImpl(aggregated[key], original, (...args)=>$f577eb5369177259$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$f577eb5369177259$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$f577eb5369177259$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $f577eb5369177259$var$wrapImpl(aggregated.middleware, original, (...args)=>$f577eb5369177259$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$f577eb5369177259$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $f577eb5369177259$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$f577eb5369177259$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $f577eb5369177259$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $f577eb5369177259$export$fe53371bee54353d(to) : ".",
                ...$f577eb5369177259$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$f577eb5369177259$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$f577eb5369177259$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $f577eb5369177259$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$f577eb5369177259$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$f577eb5369177259$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $f577eb5369177259$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $f577eb5369177259$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $f577eb5369177259$var$getReadonlyRequest(request),
            context: context != null ? $f577eb5369177259$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $f577eb5369177259$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $f577eb5369177259$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $f577eb5369177259$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $f577eb5369177259$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $f577eb5369177259$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $f577eb5369177259$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $f577eb5369177259$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $f577eb5369177259$var$getReadonlyContext(context)
    };
}
function $f577eb5369177259$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $f577eb5369177259$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $f577eb5369177259$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $f577eb5369177259$var$getReadonlyContext(context) {
    if ($f577eb5369177259$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $f577eb5369177259$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $f577eb5369177259$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $f577eb5369177259$var$objectProtoNames;
}
// lib/router/router.ts
var $f577eb5369177259$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $f577eb5369177259$var$validMutationMethods = new Set($f577eb5369177259$var$validMutationMethodsArr);
var $f577eb5369177259$var$validRequestMethodsArr = [
    "GET",
    ...$f577eb5369177259$var$validMutationMethodsArr
];
var $f577eb5369177259$var$validRequestMethods = new Set($f577eb5369177259$var$validRequestMethodsArr);
var $f577eb5369177259$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $f577eb5369177259$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $f577eb5369177259$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $f577eb5369177259$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $f577eb5369177259$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $f577eb5369177259$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $f577eb5369177259$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $f577eb5369177259$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $f577eb5369177259$var$_routes, $f577eb5369177259$var$_branches, $f577eb5369177259$var$_hmrRoutes, $f577eb5369177259$var$_hmrBranches;
var $f577eb5369177259$var$DataRoutes = class {
    constructor(routes){
        $f577eb5369177259$var$__privateAdd(this, $f577eb5369177259$var$_routes);
        $f577eb5369177259$var$__privateAdd(this, $f577eb5369177259$var$_branches);
        $f577eb5369177259$var$__privateAdd(this, $f577eb5369177259$var$_hmrRoutes);
        $f577eb5369177259$var$__privateAdd(this, $f577eb5369177259$var$_hmrBranches);
        $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_routes, routes);
        $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_branches, $f577eb5369177259$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_hmrRoutes) ?? $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_hmrBranches) ?? $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_branches);
    }
    get hasHMRRoutes() {
        return $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_routes, routes);
        $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_branches, $f577eb5369177259$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_hmrRoutes, routes);
        $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_hmrBranches, $f577eb5369177259$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_hmrRoutes)) {
            $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_routes, $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_hmrRoutes));
            $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_branches, $f577eb5369177259$var$__privateGet(this, $f577eb5369177259$var$_hmrBranches));
            $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_hmrRoutes, void 0);
            $f577eb5369177259$var$__privateSet(this, $f577eb5369177259$var$_hmrBranches, void 0);
        }
    }
};
$f577eb5369177259$var$_routes = new WeakMap();
$f577eb5369177259$var$_branches = new WeakMap();
$f577eb5369177259$var$_hmrRoutes = new WeakMap();
$f577eb5369177259$var$_hmrBranches = new WeakMap();
function $f577eb5369177259$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $f577eb5369177259$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $f577eb5369177259$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$f577eb5369177259$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $f577eb5369177259$var$DataRoutes($f577eb5369177259$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $f577eb5369177259$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f577eb5369177259$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $f577eb5369177259$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f577eb5369177259$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$f577eb5369177259$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $f577eb5369177259$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $f577eb5369177259$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $f577eb5369177259$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f577eb5369177259$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $f577eb5369177259$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f577eb5369177259$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f577eb5369177259$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $f577eb5369177259$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f577eb5369177259$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f577eb5369177259$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $f577eb5369177259$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $f577eb5369177259$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $f577eb5369177259$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $f577eb5369177259$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $f577eb5369177259$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $f577eb5369177259$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f577eb5369177259$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $f577eb5369177259$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $f577eb5369177259$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $f577eb5369177259$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f577eb5369177259$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $f577eb5369177259$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $f577eb5369177259$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $f577eb5369177259$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f577eb5369177259$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($f577eb5369177259$var$isErrorResult(result) && $f577eb5369177259$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f577eb5369177259$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $f577eb5369177259$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$f577eb5369177259$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $f577eb5369177259$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $f577eb5369177259$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $f577eb5369177259$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $f577eb5369177259$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $f577eb5369177259$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f577eb5369177259$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $f577eb5369177259$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($f577eb5369177259$var$isErrorResult(result)) {
            let boundaryMatch = $f577eb5369177259$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $f577eb5369177259$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $f577eb5369177259$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $f577eb5369177259$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $f577eb5369177259$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $f577eb5369177259$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $f577eb5369177259$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$f577eb5369177259$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $f577eb5369177259$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $f577eb5369177259$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $f577eb5369177259$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$f577eb5369177259$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $f577eb5369177259$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $f577eb5369177259$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $f577eb5369177259$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $f577eb5369177259$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f577eb5369177259$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $f577eb5369177259$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f577eb5369177259$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f577eb5369177259$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f577eb5369177259$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f577eb5369177259$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $f577eb5369177259$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $f577eb5369177259$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($f577eb5369177259$var$isRedirectResult(actionResult) || $f577eb5369177259$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f577eb5369177259$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($f577eb5369177259$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $f577eb5369177259$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f577eb5369177259$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($f577eb5369177259$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f577eb5369177259$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $f577eb5369177259$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $f577eb5369177259$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $f577eb5369177259$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $f577eb5369177259$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $f577eb5369177259$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $f577eb5369177259$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $f577eb5369177259$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $f577eb5369177259$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $f577eb5369177259$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $f577eb5369177259$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f577eb5369177259$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $f577eb5369177259$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f577eb5369177259$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f577eb5369177259$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f577eb5369177259$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $f577eb5369177259$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $f577eb5369177259$var$getDoneFetcher(void 0));
            return;
        }
        if ($f577eb5369177259$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $f577eb5369177259$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($f577eb5369177259$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $f577eb5369177259$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $f577eb5369177259$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $f577eb5369177259$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $f577eb5369177259$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($f577eb5369177259$var$isAbsoluteUrl(location)) {
                const url = $f577eb5369177259$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f577eb5369177259$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f577eb5369177259$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($f577eb5369177259$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $f577eb5369177259$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $f577eb5369177259$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $f577eb5369177259$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$f577eb5369177259$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($f577eb5369177259$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $f577eb5369177259$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $f577eb5369177259$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $f577eb5369177259$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $f577eb5369177259$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $f577eb5369177259$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $f577eb5369177259$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $f577eb5369177259$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $f577eb5369177259$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $f577eb5369177259$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $f577eb5369177259$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f577eb5369177259$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f577eb5369177259$export$386d57f03f0b2883;
        $f577eb5369177259$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $f577eb5369177259$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $f577eb5369177259$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $f577eb5369177259$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $f577eb5369177259$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$f577eb5369177259$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $f577eb5369177259$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $f577eb5369177259$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $f577eb5369177259$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $f577eb5369177259$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $f577eb5369177259$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $f577eb5369177259$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($f577eb5369177259$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $f577eb5369177259$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $f577eb5369177259$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $f577eb5369177259$export$3336b097a6fbc59a(routes, opts) {
    $f577eb5369177259$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $f577eb5369177259$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$f577eb5369177259$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $f577eb5369177259$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $f577eb5369177259$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $f577eb5369177259$var$defaultNormalizePath;
        let method = request.method;
        let location = $f577eb5369177259$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $f577eb5369177259$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $f577eb5369177259$export$b8d3e69d4b3eff04();
        if (!$f577eb5369177259$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f577eb5369177259$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f577eb5369177259$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $f577eb5369177259$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f577eb5369177259$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $f577eb5369177259$export$f5708dca728d7177(requestContext instanceof $f577eb5369177259$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $f577eb5369177259$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $f577eb5369177259$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $f577eb5369177259$var$createDataFunctionUrl(request, location),
                    pattern: $f577eb5369177259$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($f577eb5369177259$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($f577eb5369177259$export$6e80290866a84dd4(error)) return error;
                    if ($f577eb5369177259$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $f577eb5369177259$export$f2680fa305b734ca(error.status, error.statusText, await $f577eb5369177259$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($f577eb5369177259$export$e0163cfdf7bc9cfa(error)) error = $f577eb5369177259$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $f577eb5369177259$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $f577eb5369177259$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $f577eb5369177259$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $f577eb5369177259$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $f577eb5369177259$export$f5708dca728d7177($f577eb5369177259$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($f577eb5369177259$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($f577eb5369177259$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $f577eb5369177259$var$defaultNormalizePath;
        let method = request.method;
        let location = $f577eb5369177259$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $f577eb5369177259$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $f577eb5369177259$export$b8d3e69d4b3eff04();
        if (!$f577eb5369177259$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f577eb5369177259$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f577eb5369177259$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f577eb5369177259$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f577eb5369177259$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $f577eb5369177259$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $f577eb5369177259$export$f5708dca728d7177(requestContext instanceof $f577eb5369177259$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $f577eb5369177259$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $f577eb5369177259$var$runServerMiddlewarePipeline({
                request: request,
                url: $f577eb5369177259$var$createDataFunctionUrl(request, location),
                pattern: $f577eb5369177259$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $f577eb5369177259$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($f577eb5369177259$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($f577eb5369177259$var$dataWithResponseInitToResponse(error));
                if ($f577eb5369177259$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($f577eb5369177259$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $f577eb5369177259$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f577eb5369177259$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $f577eb5369177259$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $f577eb5369177259$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($f577eb5369177259$var$isDataStrategyResult(e) && $f577eb5369177259$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($f577eb5369177259$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f577eb5369177259$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $f577eb5369177259$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($f577eb5369177259$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($f577eb5369177259$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($f577eb5369177259$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f577eb5369177259$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $f577eb5369177259$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f577eb5369177259$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f577eb5369177259$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $f577eb5369177259$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $f577eb5369177259$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $f577eb5369177259$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $f577eb5369177259$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $f577eb5369177259$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $f577eb5369177259$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $f577eb5369177259$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $f577eb5369177259$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $f577eb5369177259$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $f577eb5369177259$var$callDataStrategyImpl(dataStrategy || $f577eb5369177259$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($f577eb5369177259$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $f577eb5369177259$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($f577eb5369177259$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($f577eb5369177259$export$e0163cfdf7bc9cfa(result.result)) throw $f577eb5369177259$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $f577eb5369177259$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $f577eb5369177259$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $f577eb5369177259$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $f577eb5369177259$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $f577eb5369177259$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $f577eb5369177259$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $f577eb5369177259$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $f577eb5369177259$var$resolveTo(to ? to : ".", $f577eb5369177259$var$getResolveToMatches(contextualMatches), $f577eb5369177259$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $f577eb5369177259$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $f577eb5369177259$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $f577eb5369177259$export$fe53371bee54353d(path);
}
function $f577eb5369177259$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$f577eb5369177259$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f577eb5369177259$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f577eb5369177259$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f577eb5369177259$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $f577eb5369177259$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$f577eb5369177259$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$f577eb5369177259$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f577eb5369177259$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f577eb5369177259$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f577eb5369177259$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f577eb5369177259$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f577eb5369177259$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($f577eb5369177259$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $f577eb5369177259$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $f577eb5369177259$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $f577eb5369177259$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $f577eb5369177259$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $f577eb5369177259$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $f577eb5369177259$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $f577eb5369177259$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$f577eb5369177259$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $f577eb5369177259$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($f577eb5369177259$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $f577eb5369177259$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($f577eb5369177259$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $f577eb5369177259$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $f577eb5369177259$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $f577eb5369177259$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $f577eb5369177259$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $f577eb5369177259$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($f577eb5369177259$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $f577eb5369177259$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $f577eb5369177259$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$f577eb5369177259$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $f577eb5369177259$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $f577eb5369177259$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f577eb5369177259$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $f577eb5369177259$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $f577eb5369177259$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$f577eb5369177259$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $f577eb5369177259$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $f577eb5369177259$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $f577eb5369177259$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$f577eb5369177259$var$isSameRoute(aChild, bChild))) ?? false;
}
var $f577eb5369177259$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $f577eb5369177259$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $f577eb5369177259$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $f577eb5369177259$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $f577eb5369177259$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $f577eb5369177259$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $f577eb5369177259$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $f577eb5369177259$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $f577eb5369177259$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $f577eb5369177259$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $f577eb5369177259$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $f577eb5369177259$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $f577eb5369177259$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $f577eb5369177259$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $f577eb5369177259$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $f577eb5369177259$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $f577eb5369177259$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $f577eb5369177259$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $f577eb5369177259$var$isNonNullable(value) {
    return value !== void 0;
}
function $f577eb5369177259$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $f577eb5369177259$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($f577eb5369177259$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $f577eb5369177259$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $f577eb5369177259$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $f577eb5369177259$var$defaultDataStrategy(args);
    return $f577eb5369177259$var$runClientMiddlewarePipeline(args, ()=>$f577eb5369177259$var$defaultDataStrategy(args));
}
function $f577eb5369177259$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $f577eb5369177259$var$runMiddlewarePipeline(args, handler, processResult, $f577eb5369177259$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $f577eb5369177259$export$e0163cfdf7bc9cfa(result) ? $f577eb5369177259$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $f577eb5369177259$var$runClientMiddlewarePipeline(args, handler) {
    return $f577eb5369177259$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($f577eb5369177259$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $f577eb5369177259$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $f577eb5369177259$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $f577eb5369177259$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $f577eb5369177259$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $f577eb5369177259$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $f577eb5369177259$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $f577eb5369177259$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $f577eb5369177259$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $f577eb5369177259$var$loadLazyRoute(match.route, $f577eb5369177259$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $f577eb5369177259$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $f577eb5369177259$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $f577eb5369177259$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $f577eb5369177259$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $f577eb5369177259$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$f577eb5369177259$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($f577eb5369177259$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $f577eb5369177259$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $f577eb5369177259$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $f577eb5369177259$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $f577eb5369177259$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $f577eb5369177259$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $f577eb5369177259$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $f577eb5369177259$var$createDataFunctionUrl(request, path),
        pattern: $f577eb5369177259$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $f577eb5369177259$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $f577eb5369177259$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $f577eb5369177259$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $f577eb5369177259$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f577eb5369177259$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f577eb5369177259$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f577eb5369177259$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $f577eb5369177259$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($f577eb5369177259$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $f577eb5369177259$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $f577eb5369177259$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($f577eb5369177259$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $f577eb5369177259$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $f577eb5369177259$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $f577eb5369177259$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($f577eb5369177259$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $f577eb5369177259$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $f577eb5369177259$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$f577eb5369177259$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f577eb5369177259$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $f577eb5369177259$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $f577eb5369177259$export$961a3ef7a4da3a39(location) {
    try {
        return $f577eb5369177259$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $f577eb5369177259$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($f577eb5369177259$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $f577eb5369177259$export$825a82322d91916e.test(normalizedLocation) ? new URL($f577eb5369177259$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($f577eb5369177259$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $f577eb5369177259$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $f577eb5369177259$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($f577eb5369177259$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $f577eb5369177259$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f577eb5369177259$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f577eb5369177259$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $f577eb5369177259$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f577eb5369177259$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $f577eb5369177259$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f577eb5369177259$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f577eb5369177259$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f577eb5369177259$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $f577eb5369177259$export$f5708dca728d7177(!$f577eb5369177259$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f577eb5369177259$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $f577eb5369177259$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $f577eb5369177259$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $f577eb5369177259$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f577eb5369177259$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $f577eb5369177259$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $f577eb5369177259$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($f577eb5369177259$var$isErrorResult(result)) {
            let boundaryMatch = $f577eb5369177259$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($f577eb5369177259$var$isRedirectResult(result)) $f577eb5369177259$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $f577eb5369177259$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f577eb5369177259$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $f577eb5369177259$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f577eb5369177259$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f577eb5369177259$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $f577eb5369177259$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f577eb5369177259$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f577eb5369177259$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $f577eb5369177259$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $f577eb5369177259$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($f577eb5369177259$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $f577eb5369177259$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(path) : path;
    return $f577eb5369177259$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $f577eb5369177259$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $f577eb5369177259$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $f577eb5369177259$var$dataWithResponseInitToErrorResponse(data2) {
    return new $f577eb5369177259$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $f577eb5369177259$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $f577eb5369177259$var$isDataStrategyResult(value));
}
function $f577eb5369177259$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $f577eb5369177259$var$isRedirectDataStrategyResult(result) {
    return $f577eb5369177259$export$3f1eb41d9a6a6a27(result.result) && $f577eb5369177259$var$redirectStatusCodes.has(result.result.status);
}
function $f577eb5369177259$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $f577eb5369177259$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $f577eb5369177259$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $f577eb5369177259$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f577eb5369177259$export$794b2760043cf8cd(statusCode) {
    return $f577eb5369177259$var$redirectStatusCodes.has(statusCode);
}
function $f577eb5369177259$export$6e80290866a84dd4(result) {
    return $f577eb5369177259$export$3f1eb41d9a6a6a27(result) && $f577eb5369177259$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $f577eb5369177259$var$isValidMethod(method) {
    return $f577eb5369177259$var$validRequestMethods.has(method.toUpperCase());
}
function $f577eb5369177259$export$cbae47800eb95bc3(method) {
    return $f577eb5369177259$var$validMutationMethods.has(method.toUpperCase());
}
function $f577eb5369177259$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f577eb5369177259$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f577eb5369177259$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $f577eb5369177259$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f577eb5369177259$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $f577eb5369177259$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $f577eb5369177259$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f577eb5369177259$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $f577eb5369177259$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $f577eb5369177259$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $f577eb5369177259$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f577eb5369177259$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $f577eb5369177259$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f577eb5369177259$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f577eb5369177259$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $f577eb5369177259$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $f577eb5369177259$export$2eeee58951ff3c1c = $d1Z4Y.createContext(null);
$f577eb5369177259$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $f577eb5369177259$export$315e3ffb01f217 = $d1Z4Y.createContext(null);
$f577eb5369177259$export$315e3ffb01f217.displayName = "DataRouterState";
var $f577eb5369177259$export$717f757c655223f1 = $d1Z4Y.createContext(false);
function $f577eb5369177259$var$useIsRSCRouterContext() {
    return $d1Z4Y.useContext($f577eb5369177259$export$717f757c655223f1);
}
var $f577eb5369177259$export$3681f408decb40d1 = $d1Z4Y.createContext({
    isTransitioning: false
});
$f577eb5369177259$export$3681f408decb40d1.displayName = "ViewTransition";
var $f577eb5369177259$export$cb3f1df1bef00a39 = $d1Z4Y.createContext(/* @__PURE__ */ new Map());
$f577eb5369177259$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $f577eb5369177259$var$AwaitContext = $d1Z4Y.createContext(null);
$f577eb5369177259$var$AwaitContext.displayName = "Await";
var $f577eb5369177259$export$2666c20e15407622 = (props)=>$d1Z4Y.createElement($f577eb5369177259$var$AwaitContext.Provider, props);
var $f577eb5369177259$export$3044ab7fdabeaee6 = $d1Z4Y.createContext(null);
$f577eb5369177259$export$3044ab7fdabeaee6.displayName = "Navigation";
var $f577eb5369177259$export$e6a44b110a0c44d3 = $d1Z4Y.createContext(null);
$f577eb5369177259$export$e6a44b110a0c44d3.displayName = "Location";
var $f577eb5369177259$export$aac280ed165a4397 = $d1Z4Y.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$f577eb5369177259$export$aac280ed165a4397.displayName = "Route";
var $f577eb5369177259$var$RouteErrorContext = $d1Z4Y.createContext(null);
$f577eb5369177259$var$RouteErrorContext.displayName = "RouteError";
var $f577eb5369177259$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $f577eb5369177259$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $f577eb5369177259$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $f577eb5369177259$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $f577eb5369177259$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$f577eb5369177259$var$ERROR_DIGEST_BASE}:${$f577eb5369177259$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $f577eb5369177259$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$f577eb5369177259$var$ERROR_DIGEST_BASE}:${$f577eb5369177259$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $f577eb5369177259$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $f577eb5369177259$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $f577eb5369177259$export$f5708dca728d7177($f577eb5369177259$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $f577eb5369177259$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $f577eb5369177259$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $f577eb5369177259$export$9c954a9d03d32f4a() {
    return $d1Z4Y.useContext($f577eb5369177259$export$e6a44b110a0c44d3) != null;
}
function $f577eb5369177259$export$45d76561a5302f2b() {
    $f577eb5369177259$export$f5708dca728d7177($f577eb5369177259$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $d1Z4Y.useContext($f577eb5369177259$export$e6a44b110a0c44d3).location;
}
function $f577eb5369177259$export$1b3f31771c5d07c() {
    return $d1Z4Y.useContext($f577eb5369177259$export$e6a44b110a0c44d3).navigationType;
}
function $f577eb5369177259$export$6c330e8992e8a295(pattern) {
    $f577eb5369177259$export$f5708dca728d7177($f577eb5369177259$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $f577eb5369177259$export$45d76561a5302f2b();
    return $d1Z4Y.useMemo(()=>$f577eb5369177259$export$81336c211d5ff295(pattern, $f577eb5369177259$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $f577eb5369177259$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $f577eb5369177259$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6).static;
    if (!isStatic) $d1Z4Y.useLayoutEffect(cb);
}
function $f577eb5369177259$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    return isDataRoute ? $f577eb5369177259$var$useNavigateStable() : $f577eb5369177259$var$useNavigateUnstable();
}
function $f577eb5369177259$var$useNavigateUnstable() {
    $f577eb5369177259$export$f5708dca728d7177($f577eb5369177259$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $d1Z4Y.useContext($f577eb5369177259$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let { matches: matches } = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    let { pathname: locationPathname } = $f577eb5369177259$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($f577eb5369177259$var$getResolveToMatches(matches));
    let activeRef = $d1Z4Y.useRef(false);
    $f577eb5369177259$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $d1Z4Y.useCallback((to, options = {})=>{
        $f577eb5369177259$var$warning(activeRef.current, $f577eb5369177259$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $f577eb5369177259$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f577eb5369177259$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $f577eb5369177259$var$OutletContext = $d1Z4Y.createContext(null);
function $f577eb5369177259$export$4138103a3ae699cc() {
    return $d1Z4Y.useContext($f577eb5369177259$var$OutletContext);
}
function $f577eb5369177259$export$a3be3530d8e40d0b(context) {
    let outlet = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397).outlet;
    return $d1Z4Y.useMemo(()=>outlet && /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $f577eb5369177259$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $f577eb5369177259$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    let { pathname: locationPathname } = $f577eb5369177259$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($f577eb5369177259$var$getResolveToMatches(matches));
    return $d1Z4Y.useMemo(()=>$f577eb5369177259$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $f577eb5369177259$export$5d3fca4a98652595(routes, locationArg) {
    return $f577eb5369177259$var$useRoutesImpl(routes, locationArg);
}
function $f577eb5369177259$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $f577eb5369177259$export$f5708dca728d7177($f577eb5369177259$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($f577eb5369177259$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $f577eb5369177259$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $f577eb5369177259$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $f577eb5369177259$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $f577eb5369177259$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $f577eb5369177259$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($f577eb5369177259$export$945fecf35a8ef089) {
        $f577eb5369177259$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $f577eb5369177259$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $f577eb5369177259$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $f577eb5369177259$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $f577eb5369177259$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f577eb5369177259$var$DefaultErrorComponent() {
    let error = $f577eb5369177259$export$ed527bf60f6e05f2();
    let message = $f577eb5369177259$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($f577eb5369177259$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, /* @__PURE__ */ $d1Z4Y.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $d1Z4Y.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $d1Z4Y.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $d1Z4Y.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, /* @__PURE__ */ $d1Z4Y.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $d1Z4Y.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $d1Z4Y.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $f577eb5369177259$var$defaultErrorElement = /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$DefaultErrorComponent, null);
var $f577eb5369177259$var$RenderErrorBoundary = class extends $d1Z4Y.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $f577eb5369177259$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$f577eb5369177259$var$RenderErrorBoundary.contextType = $f577eb5369177259$export$717f757c655223f1;
var $f577eb5369177259$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $f577eb5369177259$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $f577eb5369177259$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $f577eb5369177259$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $f577eb5369177259$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ($f577eb5369177259$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($f577eb5369177259$var$isBrowser && !$f577eb5369177259$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $f577eb5369177259$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $d1Z4Y.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $f577eb5369177259$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $d1Z4Y.useContext($f577eb5369177259$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $f577eb5369177259$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $f577eb5369177259$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $f577eb5369177259$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $f577eb5369177259$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f577eb5369177259$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $d1Z4Y.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $f577eb5369177259$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $f577eb5369177259$var$useDataRouterContext(hookName) {
    let ctx = $d1Z4Y.useContext($f577eb5369177259$export$2eeee58951ff3c1c);
    $f577eb5369177259$export$f5708dca728d7177(ctx, $f577eb5369177259$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $f577eb5369177259$var$useDataRouterState(hookName) {
    let state = $d1Z4Y.useContext($f577eb5369177259$export$315e3ffb01f217);
    $f577eb5369177259$export$f5708dca728d7177(state, $f577eb5369177259$var$getDataRouterConsoleError(hookName));
    return state;
}
function $f577eb5369177259$var$useRouteContext(hookName) {
    let route = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    $f577eb5369177259$export$f5708dca728d7177(route, $f577eb5369177259$var$getDataRouterConsoleError(hookName));
    return route;
}
function $f577eb5369177259$var$useCurrentRouteId(hookName) {
    let route = $f577eb5369177259$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $f577eb5369177259$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $f577eb5369177259$var$useRouteId() {
    return $f577eb5369177259$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $f577eb5369177259$export$d0fd4b7106de2769() {
    let state = $f577eb5369177259$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $d1Z4Y.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $f577eb5369177259$export$600dc272ed516c15() {
    let dataRouterContext = $f577eb5369177259$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $f577eb5369177259$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $d1Z4Y.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $d1Z4Y.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $f577eb5369177259$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $f577eb5369177259$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $d1Z4Y.useMemo(()=>matches.map((m)=>$f577eb5369177259$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $f577eb5369177259$export$1448a5050d252c4d() {
    let state = $f577eb5369177259$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $f577eb5369177259$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $f577eb5369177259$export$fd5d37484eab868d(routeId) {
    let state = $f577eb5369177259$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $f577eb5369177259$export$fdc00f3f26066d5e() {
    let state = $f577eb5369177259$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $f577eb5369177259$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $f577eb5369177259$export$ed527bf60f6e05f2() {
    let error = $d1Z4Y.useContext($f577eb5369177259$var$RouteErrorContext);
    let state = $f577eb5369177259$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $f577eb5369177259$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $f577eb5369177259$export$78a72ddb39bdd145() {
    let value = $d1Z4Y.useContext($f577eb5369177259$var$AwaitContext);
    return value?._data;
}
function $f577eb5369177259$export$17f53340677d5831() {
    let value = $d1Z4Y.useContext($f577eb5369177259$var$AwaitContext);
    return value?._error;
}
var $f577eb5369177259$var$blockerId = 0;
function $f577eb5369177259$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $f577eb5369177259$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $f577eb5369177259$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $d1Z4Y.useState("");
    let blockerFunction = $d1Z4Y.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $f577eb5369177259$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $f577eb5369177259$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $d1Z4Y.useEffect(()=>{
        let key = String(++$f577eb5369177259$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $d1Z4Y.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $f577eb5369177259$export$386d57f03f0b2883;
}
function $f577eb5369177259$var$useNavigateStable() {
    let { router: router } = $f577eb5369177259$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $f577eb5369177259$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $d1Z4Y.useRef(false);
    $f577eb5369177259$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $d1Z4Y.useCallback(async (to, options = {})=>{
        $f577eb5369177259$var$warning(activeRef.current, $f577eb5369177259$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $f577eb5369177259$var$alreadyWarned = {};
function $f577eb5369177259$var$warningOnce(key, cond, message) {
    if (!cond && !$f577eb5369177259$var$alreadyWarned[key]) {
        $f577eb5369177259$var$alreadyWarned[key] = true;
        $f577eb5369177259$var$warning(false, message);
    }
}
function $f577eb5369177259$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $f577eb5369177259$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $f577eb5369177259$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $f577eb5369177259$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $f577eb5369177259$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $f577eb5369177259$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $d1Z4Y.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$f577eb5369177259$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $d1Z4Y.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$f577eb5369177259$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $d1Z4Y.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $f577eb5369177259$var$alreadyWarned2 = {};
function $f577eb5369177259$export$5b28268982f175ba(condition, message) {
    if (!condition && !$f577eb5369177259$var$alreadyWarned2[message]) {
        $f577eb5369177259$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $f577eb5369177259$var$USE_OPTIMISTIC = "useOptimistic";
var $f577eb5369177259$var$useOptimisticImpl = $d1Z4Y[$f577eb5369177259$var$USE_OPTIMISTIC];
var $f577eb5369177259$var$stableUseOptimisticSetter = ()=>void 0;
function $f577eb5369177259$var$useOptimisticSafe(val) {
    if ($f577eb5369177259$var$useOptimisticImpl) return $f577eb5369177259$var$useOptimisticImpl(val);
    else return [
        val,
        $f577eb5369177259$var$stableUseOptimisticSetter
    ];
}
function $f577eb5369177259$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($f577eb5369177259$export$945fecf35a8ef089) {
            if (route.element) $f577eb5369177259$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $d1Z4Y.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($f577eb5369177259$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $f577eb5369177259$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $d1Z4Y.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($f577eb5369177259$export$945fecf35a8ef089) {
            if (route.errorElement) $f577eb5369177259$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $d1Z4Y.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $f577eb5369177259$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $f577eb5369177259$export$f30f7e456d254e83(routes, opts) {
    return $f577eb5369177259$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $f577eb5369177259$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $f577eb5369177259$export$e2fd2c03906469db,
        mapRouteProperties: $f577eb5369177259$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $f577eb5369177259$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $f577eb5369177259$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $f577eb5369177259$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $d1Z4Y.useState(router.state);
    let [state, setOptimisticState] = $f577eb5369177259$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $d1Z4Y.useState();
    let [vtContext, setVtContext] = $d1Z4Y.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $d1Z4Y.useState();
    let [transition, setTransition] = $d1Z4Y.useState();
    let [interruption, setInterruption] = $d1Z4Y.useState();
    let fetcherData = $d1Z4Y.useRef(/* @__PURE__ */ new Map());
    let setState = $d1Z4Y.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $f577eb5369177259$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $f577eb5369177259$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $f577eb5369177259$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $d1Z4Y.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$f577eb5369177259$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $d1Z4Y.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $d1Z4Y.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $f577eb5369177259$var$Deferred());
    }, [
        vtContext
    ]);
    $d1Z4Y.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $d1Z4Y.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$f577eb5369177259$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $d1Z4Y.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $d1Z4Y.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $d1Z4Y.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $d1Z4Y.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $f577eb5369177259$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $f577eb5369177259$var$MemoizedDataRoutes = $d1Z4Y.memo($f577eb5369177259$var$DataRoutes2);
function $f577eb5369177259$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $f577eb5369177259$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $f577eb5369177259$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $d1Z4Y.useRef();
    if (historyRef.current == null) historyRef.current = $f577eb5369177259$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $d1Z4Y.useState({
        action: history.action,
        location: history.location
    });
    let setState = $d1Z4Y.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $d1Z4Y.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $d1Z4Y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $f577eb5369177259$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $f577eb5369177259$export$f5708dca728d7177($f577eb5369177259$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    $f577eb5369177259$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    let { pathname: locationPathname } = $f577eb5369177259$export$45d76561a5302f2b();
    let navigate = $f577eb5369177259$export$9770f232ac06a008();
    let path = $f577eb5369177259$var$resolveTo(to, $f577eb5369177259$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $d1Z4Y.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $f577eb5369177259$export$910ae8079b2c2852(props) {
    return $f577eb5369177259$export$a3be3530d8e40d0b(props.context);
}
function $f577eb5369177259$export$e7b0ac011bb776c6(props) {
    $f577eb5369177259$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $f577eb5369177259$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $f577eb5369177259$export$f5708dca728d7177(!$f577eb5369177259$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $d1Z4Y.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $f577eb5369177259$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $d1Z4Y.useMemo(()=>{
        let trailingPathname = $f577eb5369177259$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $f577eb5369177259$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $f577eb5369177259$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $f577eb5369177259$export$5d3fca4a98652595($f577eb5369177259$export$16da398f5434bdec(children), location);
}
function $f577eb5369177259$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $d1Z4Y.useContext($f577eb5369177259$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $d1Z4Y.useContext($f577eb5369177259$export$315e3ffb01f217);
    let onError = $d1Z4Y.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $f577eb5369177259$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$ResolveAwait, null, children));
}
var $f577eb5369177259$var$AwaitErrorBoundary = class extends $d1Z4Y.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $f577eb5369177259$var$ResolveAwait({ children: children }) {
    let data2 = $f577eb5369177259$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, toRender);
}
function $f577eb5369177259$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $d1Z4Y.Children.forEach(children, (element, index)=>{
        if (!$d1Z4Y.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $d1Z4Y.Fragment) {
            routes.push.apply(routes, $f577eb5369177259$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $f577eb5369177259$export$f5708dca728d7177(element.type === $f577eb5369177259$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $f577eb5369177259$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f577eb5369177259$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $f577eb5369177259$export$9b5b6d122dea0c88 = $f577eb5369177259$export$16da398f5434bdec;
function $f577eb5369177259$export$daf73786167a7f72(matches) {
    return $f577eb5369177259$var$_renderMatches(matches);
}
function $f577eb5369177259$var$useRouteComponentProps() {
    return {
        params: $f577eb5369177259$export$99eaa27ddbbb95ef(),
        loaderData: $f577eb5369177259$export$1448a5050d252c4d(),
        actionData: $f577eb5369177259$export$fdc00f3f26066d5e(),
        matches: $f577eb5369177259$export$2378eb7f5ff86053()
    };
}
function $f577eb5369177259$export$6c4f3826290c37af({ children: children }) {
    const props = $f577eb5369177259$var$useRouteComponentProps();
    return $d1Z4Y.cloneElement(children, props);
}
function $f577eb5369177259$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $f577eb5369177259$var$useRouteComponentProps();
        return $d1Z4Y.createElement(Component4, props);
    };
}
function $f577eb5369177259$var$useHydrateFallbackProps() {
    return {
        params: $f577eb5369177259$export$99eaa27ddbbb95ef(),
        loaderData: $f577eb5369177259$export$1448a5050d252c4d(),
        actionData: $f577eb5369177259$export$fdc00f3f26066d5e()
    };
}
function $f577eb5369177259$export$f8cff34f39c1932a({ children: children }) {
    const props = $f577eb5369177259$var$useHydrateFallbackProps();
    return $d1Z4Y.cloneElement(children, props);
}
function $f577eb5369177259$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $f577eb5369177259$var$useHydrateFallbackProps();
        return $d1Z4Y.createElement(HydrateFallback, props);
    };
}
function $f577eb5369177259$var$useErrorBoundaryProps() {
    return {
        params: $f577eb5369177259$export$99eaa27ddbbb95ef(),
        loaderData: $f577eb5369177259$export$1448a5050d252c4d(),
        actionData: $f577eb5369177259$export$fdc00f3f26066d5e(),
        error: $f577eb5369177259$export$ed527bf60f6e05f2()
    };
}
function $f577eb5369177259$export$e5afde5c4b6d747b({ children: children }) {
    const props = $f577eb5369177259$var$useErrorBoundaryProps();
    return $d1Z4Y.cloneElement(children, props);
}
function $f577eb5369177259$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $f577eb5369177259$var$useErrorBoundaryProps();
        return $d1Z4Y.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $f577eb5369177259$var$defaultMethod = "get";
var $f577eb5369177259$var$defaultEncType = "application/x-www-form-urlencoded";
function $f577eb5369177259$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $f577eb5369177259$var$isButtonElement(object) {
    return $f577eb5369177259$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $f577eb5369177259$var$isFormElement(object) {
    return $f577eb5369177259$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $f577eb5369177259$var$isInputElement(object) {
    return $f577eb5369177259$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $f577eb5369177259$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $f577eb5369177259$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$f577eb5369177259$var$isModifiedEvent(event);
}
function $f577eb5369177259$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $f577eb5369177259$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $f577eb5369177259$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $f577eb5369177259$var$_formDataSupportsSubmitter = null;
function $f577eb5369177259$var$isFormDataSubmitterSupported() {
    if ($f577eb5369177259$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $f577eb5369177259$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $f577eb5369177259$var$_formDataSupportsSubmitter = true;
    }
    return $f577eb5369177259$var$_formDataSupportsSubmitter;
}
var $f577eb5369177259$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $f577eb5369177259$var$getFormEncType(encType) {
    if (encType != null && !$f577eb5369177259$var$supportedFormEncTypes.has(encType)) {
        $f577eb5369177259$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$f577eb5369177259$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $f577eb5369177259$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($f577eb5369177259$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $f577eb5369177259$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $f577eb5369177259$var$defaultMethod;
        encType = $f577eb5369177259$var$getFormEncType(target.getAttribute("enctype")) || $f577eb5369177259$var$defaultEncType;
        formData = new FormData(target);
    } else if ($f577eb5369177259$var$isButtonElement(target) || $f577eb5369177259$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $f577eb5369177259$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $f577eb5369177259$var$defaultMethod;
        encType = $f577eb5369177259$var$getFormEncType(target.getAttribute("formenctype")) || $f577eb5369177259$var$getFormEncType(form.getAttribute("enctype")) || $f577eb5369177259$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$f577eb5369177259$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($f577eb5369177259$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $f577eb5369177259$var$defaultMethod;
        action = null;
        encType = $f577eb5369177259$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $f577eb5369177259$var$HOLE = -1;
var $f577eb5369177259$var$NAN = -2;
var $f577eb5369177259$var$NEGATIVE_INFINITY = -3;
var $f577eb5369177259$var$NEGATIVE_ZERO = -4;
var $f577eb5369177259$var$NULL = -5;
var $f577eb5369177259$var$POSITIVE_INFINITY = -6;
var $f577eb5369177259$var$UNDEFINED = -7;
var $f577eb5369177259$var$TYPE_BIGINT = "B";
var $f577eb5369177259$var$TYPE_DATE = "D";
var $f577eb5369177259$var$TYPE_ERROR = "E";
var $f577eb5369177259$var$TYPE_MAP = "M";
var $f577eb5369177259$var$TYPE_NULL_OBJECT = "N";
var $f577eb5369177259$var$TYPE_PROMISE = "P";
var $f577eb5369177259$var$TYPE_REGEXP = "R";
var $f577eb5369177259$var$TYPE_SET = "S";
var $f577eb5369177259$var$TYPE_SYMBOL = "Y";
var $f577eb5369177259$var$TYPE_URL = "U";
var $f577eb5369177259$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $f577eb5369177259$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $f577eb5369177259$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $f577eb5369177259$var$TIME_LIMIT_MS = 1;
var $f577eb5369177259$var$getNow = ()=>Date.now();
var $f577eb5369177259$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $f577eb5369177259$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $f577eb5369177259$var$UNDEFINED;
    if (input === null) return $f577eb5369177259$var$NULL;
    if (Number.isNaN(input)) return $f577eb5369177259$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $f577eb5369177259$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $f577eb5369177259$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $f577eb5369177259$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $f577eb5369177259$var$stringify.call(this, stack);
    return index;
}
async function $f577eb5369177259$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $f577eb5369177259$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $f577eb5369177259$var$UNDEFINED;
        if (value === null) return $f577eb5369177259$var$NULL;
        if (Number.isNaN(value)) return $f577eb5369177259$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $f577eb5369177259$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $f577eb5369177259$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $f577eb5369177259$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $f577eb5369177259$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $f577eb5369177259$var$TIME_LIMIT_MS) {
            await $f577eb5369177259$var$yieldToMain();
            lastYieldTime = $f577eb5369177259$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$f577eb5369177259$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$f577eb5369177259$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$f577eb5369177259$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $f577eb5369177259$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$f577eb5369177259$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$f577eb5369177259$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$f577eb5369177259$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$f577eb5369177259$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$f577eb5369177259$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$f577eb5369177259$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$f577eb5369177259$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$f577eb5369177259$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$f577eb5369177259$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$f577eb5369177259$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($f577eb5369177259$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $f577eb5369177259$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $f577eb5369177259$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $f577eb5369177259$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $f577eb5369177259$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $f577eb5369177259$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $f577eb5369177259$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $f577eb5369177259$var$hydrate.call(this, startIndex);
}
function $f577eb5369177259$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $f577eb5369177259$var$UNDEFINED:
                set(void 0);
                continue;
            case $f577eb5369177259$var$NULL:
                set(null);
                continue;
            case $f577eb5369177259$var$NAN:
                set(NaN);
                continue;
            case $f577eb5369177259$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $f577eb5369177259$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $f577eb5369177259$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $f577eb5369177259$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $f577eb5369177259$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $f577eb5369177259$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $f577eb5369177259$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $f577eb5369177259$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $f577eb5369177259$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $f577eb5369177259$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $f577eb5369177259$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $f577eb5369177259$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $f577eb5369177259$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $f577eb5369177259$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $f577eb5369177259$var$globalObj && $f577eb5369177259$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $f577eb5369177259$var$globalObj && typeof $f577eb5369177259$var$globalObj[errorType] === "function" ? new $f577eb5369177259$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $f577eb5369177259$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $f577eb5369177259$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $f577eb5369177259$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $f577eb5369177259$var$Deferred2();
    const reader = readable.pipeThrough($f577eb5369177259$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $f577eb5369177259$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $f577eb5369177259$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $f577eb5369177259$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $f577eb5369177259$var$unflatten.call(this, line)
    };
}
async function $f577eb5369177259$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $f577eb5369177259$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $f577eb5369177259$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $f577eb5369177259$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $f577eb5369177259$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $f577eb5369177259$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $f577eb5369177259$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $f577eb5369177259$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$f577eb5369177259$var$TYPE_PROMISE}${deferredId}:[["${$f577eb5369177259$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$f577eb5369177259$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$f577eb5369177259$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $f577eb5369177259$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$f577eb5369177259$var$TYPE_ERROR}${deferredId}:[["${$f577eb5369177259$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$f577eb5369177259$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$f577eb5369177259$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $f577eb5369177259$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $f577eb5369177259$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $f577eb5369177259$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $f577eb5369177259$export$4cf11838cdc2a8a8(html) {
    return html.replace($f577eb5369177259$var$ESCAPE_REGEX, (match)=>$f577eb5369177259$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $f577eb5369177259$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $f577eb5369177259$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $f577eb5369177259$var$SingleFetchNoResultError = class extends Error {
};
var $f577eb5369177259$export$ae9272e641ead836 = 202;
var $f577eb5369177259$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $f577eb5369177259$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $d1Z4Y.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$f577eb5369177259$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, scriptTag, /* @__PURE__ */ $d1Z4Y.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, scriptTag, /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Suspense, null, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $f577eb5369177259$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $f577eb5369177259$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $f577eb5369177259$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $f577eb5369177259$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $f577eb5369177259$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $f577eb5369177259$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $f577eb5369177259$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $f577eb5369177259$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $f577eb5369177259$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $f577eb5369177259$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $f577eb5369177259$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $f577eb5369177259$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($f577eb5369177259$export$3f1eb41d9a6a6a27(result.result) || $f577eb5369177259$export$972111febbeef05b(result.result) || $f577eb5369177259$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $f577eb5369177259$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $f577eb5369177259$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $f577eb5369177259$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $f577eb5369177259$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$f577eb5369177259$var$createDeferred2());
    let singleFetchDfd = $f577eb5369177259$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $f577eb5369177259$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $f577eb5369177259$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $f577eb5369177259$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $f577eb5369177259$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $f577eb5369177259$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $f577eb5369177259$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $f577eb5369177259$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $f577eb5369177259$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $f577eb5369177259$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $f577eb5369177259$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $f577eb5369177259$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$f577eb5369177259$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$f577eb5369177259$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $f577eb5369177259$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $f577eb5369177259$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $f577eb5369177259$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $f577eb5369177259$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $f577eb5369177259$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $f577eb5369177259$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($f577eb5369177259$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $f577eb5369177259$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $f577eb5369177259$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($f577eb5369177259$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$f577eb5369177259$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $f577eb5369177259$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $f577eb5369177259$export$4023ad4ecd4126a2(body, global) {
    return $f577eb5369177259$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $f577eb5369177259$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $f577eb5369177259$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$f577eb5369177259$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $f577eb5369177259$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $f577eb5369177259$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $f577eb5369177259$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $f577eb5369177259$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $f577eb5369177259$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $f577eb5369177259$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $f577eb5369177259$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $f577eb5369177259$var$getModuleLinkHrefs(matches, manifest);
    return $f577eb5369177259$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $f577eb5369177259$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $f577eb5369177259$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $f577eb5369177259$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($f577eb5369177259$var$prefetchStyleLink));
}
async function $f577eb5369177259$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$f577eb5369177259$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$f577eb5369177259$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$f577eb5369177259$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($f577eb5369177259$var$prefetchStyleLink));
}
async function $f577eb5369177259$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $f577eb5369177259$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $f577eb5369177259$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $f577eb5369177259$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $f577eb5369177259$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $f577eb5369177259$var$dedupeLinkDescriptors(links.flat(1).filter($f577eb5369177259$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $f577eb5369177259$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $f577eb5369177259$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $f577eb5369177259$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $f577eb5369177259$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $f577eb5369177259$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $f577eb5369177259$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$f577eb5369177259$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($f577eb5369177259$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $f577eb5369177259$var$_isPreloadSupported;
function $f577eb5369177259$var$isPreloadSupported() {
    if ($f577eb5369177259$var$_isPreloadSupported !== void 0) return $f577eb5369177259$var$_isPreloadSupported;
    let el = document.createElement("link");
    $f577eb5369177259$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $f577eb5369177259$var$_isPreloadSupported;
}
function $f577eb5369177259$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $f577eb5369177259$var$useFrameworkContext();
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $f577eb5369177259$export$945fecf35a8ef089 ? /* @__PURE__ */ $d1Z4Y.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $f577eb5369177259$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $f577eb5369177259$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $f577eb5369177259$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $f577eb5369177259$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$RemixRootDefaultErrorBoundary, {
            error: $f577eb5369177259$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $d1Z4Y.createElement(routeModule.Layout, null, /* @__PURE__ */ $d1Z4Y.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $d1Z4Y.createElement(routeModule.Layout, null, /* @__PURE__ */ $d1Z4Y.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $d1Z4Y.createElement(routeModule.Layout, null, /* @__PURE__ */ $d1Z4Y.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $f577eb5369177259$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $f577eb5369177259$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $f577eb5369177259$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$f577eb5369177259$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $f577eb5369177259$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $f577eb5369177259$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $f577eb5369177259$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $f577eb5369177259$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $f577eb5369177259$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $f577eb5369177259$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $f577eb5369177259$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $f577eb5369177259$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $f577eb5369177259$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $f577eb5369177259$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $f577eb5369177259$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $f577eb5369177259$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $f577eb5369177259$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$f577eb5369177259$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $f577eb5369177259$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $f577eb5369177259$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $f577eb5369177259$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $f577eb5369177259$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $f577eb5369177259$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $f577eb5369177259$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $f577eb5369177259$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $f577eb5369177259$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $f577eb5369177259$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $f577eb5369177259$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $f577eb5369177259$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $f577eb5369177259$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $f577eb5369177259$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $f577eb5369177259$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $f577eb5369177259$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $f577eb5369177259$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $f577eb5369177259$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $f577eb5369177259$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $f577eb5369177259$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $f577eb5369177259$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $f577eb5369177259$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $f577eb5369177259$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $f577eb5369177259$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $f577eb5369177259$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $f577eb5369177259$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $f577eb5369177259$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $f577eb5369177259$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $f577eb5369177259$var$nextPaths = /* @__PURE__ */ new Set();
var $f577eb5369177259$var$discoveredPathsMaxSize = 1e3;
var $f577eb5369177259$var$discoveredPaths = /* @__PURE__ */ new Set();
var $f577eb5369177259$export$b5915cf27fa06b9f = 7680;
function $f577eb5369177259$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $f577eb5369177259$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $f577eb5369177259$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $f577eb5369177259$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $f577eb5369177259$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$f577eb5369177259$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($f577eb5369177259$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $f577eb5369177259$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $f577eb5369177259$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $f577eb5369177259$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $d1Z4Y.useEffect(()=>{
        if (!$f577eb5369177259$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$f577eb5369177259$var$discoveredPaths.has(pathname)) $f577eb5369177259$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($f577eb5369177259$var$nextPaths.keys()).filter((path)=>{
                if ($f577eb5369177259$var$discoveredPaths.has(path)) {
                    $f577eb5369177259$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $f577eb5369177259$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $f577eb5369177259$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $f577eb5369177259$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $f577eb5369177259$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $f577eb5369177259$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $f577eb5369177259$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $f577eb5369177259$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($f577eb5369177259$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $f577eb5369177259$export$b5915cf27fa06b9f) {
        $f577eb5369177259$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($f577eb5369177259$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($f577eb5369177259$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($f577eb5369177259$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$f577eb5369177259$var$addToFifoQueue(p, $f577eb5369177259$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $f577eb5369177259$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $f577eb5369177259$var$addToFifoQueue(path, queue) {
    if (queue.size >= $f577eb5369177259$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $f577eb5369177259$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $f577eb5369177259$var$useDataRouterContext2() {
    let context = $d1Z4Y.useContext($f577eb5369177259$export$2eeee58951ff3c1c);
    $f577eb5369177259$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $f577eb5369177259$var$useDataRouterStateContext() {
    let context = $d1Z4Y.useContext($f577eb5369177259$export$315e3ffb01f217);
    $f577eb5369177259$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $f577eb5369177259$export$208d6a3bc3aa62bd = $d1Z4Y.createContext(void 0);
$f577eb5369177259$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $f577eb5369177259$var$useFrameworkContext() {
    let context = $d1Z4Y.useContext($f577eb5369177259$export$208d6a3bc3aa62bd);
    $f577eb5369177259$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $f577eb5369177259$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $d1Z4Y.useContext($f577eb5369177259$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $d1Z4Y.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $d1Z4Y.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $d1Z4Y.useRef(null);
    $d1Z4Y.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $d1Z4Y.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $f577eb5369177259$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $f577eb5369177259$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $f577eb5369177259$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $f577eb5369177259$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $f577eb5369177259$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $f577eb5369177259$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $f577eb5369177259$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$f577eb5369177259$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $f577eb5369177259$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $f577eb5369177259$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $f577eb5369177259$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $f577eb5369177259$var$useDataRouterStateContext();
    let matches = $f577eb5369177259$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $d1Z4Y.useMemo(()=>$f577eb5369177259$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $d1Z4Y.createElement("style", {
        [$f577eb5369177259$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $d1Z4Y.createElement("link", {
        [$f577eb5369177259$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$f577eb5369177259$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $d1Z4Y.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $f577eb5369177259$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $f577eb5369177259$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $f577eb5369177259$var$useFrameworkContext();
    let { router: router } = $f577eb5369177259$var$useDataRouterContext2();
    let matches = $d1Z4Y.useMemo(()=>$f577eb5369177259$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $f577eb5369177259$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $f577eb5369177259$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $d1Z4Y.useState([]);
    $d1Z4Y.useEffect(()=>{
        let interrupted = false;
        $f577eb5369177259$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $f577eb5369177259$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let { future: future } = $f577eb5369177259$var$useFrameworkContext();
    let { basename: basename } = $f577eb5369177259$var$useDataRouterContext2();
    let dataHrefs = $d1Z4Y.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $f577eb5369177259$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $d1Z4Y.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $f577eb5369177259$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $f577eb5369177259$var$useFrameworkContext();
    let { basename: basename } = $f577eb5369177259$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $f577eb5369177259$var$useDataRouterStateContext();
    let newMatchesForData = $d1Z4Y.useMemo(()=>$f577eb5369177259$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $d1Z4Y.useMemo(()=>$f577eb5369177259$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $d1Z4Y.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $f577eb5369177259$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $d1Z4Y.useMemo(()=>$f577eb5369177259$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $f577eb5369177259$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $d1Z4Y.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $d1Z4Y.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $d1Z4Y.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $f577eb5369177259$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $f577eb5369177259$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $f577eb5369177259$var$useDataRouterStateContext();
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let _matches = $f577eb5369177259$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$f577eb5369177259$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $d1Z4Y.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $d1Z4Y.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $d1Z4Y.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $d1Z4Y.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $f577eb5369177259$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $d1Z4Y.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $f577eb5369177259$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $f577eb5369177259$var$isHydrated = false;
function $f577eb5369177259$export$3be068dde909e563() {
    $f577eb5369177259$var$isHydrated = true;
}
function $f577eb5369177259$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $f577eb5369177259$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $f577eb5369177259$var$useDataRouterContext2();
    let { matches: routerMatches } = $f577eb5369177259$var$useDataRouterStateContext();
    let isRSCRouterContext = $f577eb5369177259$var$useIsRSCRouterContext();
    let enableFogOfWar = $f577eb5369177259$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $f577eb5369177259$var$getActiveMatches(routerMatches, null, isSpaMode);
    $d1Z4Y.useEffect(()=>{
        $f577eb5369177259$export$3be068dde909e563();
    }, []);
    let initialScripts = $d1Z4Y.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $f577eb5369177259$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($f577eb5369177259$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, /* @__PURE__ */ $d1Z4Y.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $d1Z4Y.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $f577eb5369177259$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($f577eb5369177259$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $f577eb5369177259$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $f577eb5369177259$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $d1Z4Y.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $d1Z4Y.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $d1Z4Y.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $d1Z4Y.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $f577eb5369177259$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $f577eb5369177259$export$32e57f52df4b6e34 = class extends $d1Z4Y.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $f577eb5369177259$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $f577eb5369177259$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $d1Z4Y.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($f577eb5369177259$export$972111febbeef05b(error)) return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $d1Z4Y.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $f577eb5369177259$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $d1Z4Y.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $d1Z4Y.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $f577eb5369177259$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $f577eb5369177259$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $d1Z4Y.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $d1Z4Y.createElement("head", null, /* @__PURE__ */ $d1Z4Y.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $d1Z4Y.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $d1Z4Y.createElement("title", null, title)), /* @__PURE__ */ $d1Z4Y.createElement("body", null, /* @__PURE__ */ $d1Z4Y.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$ff0bf87698939488, null) : null)));
}
var $f577eb5369177259$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($f577eb5369177259$var$isBrowser2) window.__reactRouterVersion = "7.18.2";
} catch (e) {}
function $f577eb5369177259$export$1f3f55432a00e06d(routes, opts) {
    return $f577eb5369177259$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $f577eb5369177259$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $f577eb5369177259$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $f577eb5369177259$export$9269a41d8c4635e,
        hydrationRouteProperties: $f577eb5369177259$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $f577eb5369177259$export$1ba7ed8a3a7b3765(routes, opts) {
    return $f577eb5369177259$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $f577eb5369177259$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $f577eb5369177259$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $f577eb5369177259$export$9269a41d8c4635e,
        hydrationRouteProperties: $f577eb5369177259$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $f577eb5369177259$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $f577eb5369177259$var$deserializeErrors(state.errors)
    };
    return state;
}
function $f577eb5369177259$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $f577eb5369177259$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $f577eb5369177259$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $f577eb5369177259$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $d1Z4Y.useRef();
    if (historyRef.current == null) historyRef.current = $f577eb5369177259$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $d1Z4Y.useState({
        action: history.action,
        location: history.location
    });
    let setState = $d1Z4Y.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $d1Z4Y.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $d1Z4Y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $f577eb5369177259$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $d1Z4Y.useRef();
    if (historyRef.current == null) historyRef.current = $f577eb5369177259$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $d1Z4Y.useState({
        action: history.action,
        location: history.location
    });
    let setState = $d1Z4Y.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $d1Z4Y.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $d1Z4Y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $f577eb5369177259$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $d1Z4Y.useState({
        action: history.action,
        location: history.location
    });
    let setState = $d1Z4Y.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $d1Z4Y.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $d1Z4Y.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$f577eb5369177259$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $f577eb5369177259$export$a6c7ac8248d6e38a = $d1Z4Y.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $f577eb5369177259$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $f577eb5369177259$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $f577eb5369177259$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $f577eb5369177259$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $f577eb5369177259$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $f577eb5369177259$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $f577eb5369177259$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $d1Z4Y.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $f577eb5369177259$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, link, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$f577eb5369177259$export$a6c7ac8248d6e38a.displayName = "Link";
var $f577eb5369177259$export$b0d92dbee9b5b60d = $d1Z4Y.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $f577eb5369177259$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let routerState = $d1Z4Y.useContext($f577eb5369177259$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $f577eb5369177259$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $f577eb5369177259$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$f577eb5369177259$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $f577eb5369177259$export$a7fed597f4b8afd8 = $d1Z4Y.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $f577eb5369177259$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let submit = $f577eb5369177259$export$47c85c6e3a081d3();
    let formAction = $f577eb5369177259$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $f577eb5369177259$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $d1Z4Y.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $d1Z4Y.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$f577eb5369177259$export$a7fed597f4b8afd8.displayName = "Form";
function $f577eb5369177259$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $d1Z4Y.useContext($f577eb5369177259$export$208d6a3bc3aa62bd);
    let { basename: basename } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let matches = $f577eb5369177259$export$2378eb7f5ff86053();
    $f577eb5369177259$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $d1Z4Y.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $f577eb5369177259$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $d1Z4Y.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$f577eb5369177259$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $f577eb5369177259$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$f577eb5369177259$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$f577eb5369177259$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $f577eb5369177259$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $f577eb5369177259$var$useDataRouterContext3(hookName) {
    let ctx = $d1Z4Y.useContext($f577eb5369177259$export$2eeee58951ff3c1c);
    $f577eb5369177259$export$f5708dca728d7177(ctx, $f577eb5369177259$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $f577eb5369177259$var$useDataRouterState2(hookName) {
    let state = $d1Z4Y.useContext($f577eb5369177259$export$315e3ffb01f217);
    $f577eb5369177259$export$f5708dca728d7177(state, $f577eb5369177259$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $f577eb5369177259$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $f577eb5369177259$export$9770f232ac06a008();
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let path = $f577eb5369177259$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $d1Z4Y.useCallback((event)=>{
        if ($f577eb5369177259$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $f577eb5369177259$export$fe53371bee54353d(location) === $f577eb5369177259$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $d1Z4Y.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $f577eb5369177259$export$f1a78c17382fe22a(defaultInit) {
    $f577eb5369177259$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $d1Z4Y.useRef($f577eb5369177259$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $d1Z4Y.useRef(false);
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let searchParams = $d1Z4Y.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $f577eb5369177259$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $f577eb5369177259$export$9770f232ac06a008();
    let setSearchParams = $d1Z4Y.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $f577eb5369177259$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $f577eb5369177259$var$fetcherId = 0;
var $f577eb5369177259$var$getUniqueFetcherId = ()=>`__${String(++$f577eb5369177259$var$fetcherId)}__`;
function $f577eb5369177259$export$47c85c6e3a081d3() {
    let { router: router } = $f577eb5369177259$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let currentRouteId = $f577eb5369177259$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $d1Z4Y.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $f577eb5369177259$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $f577eb5369177259$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $f577eb5369177259$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let routeContext = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    $f577eb5369177259$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$f577eb5369177259$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $f577eb5369177259$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $f577eb5369177259$export$fe53371bee54353d(path);
}
function $f577eb5369177259$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $f577eb5369177259$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $f577eb5369177259$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $d1Z4Y.useContext($f577eb5369177259$export$cb3f1df1bef00a39);
    let route = $d1Z4Y.useContext($f577eb5369177259$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $f577eb5369177259$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $f577eb5369177259$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $f577eb5369177259$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $d1Z4Y.useId();
    let [fetcherKey, setFetcherKey] = $d1Z4Y.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $d1Z4Y.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $d1Z4Y.useCallback(async (href, opts)=>{
        $f577eb5369177259$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $f577eb5369177259$export$47c85c6e3a081d3();
    let submit = $d1Z4Y.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $d1Z4Y.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $d1Z4Y.useMemo(()=>{
        let FetcherForm2 = $d1Z4Y.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $f577eb5369177259$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $d1Z4Y.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $f577eb5369177259$export$fa996778a3a31087() {
    let state = $f577eb5369177259$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $d1Z4Y.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $f577eb5369177259$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $f577eb5369177259$var$savedScrollPositions = {};
function $f577eb5369177259$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $f577eb5369177259$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $f577eb5369177259$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $f577eb5369177259$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $f577eb5369177259$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $d1Z4Y.useContext($f577eb5369177259$export$3044ab7fdabeaee6);
    let location = $f577eb5369177259$export$45d76561a5302f2b();
    let matches = $f577eb5369177259$export$2378eb7f5ff86053();
    let navigation = $f577eb5369177259$export$d0fd4b7106de2769();
    $d1Z4Y.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $f577eb5369177259$var$usePageHide($d1Z4Y.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $f577eb5369177259$var$getScrollRestorationKey(location, matches, basename, getKey);
            $f577eb5369177259$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $f577eb5369177259$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($f577eb5369177259$var$savedScrollPositions));
        } catch (error) {
            $f577eb5369177259$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $d1Z4Y.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $f577eb5369177259$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $f577eb5369177259$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $d1Z4Y.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($f577eb5369177259$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$f577eb5369177259$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $d1Z4Y.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $f577eb5369177259$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $f577eb5369177259$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $d1Z4Y.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $f577eb5369177259$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $d1Z4Y.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $f577eb5369177259$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $f577eb5369177259$export$b273b3273281a049(when);
    $d1Z4Y.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $d1Z4Y.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $f577eb5369177259$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $d1Z4Y.useContext($f577eb5369177259$export$3681f408decb40d1);
    $f577eb5369177259$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $f577eb5369177259$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $f577eb5369177259$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $f577eb5369177259$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $f577eb5369177259$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $f577eb5369177259$export$81336c211d5ff295(path.pathname, nextPath) != null || $f577eb5369177259$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $f577eb5369177259$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $f577eb5369177259$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $f577eb5369177259$var$getStatelessNavigator();
    return /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $f577eb5369177259$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $f577eb5369177259$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $f577eb5369177259$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $f577eb5369177259$var$serializeErrors(context.errors)
        };
        let json = $f577eb5369177259$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $d1Z4Y.createElement($d1Z4Y.Fragment, null, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $d1Z4Y.createElement($f577eb5369177259$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $d1Z4Y.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $f577eb5369177259$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($f577eb5369177259$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $f577eb5369177259$var$getStatelessNavigator() {
    return {
        createHref: $f577eb5369177259$var$createHref,
        encodeLocation: $f577eb5369177259$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $f577eb5369177259$export$69163f0b72ec60d9(routes, opts) {
    return $f577eb5369177259$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $f577eb5369177259$export$9269a41d8c4635e
    });
}
function $f577eb5369177259$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $f577eb5369177259$export$87cb1a9238dc3fba(routes, $f577eb5369177259$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $f577eb5369177259$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $f577eb5369177259$var$createHref,
        encodeLocation: $f577eb5369177259$var$encodeLocation,
        getFetcher () {
            return $f577eb5369177259$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $f577eb5369177259$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $f577eb5369177259$var$createHref(to) {
    return typeof to === "string" ? to : $f577eb5369177259$export$fe53371bee54353d(to);
}
function $f577eb5369177259$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $f577eb5369177259$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $f577eb5369177259$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});

parcelRegister("eQZs6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $ad05972b9e5ea2ce$var$_gtag = $ad05972b9e5ea2ce$var$_interopRequireDefault((parcelRequire("aB6q0")));

var $ad05972b9e5ea2ce$var$_format = $ad05972b9e5ea2ce$var$_interopRequireDefault((parcelRequire("lmcwK")));
var $ad05972b9e5ea2ce$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $ad05972b9e5ea2ce$var$_excluded2 = [
    "title",
    "location"
], $ad05972b9e5ea2ce$var$_excluded3 = [
    "page",
    "hitType"
];
function $ad05972b9e5ea2ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ad05972b9e5ea2ce$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ad05972b9e5ea2ce$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ad05972b9e5ea2ce$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ad05972b9e5ea2ce$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ad05972b9e5ea2ce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ad05972b9e5ea2ce$var$_typeof(obj);
}
function $ad05972b9e5ea2ce$var$_toConsumableArray(arr) {
    return $ad05972b9e5ea2ce$var$_arrayWithoutHoles(arr) || $ad05972b9e5ea2ce$var$_iterableToArray(arr) || $ad05972b9e5ea2ce$var$_unsupportedIterableToArray(arr) || $ad05972b9e5ea2ce$var$_nonIterableSpread();
}
function $ad05972b9e5ea2ce$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ad05972b9e5ea2ce$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ad05972b9e5ea2ce$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ad05972b9e5ea2ce$var$_arrayLikeToArray(arr);
}
function $ad05972b9e5ea2ce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ad05972b9e5ea2ce$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ad05972b9e5ea2ce$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ad05972b9e5ea2ce$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ad05972b9e5ea2ce$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ad05972b9e5ea2ce$var$_slicedToArray(arr, i) {
    return $ad05972b9e5ea2ce$var$_arrayWithHoles(arr) || $ad05972b9e5ea2ce$var$_iterableToArrayLimit(arr, i) || $ad05972b9e5ea2ce$var$_unsupportedIterableToArray(arr, i) || $ad05972b9e5ea2ce$var$_nonIterableRest();
}
function $ad05972b9e5ea2ce$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ad05972b9e5ea2ce$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ad05972b9e5ea2ce$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ad05972b9e5ea2ce$var$_arrayLikeToArray(o, minLen);
}
function $ad05972b9e5ea2ce$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ad05972b9e5ea2ce$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $ad05972b9e5ea2ce$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ad05972b9e5ea2ce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ad05972b9e5ea2ce$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ad05972b9e5ea2ce$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ad05972b9e5ea2ce$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ad05972b9e5ea2ce$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ad05972b9e5ea2ce$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ad05972b9e5ea2ce$var$_defineProperty(obj, key, value) {
    key = $ad05972b9e5ea2ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad05972b9e5ea2ce$var$_toPropertyKey(arg) {
    var key = $ad05972b9e5ea2ce$var$_toPrimitive(arg, "string");
    return $ad05972b9e5ea2ce$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ad05972b9e5ea2ce$var$_toPrimitive(input, hint) {
    if ($ad05972b9e5ea2ce$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ad05972b9e5ea2ce$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $ad05972b9e5ea2ce$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $ad05972b9e5ea2ce$var$_classCallCheck(this, GA4);
        $ad05972b9e5ea2ce$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $ad05972b9e5ea2ce$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $ad05972b9e5ea2ce$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $ad05972b9e5ea2ce$var$_objectSpread($ad05972b9e5ea2ce$var$_objectSpread($ad05972b9e5ea2ce$var$_objectSpread({}, _this._toGtagOptions($ad05972b9e5ea2ce$var$_objectSpread($ad05972b9e5ea2ce$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $ad05972b9e5ea2ce$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $ad05972b9e5ea2ce$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($ad05972b9e5ea2ce$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $ad05972b9e5ea2ce$var$_objectSpread($ad05972b9e5ea2ce$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $ad05972b9e5ea2ce$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $ad05972b9e5ea2ce$var$_objectWithoutProperties(_args$, $ad05972b9e5ea2ce$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $ad05972b9e5ea2ce$var$_objectWithoutProperties(_this$_toGtagOptions, $ad05972b9e5ea2ce$var$_excluded2);
                _this._gtag("event", "page_view", $ad05972b9e5ea2ce$var$_objectSpread($ad05972b9e5ea2ce$var$_objectSpread($ad05972b9e5ea2ce$var$_objectSpread($ad05972b9e5ea2ce$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $ad05972b9e5ea2ce$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $ad05972b9e5ea2ce$var$_objectWithoutProperties(_args$2, $ad05972b9e5ea2ce$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $ad05972b9e5ea2ce$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $ad05972b9e5ea2ce$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $ad05972b9e5ea2ce$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $ad05972b9e5ea2ce$var$_format["default"])(category),
                    eventAction: (0, $ad05972b9e5ea2ce$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $ad05972b9e5ea2ce$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $ad05972b9e5ea2ce$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $ad05972b9e5ea2ce$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $ad05972b9e5ea2ce$var$GA4;
var $ad05972b9e5ea2ce$var$_default = new $ad05972b9e5ea2ce$var$GA4();
module.exports["default"] = $ad05972b9e5ea2ce$var$_default;

});
parcelRegister("aB6q0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $7b7256a1492a3cf0$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $7b7256a1492a3cf0$var$_default = $7b7256a1492a3cf0$var$gtag;
module.exports["default"] = $7b7256a1492a3cf0$var$_default;

});

parcelRegister("lmcwK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f8c55eb6688c7819$var$format;
var $f8c55eb6688c7819$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $f8c55eb6688c7819$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($f8c55eb6688c7819$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $f8c55eb6688c7819$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $f8c55eb6688c7819$var$redacted = "REDACTED (Potential Email Address)";
function $f8c55eb6688c7819$var$redactEmail(string) {
    if ($f8c55eb6688c7819$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $f8c55eb6688c7819$var$redacted;
    }
    return string;
}
function $f8c55eb6688c7819$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $f8c55eb6688c7819$var$toTitleCase(s);
    if (redactingEmail) _str = $f8c55eb6688c7819$var$redactEmail(_str);
    return _str;
}

});


parcelRegister("hE0KL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd86c1b111586592$export$2e2bcd8739ae039; });

var $771aI = parcelRequire("771aI");
parcelRequire("d1Z4Y");
const $cd86c1b111586592$var$Spinner = ()=>/*#__PURE__*/ (0, $771aI.jsxs)("div", {
        className: "lds-ellipsis",
        children: [
            /*#__PURE__*/ (0, $771aI.jsx)("div", {}),
            /*#__PURE__*/ (0, $771aI.jsx)("div", {}),
            /*#__PURE__*/ (0, $771aI.jsx)("div", {}),
            /*#__PURE__*/ (0, $771aI.jsx)("div", {})
        ]
    });
var $cd86c1b111586592$export$2e2bcd8739ae039 = $cd86c1b111586592$var$Spinner;

});

parcelRegister("dVPc1", function(module, exports) {

module.exports = Promise.all([
    $parcel$import("61nA2"),
    (parcelRequire("4UOQl"))($parcel$resolve("6Tn4K")),
    $parcel$import("9ApDA"),
    $parcel$import("e4VlE"),
    $parcel$import("5hTT7"),
    $parcel$import("G5Ivw")
]).then(()=>parcelRequire('dOmVd'));

});
parcelRegister("4UOQl", function(module, exports) {
"use strict";

var $9IlKE = parcelRequire("9IlKE");
module.exports = $9IlKE(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("9IlKE", function(module, exports) {
"use strict";
var $712918818f038a8b$var$cachedBundles = {};
var $712918818f038a8b$var$cachedPreloads = {};
var $712918818f038a8b$var$cachedPrefetches = {};
function $712918818f038a8b$var$getCache(type) {
    switch(type){
        case 'preload':
            return $712918818f038a8b$var$cachedPreloads;
        case 'prefetch':
            return $712918818f038a8b$var$cachedPrefetches;
        default:
            return $712918818f038a8b$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $712918818f038a8b$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("2fVrq", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("4UOQl"))($parcel$resolve("cgbUd")),
    $parcel$import("61nA2"),
    $parcel$import("9ApDA"),
    $parcel$import("e4VlE"),
    $parcel$import("5hTT7"),
    $parcel$import("6nMz4")
]).then(()=>parcelRequire('h5jVr'));

});

parcelRegister("9qbIc", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("5hTT7"),
    $parcel$import("evAE1")
]).then(()=>parcelRequire('1EgqM'));

});

parcelRegister("gXraD", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("4UOQl"))($parcel$resolve("25t6a")),
    $parcel$import("9ApDA"),
    $parcel$import("5hTT7"),
    $parcel$import("5SOnT")
]).then(()=>parcelRequire('2dAPu'));

});

parcelRegister("asi3e", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("61nA2"),
    $parcel$import("9ApDA"),
    $parcel$import("5hTT7"),
    $parcel$import("64w4P")
]).then(()=>parcelRequire('5gfGe'));

});

parcelRegister("hGFVE", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("4UOQl"))($parcel$resolve("eEmjc")),
    $parcel$import("9ApDA"),
    $parcel$import("5hTT7"),
    $parcel$import("9xCb0")
]).then(()=>parcelRequire('aK9WY'));

});

parcelRegister("jacla", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("9ApDA"),
    $parcel$import("5hTT7"),
    $parcel$import("44yEd")
]).then(()=>parcelRequire('3c5bz'));

});

parcelRegister("qNj0I", function(module, exports) {
module.exports = $parcel$import("1IaFC").then(()=>parcelRequire('5o6hW'));

});

var $72c2fa128b4b7612$exports = {};
$parcel$extendImportMap({
    "G5Ivw": "Admin.d458dda6.js",
    "cM7F2": "locked.cf5f9e76.svg",
    "7Xe5f": "close-circled.a92cf51a.svg",
    "b0dcb": "tick-circled.66d14ca7.svg",
    "5hTT7": "Admin.30ab97cd.js",
    "e4VlE": "Admin.7a27fcb1.js",
    "fdgSH": "icon--location.8aeaeff8.svg",
    "eu1Hq": "Info.d65717e7.svg",
    "9ApDA": "Admin.45db106f.js",
    "3kozF": "digital-onboarding-logo.931cc339.svg",
    "6Tn4K": "Admin.bfe1a32f.css",
    "9dlBo": "tick-white.a56f365a.svg",
    "61nA2": "Admin.0f7d5e93.js",
    "6nMz4": "UserPortal.e1be247b.js",
    "bXlkO": "AXAHealthSummary.8c037bc3.pdf",
    "51F1n": "2.7673f155.png",
    "4RTFn": "envelope.384cc470.svg",
    "emtlV": "24_062321_ThinkEmployee_DiversityCensus_ActionPlan_A4_04_04_24_6.a07cf055.pdf",
    "cgbUd": "UserPortal.b4c255d3.css",
    "cw6YY": "chat.7cd80767.svg",
    "hmHUt": "mobile.47da98c0.svg",
    "91LOl": "person.b520dae2.svg",
    "7GGfX": "person-large.40ac048c.svg",
    "6h6C6": "calendar.b9d0d78f.svg",
    "f4AsL": "calendar-large.d89f4b11.svg",
    "lcCS1": "location.a275d373.svg",
    "efFef": "location-large.00e60e99.svg",
    "W1v2K": "chat.27ea3ca0.svg",
    "9AgO6": "doc-alt.d5857731.svg",
    "9ERFt": "person.037eef6d.svg",
    "evAE1": "MagicLink.ba97d540.js",
    "5SOnT": "EmpAuth.f80d8430.js",
    "25t6a": "EmpAuth.1abd468e.css",
    "64w4P": "forgotPassword.dc93e155.js",
    "9xCb0": "UpdatePassword.6e08f72e.js",
    "eEmjc": "UpdatePassword.9b9df933.css",
    "44yEd": "PrivacyPolicy.576e8ae5.js",
    "1IaFC": "Maintenance.d88a95f0.js",
    "4wLSD": "DigitalOnboarding.ee16b8d9.svg"
});


var $771aI = parcelRequire("771aI");

var $d1Z4Y = parcelRequire("d1Z4Y");
var $5d034a63d6bc71fe$exports = {};
'use strict';
function $5d034a63d6bc71fe$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($5d034a63d6bc71fe$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$5d034a63d6bc71fe$var$checkDCE();

$5d034a63d6bc71fe$exports = (parcelRequire("03qsr"));



var $771aI = parcelRequire("771aI");

var $d1Z4Y = parcelRequire("d1Z4Y");

var $jp3Fn = parcelRequire("jp3Fn");
var $98d21678eedade00$exports = {};
"use strict";
function $98d21678eedade00$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $98d21678eedade00$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $98d21678eedade00$var$_typeof(obj);
}
Object.defineProperty($98d21678eedade00$exports, "__esModule", {
    value: true
});
$98d21678eedade00$exports["default"] = $98d21678eedade00$exports.ReactGAImplementation = void 0;

var $98d21678eedade00$var$_ga = $98d21678eedade00$var$_interopRequireWildcard((parcelRequire("eQZs6")));
function $98d21678eedade00$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($98d21678eedade00$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $98d21678eedade00$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $98d21678eedade00$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $98d21678eedade00$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $98d21678eedade00$var$ReactGAImplementation = $98d21678eedade00$var$_ga.GA4;
$98d21678eedade00$exports.ReactGAImplementation = $98d21678eedade00$var$ReactGAImplementation;
var $98d21678eedade00$var$_default = $98d21678eedade00$var$_ga["default"];
$98d21678eedade00$exports["default"] = $98d21678eedade00$var$_default;



var $hE0KL = parcelRequire("hE0KL");


const $aa831a3b70830250$var$Admin = /*#__PURE__*/ (0, $d1Z4Y.lazy)(()=>(parcelRequire("dVPc1")));

const $aa831a3b70830250$var$UserPortal = /*#__PURE__*/ (0, $d1Z4Y.lazy)(()=>(parcelRequire("2fVrq")));

const $aa831a3b70830250$var$MagicLink = /*#__PURE__*/ (0, $d1Z4Y.lazy)(()=>(parcelRequire("9qbIc")));

const $aa831a3b70830250$var$EmpAuth = /*#__PURE__*/ (0, $d1Z4Y.lazy)(()=>(parcelRequire("gXraD")));

const $aa831a3b70830250$var$ForgotPassword = /*#__PURE__*/ (0, $d1Z4Y.lazy)(()=>(parcelRequire("asi3e")));

const $aa831a3b70830250$var$UpdatePassword = /*#__PURE__*/ (0, $d1Z4Y.lazy)(()=>(parcelRequire("hGFVE")));

const $aa831a3b70830250$var$PrivacyPolicy = /*#__PURE__*/ (0, $d1Z4Y.lazy)(()=>(parcelRequire("jacla")));

const $aa831a3b70830250$var$Maintenance = /*#__PURE__*/ (0, $d1Z4Y.lazy)(()=>(parcelRequire("qNj0I")));
const $aa831a3b70830250$var$PageTracker = ()=>{
    const location = (0, $jp3Fn.useLocation)();
    (0, $d1Z4Y.useEffect)(()=>{
        window.scrollTo(0, 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($98d21678eedade00$exports))).send({
            hitType: "pageview",
            page: location.pathname + location.search
        });
    }, [
        location
    ]);
    return null;
};
const $aa831a3b70830250$export$abbfbd921ad63ddb = false;
const $aa831a3b70830250$var$App = ()=>{
    (0, $d1Z4Y.useEffect)(()=>{
        setTimeout(()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($98d21678eedade00$exports))).initialize("UA-76124910-23");
        }, 0);
    }, []);
    return /*#__PURE__*/ (0, $771aI.jsx)((0, $771aI.Fragment), {
        children: /*#__PURE__*/ (0, $771aI.jsxs)((0, $jp3Fn.BrowserRouter), {
            children: [
                /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$PageTracker, {}),
                $aa831a3b70830250$export$abbfbd921ad63ddb ? /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Routes), {
                    children: /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Route), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$Maintenance, {})
                    })
                }) : /*#__PURE__*/ (0, $771aI.jsx)((0, $d1Z4Y.Suspense), {
                    fallback: /*#__PURE__*/ (0, $771aI.jsx)((0, $hE0KL.default), {}),
                    children: /*#__PURE__*/ (0, $771aI.jsxs)((0, $jp3Fn.Routes), {
                        children: [
                            /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Route), {
                                path: "/admin/*",
                                element: /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$Admin, {})
                            }),
                            /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Route), {
                                path: "/magiclink/:token",
                                element: /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$MagicLink, {})
                            }),
                            /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Route), {
                                path: "/empauth/*",
                                element: /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$EmpAuth, {})
                            }),
                            /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Route), {
                                path: "/forgot-password",
                                element: /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$ForgotPassword, {})
                            }),
                            /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Route), {
                                path: "/update-password",
                                element: /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$UpdatePassword, {})
                            }),
                            /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Route), {
                                path: "/privacy-policy",
                                element: /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$PrivacyPolicy, {})
                            }),
                            /*#__PURE__*/ (0, $771aI.jsx)((0, $jp3Fn.Route), {
                                path: "/*",
                                element: /*#__PURE__*/ (0, $771aI.jsx)($aa831a3b70830250$var$UserPortal, {})
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $aa831a3b70830250$export$2e2bcd8739ae039 = $aa831a3b70830250$var$App;



const $1f0dc3b9307be026$var$rootElement = document.getElementById("root");
const $1f0dc3b9307be026$var$root = (0, $5d034a63d6bc71fe$exports.createRoot)($1f0dc3b9307be026$var$rootElement);
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $771aI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d1Z4Y))).StrictMode, {
    children: /*#__PURE__*/ (0, $771aI.jsx)((0, $aa831a3b70830250$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=s.2593de87.js.map
